/* eslint-disable */
/* eslint-disable sonarjs/prefer-immediate-return */
/* eslint-disable no-debugger */
/* eslint-disable sonarjs/no-identical-functions */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/prefer-single-boolean-return */
/* eslint-disable sonarjs/no-all-duplicated-branches */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable react-hooks/exhaustive-deps */

import { PrintFieldSheetModal } from "./ViewFieldSheetPopUp";  
import { FieldSheet, FieldSheetSection6Retention  } from "../../../types/types";
import { FieldSheetPreview } from "./FieldSheetPreview";
import React, { useEffect, useState, useMemo, useContext } from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  RACDatePicker,
  RACButton,
  RACSelect,
  RACTextbox,
  RACBadge,
  RACTableCell,
  List,
  ListItem,
  RACModalCard,
  RACTable,
  RACTableRow,
  Box,
  CircularProgress,
  RACToggle,
  RACRadio,
  makeStyles,
  RACCheckBox,
  RACDateTimeLabel,
} from "@rentacenter/racstrap";
import { useHistory } from "react-router-dom";
import moment from "moment";
import CustomerSignature from "../../CustomerSignarure";
import { fieldDeviceStyles } from "../../fieldDeviceStyles";
import { DapCalendarStyles } from "./DapCalendarStyles";
import { ReactComponent as Alerticon } from "../../../assets/images/No-records.svg";
import { ReactComponent as Alert } from "../../../assets/images/no-records-found.svg";
import { ReactComponent as SearchbarIcon } from "../../../assets/images/searchbarIcon.svg";
import { ReactComponent as CompletedIcon } from "../../../assets/images/wizard-complete.svg";
import { ReactComponent as Racfont } from "../../../assets/images/RAC-Banner.svg";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
import { ReactComponent as Images } from "../../../assets/images/pdf-icon.svg";
import { ReactComponent as PDFImage } from "../../../assets/images/pdf-icon.svg";
import { ReactComponent as Successimage } from "../../../assets/images/success-icon.svg";
// PS_06
import { ReactComponent as WarningIcon } from "../../../assets/images/Warning-icon.svg";
import {
  logWorkedHistory,
  GetReferenceValues,
  getDapEvent,
  updateEventStatus,
  getTimeSlot,
  EventHistory,
  getAgreementDelivery,
  getAgreementInfo,
  getnextpaymentamount,
  LoadDeliveryreceipt,
  Confirmdelivery,
  LoadswitchoutDeliveryreceipt,
  manageAppointment,
  getmenuandstore,
  Recieptsign,
  GetCustomerinfo,
  CheckSign,
  managePoAcimaFn,
  storeException,
  saveSurveyForm,
  getSavedSurvey,
  GenerateReceipt,
  GetCustomer,
  getVerificationDocuments,
  makeApiClientCall,
} from "../../../api/user";
import { customerStyles } from "./customerStyles";
import { UserStateContext } from "../../../context/user/user-contexts";
import ReprintReceiptCode from "./ReprintReceiptCode";
import { ContainerContext } from "../../../app/App";
import { CustomPropInterface } from "../../../index";
import { ReactComponent as Expandicon } from "../../../assets/images/fullscreen-mode.svg";
import { ReactComponent as InfoIcon } from "../../../assets/images/No-records.svg";
import DeliveryDigitalSign from "../../shared/DeliveryDigitalSign";
import AcimaDeliveryDigitalSign from "../../shared/AcimaDeliveryDigitalSign";
import { FeatureFlagContext } from "../../../context/featureFlagContext";
import { DashboardContext } from "../../../context/DashboardContext";
import { FieldVisitModal } from "./FieldVisitModal";
import SendReferralLink from "./SendReferralLink";
import {
  buildRewardProfilePayload,
  buildPromotionProfile,
  isRewardDetailsSuccess,
} from "./RAFUtils";
import html2pdf from "html2pdf.js";

import { appConfig } from "../../../config/app-config";
import { getRetentionOffers, featureFlags } from "../../../api/user";
import { DOCUMENT_TYPE, GRID_MOCK, LOG_ACTIVITY_ERROR_MESSAGE } from "../../../constants/constants";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles((theme: any) => ({
  w100: {
    width: "100%",
  },
  card: {
    borderRadius: "16px!important",
    boxShadow: "0 1px 4px 0 rgba(0,0,0,.074)!important",
    width: "100%",
  },
  colMD12: {
    flex: "0 0 auto",
    width: "100%",
    paddingRight: "0.75rem",
    paddingLeft: "0.75rem",
  },
  reinforcementGrid: {
    marginLeft: "1.5rem",
  },
  floatStart: {
    float: "left",
  },
  mb3: {
    marginBottom: "1rem",
  },
  formLabel: {
    marginBottom: "0.8rem !important",
    marginLeft: "0.4rem !important",
    color: "#111111",
    fontFamily: "OpenSans-semibold",
    fontSize: "14px",
  },
  accordionHeader: {
    color: "#2179FE",
    fontFamily: "OpenSans-bold",
    fontSize: "20px",
    marginBottom: "1.0rem !important",
  },
  headerLabel: {
    marginBottom: "1.0rem !important",
    color: "#111111",
    fontFamily: "OpenSans-bold",
    fontSize: "16px",
  },
  commentsField: {
    marginBottom: "1.0rem !important",
    color: "#111111",
    fontFamily: "OpenSans-bold",
    fontSize: "16px",
    marginTop: "5%",
  },
  formCheckInline: {
    display: "inline-block",
    marginRight: "1rem",
  },
  formCheck: {
    minHeight: "1.5rem",
    marginBottom: "1.0rem",
  },
  checkboxLabel: {
    fontSize: "14px",
    display: "inline-block",
    fontFamily: "OpenSans-regular",
  },
  buttonsContent: {
    float: "right",
    marginTop: "1rem",
  },
  popUpContent: {
    width: "25%",
    fontFamily: "OpenSans-semibold",
    color: "#2179FE",
  },
  tabSpace: {
    display: "inline-block",
    marginLeft: "40px",
  },
  flex: {
    display: "flex",
  },
}));
const PaddingConst = "0px 8px 0px 8px";
const Constinter = "1px solid  #545454";
const borderRadiuss = "3px";
const borderbotttom = "1px solid #545454";
const borderrr = "1px solid #DFDFDF";
const borderrbottommm = "1px dashed #545454";
const borderalone = "1px solid #545454";
enum tabList {
  CALENDAR,
  HISTORYLOG,
}

export const isDeliveryOrPickupType = (appointmentType: string): boolean => {
  return ["D", "P"].includes(appointmentType);
};

export const buildNotesListWithInstruction = (appointmentData: any): any[] => {
  const appointmentType = appointmentData?.appointmentInfo?.appointmentType || "";
  const modifiedDate = appointmentData?.appointmentInfo?.lastModifiedDate || "";
  const instructions = appointmentData?.appointmentInfo?.instructions || "";
  const notes = appointmentData?.notes || [];
  const trimmed = instructions?.trim();

  if (isDeliveryOrPickupType(appointmentType) && trimmed) {
    const instructionNote = {
      appointmentNoteId: appointmentData?.appointmentInfo?.appointmentId || "",
      lastModifiedBy: appointmentData?.appointmentInfo?.lastModifiedBy || "",
      lastModifiedDate: modifiedDate,
      noteContent: trimmed,
      isInstructionNote: true,
    };
    return [instructionNote, ...notes];
  }
  return notes;
};

function Calender(props: any) {
  const { t, i18n } = useTranslation("task");
  const {dateTimeLocalization, countryIdentification, EnableRAFSurvey } = useContext(FeatureFlagContext)
  const customerSurveyClasses = useClasses();
  const classes1 = fieldDeviceStyles();
  const containerData = useContext(ContainerContext) as CustomPropInterface;
  let UserStateContextRes: any;
  UserStateContextRes = useContext(UserStateContext);
  UserStateContextRes = UserStateContextRes?.user?.permissions?.NAV_MENU;
  const history = useHistory();
  const [mandatoryPopup, setMandatoryPopup] = useState<boolean>(false);

  // PS_09
  const {
    fieldDeviceParamKey,
    pilotStoreParamKey,
    upcomingDapParamKey,
    customerSurveyParamKey,
    customerVerification,
    MXStoreIdentifier,
    addressVerificationSurveyParamKey,
    enableDocumentsCheck
  } = useContext(FeatureFlagContext);
  const customerStyleClasses = customerStyles();
  const [acimaDeliveryDigitalsignEnbale, setacimaDeliveryDigitalsignEnbale] =
    useState(false);
  const [acimaManulaSign, setacimaManulaSign] = useState(false);
  const [isManual, setisManaul] = useState(false);
  const [openFieldVisitModal, setOpenFieldVisitModal] = useState(false);
  const [isSignedByCustomer, setisSignedByCustomer] = useState(false);
  const [acimaEventValues, setacimaEventValues] = useState({
    poNumber: "",
    addressLine1: "",
    addressLine2: "",
    state: "",
    city: "",
    zip: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    appointmentStatus: "",
    itemInformation: [],
    appointmentId: "",
    appiontmnetDate: "",
    appiontmnetTime: "",
    emailId: "",
  });
  // const [activetab, setactivetab] = useState<tabList | undefined>(
  //     tabList.HISTORYLOG
  // );
  const [activetab, setactivetab] = useState({
    instructions: true,
    notes: false,
    history: false,
  });
  const classes: any = DapCalendarStyles();
  const options = {
    advancedFilter: [
      { label: t("All"), value: "0" },
      { label: t("Events"), value: "1" },
      //  { label: 'Tasks', value: "2" }
    ],
  };
  
  const [category, setCategory] = useState<any>();
  const [dateDap, setDateDap] = useState<any>({
    Date: moment().format("YYYY-MM-DD"),
  });
  const [digitalSignEnable, setdigitalSignEnable] = useState(false);
  const [eventType, setEventType] = useState<any>("ALL");
  const [documentName, setDocumentName] = useState("");
  const [storeEventNotes, setStoreEventNotes] = useState<any>("");
  const [manualSignatureEnabled, setmanualSignatureEnabled] = useState(false);
  const [cancelEventPopup, setcancelEventPopup] = useState(false);
  const [acimaEventDetails, setacimaEventDetails] = useState(false);
  const [cancelPOReason, setcancelPOReason] = useState("");
  const [agreementValues, setagreementValues] = useState({
    agreementSign: "",
    agreementNumber: "",
    agreementId: "",
  });
  const { actionEvent, customerPromotionProfile, setCustomerPromotionProfile } = useContext(DashboardContext);
  const [Opendeliveryconfirmpopup, SetOpendeliveryconfirmpopup] =
    useState(false);
  const [appiontmentId, setappiontmentId] = useState("");
  const [agrDelStatus, setagrDelStatus] = useState("");
  const [deliveryerrorpopup, setdeliveryerrorpopup] = useState(false);
  const [eventLenght, seteventLenght] = useState<any>();
  const [CheckforSign, SetCheckforSign] = useState(false);
  const [agreementInfoResponse, setAgreementInfoResponse] = useState("");
  const [manualSignature, setmanualSignature] = useState(false);
  const [maualSignReasonDrpdwnVal, setmaualSignReasonDrpdwnVal] = useState([
    {
      value: "",
      label: t("Select"),
    },
    {
      value: "3",
      label: t("Technology issue - Digital Signing"),
    },
    {
      value: "2",
      label: t("Technology issue - Customer"),
    },
    {
      value: "1",
      label: t("Customer requires Paper Signature"),
    },
  ]);
  // Feature flag for View Field Sheet button
  const [enableFieldVisitStrategy, setEnableFieldVisitStrategy] = useState(false);
  // Feature flag for FVS Retention
  const [isFVSRetentionEnabled, setIsFVSRetentionEnabled] = useState(false);

  useEffect(() => {
    // Fetch EnableFieldVisitStrategy and FVSRETENTION from config
    const fetchFeatureFlag = async () => {
      const storeNumber = window.sessionStorage.getItem("storeNumber");
      const bodyobject = {
        storeNumbers: [storeNumber],
        paramKeyNames: ["EnableFieldVisitStrategy", "FVSRETENTION"],
      };
      try {
        const configDetails = await featureFlags(bodyobject);
        const configList = configDetails?.data?.storeProfileResponse?.configDetails[0]?.configDetails || [];
        
        const enableFVS = configList.find(
          (el) => el.paramKeyName === "EnableFieldVisitStrategy"
        )?.paramValue;
        setEnableFieldVisitStrategy(enableFVS === "1");
        
        const fvsRetention = configList.find(
          (el) => el.paramKeyName === "FVSRETENTION"
        )?.paramValue;
        setIsFVSRetentionEnabled(fvsRetention === "1");
      } catch (e) {
        setEnableFieldVisitStrategy(false);
        setIsFVSRetentionEnabled(false);
      }
    };
    fetchFeatureFlag();
  }, []);

  const dynamicClasses: any = {
    complete: {
      anchor: classes.smartWizardListLinkActive,
      spanNum: `${classes.borderDefault} ${classes.done}`,
      spanDetail: classes.stepDone,
    },
    inprogress: {
      anchor: classes.smartWizardListLinkInActive,
      spanNum: classes.borderActive,
      spanDetail: classes.stepActive,
    },
    pending: {
      anchor: classes.smartWizardListLinkInActive,
      spanNum: classes.borderDefault,
      spanDetail: classes.stepNotStarted,
    },
  };
  const {
    storeEventDD,
    assigneeEventDD,
    assignee,
    setassignee,
    store,
    setStore,
    isLoading
  } = props;
  //state variables

  const [reprintPopUp, setReprintPopUp] = useState<any>();

  const [status, setStatus] = useState<any>();
  const [createEvent, setCreateEvent] = useState(true);
  const [enableDeliveryPopup, setEnableDeliveryPopup] = useState<any>();
  const [enableStorePickupPopup, setEnableStorePickupPopup] = useState<any>();
  const [enableFieldVisitPopup, setEnableFieldVisitPopup] = useState<any>();
  const [serviceErrorMsg, setServiceErrorMsg] = useState<string>("");
  const [errorMessagePopupOpen, seterrorMessagePopupOpen] =
    useState<boolean>(false);
  const [customerSignEnabled, setcustomerSignEnabled] = useState(false);
  const [popUpValues, setPopUpValues] = useState<any>();
  const [appointmentDetails, setAppointmentDetails] = useState<any>([]);
  const [appointmentDetailsForExpand, setAppointmentDetailsForExpand] =
    useState<any>([]);
  const [modals, setModals] = useState<any>({
    storeEventDetailModal: false,
    cancelEventReaspnModal: false,
    timeSlotExceedModal: false,
    apiErrorInfoMsg: false,
    reopenConfirmModal: false,
    completeConfirmModal: false,
    initialLoad: false,
    expandIconClicked: false,
  });
  const [customersArray, setcustomersArray]: any = useState([]);
  const [currentappointmentDetails, setCurrentappointmentDetails] =
    useState<any>();
  const [filterStateData, setFilterStateData] = useState<any>({
    date: moment().format("YYYY-MM-DD"),
    category: "",
    typesOfEvent: "",
    searchBarData: "",
    filterRecords: [],
    timeSlotDate: "",
  });
  const [eventDD, setEventDD] = useState<any>([
    { label: t("ALL"), value: "ALL" },
  ]);
  const [loader, setloader] = useState(false);
  const [isStoreClosed, setIsStoreClosed] = useState(false);
  const [appointmentHistoryRecord, setAppointmentHistoryRecord] = useState<any>(
    []
  );
  const [storename, Setstorename] = useState("");
  const [storecity, Setstorecity] = useState("");
  const [StoreAddressline1, SetStoreAddressline1] = useState("");
  const [StoreAddressline2, SetStoreAdressline2] = useState("");
  const [Storephonenum, SetStorephonenum] = useState("");
  const [CustomerName, SetCustomerName] = useState("");
  const [CustomerAddressline1, SetCustomerAddressline1] = useState("");
  const [CustomerAddressline2, SetCustomerAddressline2] = useState("");
  const [CustomerPhoneNumber, SetCustomerPhoneNumber] = useState("");
  const [customercity, Setcustomercity] = useState("");
  const [disableSubmitButton, setdisableSubmitButton] = useState(false);
  const [customerstate, SetCustomerstate] = useState("");
  const [customerzip, Setcustomerzip] = useState("");
  const [customerplus4, Setcustomerplus4] = useState("");
  const [storezip, Setstorezip] = useState("");
  const nextpaymentobj = {
    nextamountdue: "",
    nextduedate: "",
  };
  const [nextpaymentinfo, setnextpaymentinfo] = useState(nextpaymentobj);
  const [inventorydescswitchin, setinventorydescswitchin] = useState("");
  const [inventoryserialnumswitchin, setinventoryserialnumswithchin] =
    useState("");
  const [inventorynumberswitchinitem, setinventorynumberswitchinitem] =
    useState("");
  const [itemdata, setitemdata] = useState([]);
  const [DeliveryDate, setDeliveryDate] = useState<any>("");
  const [DeliveryTime, setDeliveryTime] = useState<any>("");
  const [isCustomerorderenabled, setisCustomerorderenabled] = useState(false);
  const [openCOprintpopup, setopenCOprintpopup] = useState(false);
  const [Openprintpopup, SetOpenprintpopup] = useState(false);
  const [disableconfirmdelivery, Setdisableconfirmdelivery] = useState(true);
  const [isReprintCompleted, setIsReprintCompleted] = useState(false);
  const [printswitchoutpopup, setprintswitchoutpopup] = useState(false);
  const [cancelEventReason, setCancelEventReason] = useState<any>("");
  const [updatingNotesLoader, setUpdatingNotesLoader] = useState<any>(false);
  const [EmpolyeeId, setEmpolyeeId] = useState("");
  const [isManualAgreementSigned, setisManualAgreementSigned] = useState(false);
  const [timeSlotExceedRecordsDetails, setTimeSlotExceedRecordsDetails] =
    useState<any>({ timeSlot: "", appointmentDetails: [] });
  const [toShowCustomerSurveyForm, setToShowCustomerSurveyForm] =
    useState(false);
  const [toShowAddressSurveyForm, setToShowAddressSurveyForm] = useState(false);
  const [toShowAddressSurvey, setToShowAddressSurvey] = React.useState(false);
  const [readOnlyAddressSurvey, setReadOnlyAddressSurvey] =
    React.useState(false);
  const [showSendReferralLinkPopup, setShowSendReferralLinkPopup] = useState(false);
  const [referralLinkSentSuccess, setReferralLinkSentSuccess] = useState(false);
  const [referralLinkError, setReferralLinkError] = useState(false);
  const [referralLinkErrorMessage, setReferralLinkErrorMessage] = useState('');
  const [rewardProfileLoading, setRewardProfileLoading] = useState(false);
  const [rewardProfileSuccess, setRewardProfileSuccess] = useState(false);
  const [carInstructions, setCarInstructions] = useState("");

  const language = window.sessionStorage.getItem('language')
  interface Address {
  addressLine1: string;
  exteriorNumber?: string;
  interiorNumber?: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  
}
const [mxCustomerAddress, setMxCustomerAddress] = useState<Address | null>(null);

  const [surveyDetails, setSurveyDetails] = useState({
    readOnlyMode: false,
    productDeliveryQn: "",
    rentalAgrQn: "",
    renewalDateAndAmtQn: false,
    autoEnrollQn: false,
    timelyPayments: false,
    referFriendProgram: "",
    referSomeone: "",
    anyOtherQns: "",
    additionalNotes: "",
  });

  interface AddressVerificationSurveyDetails {
    isResident: string;
    riskAssessmentFound: string;
    utilitiesAvailability: string;
    neighborConcern: string;
    additionalNotes: string;
    readOnlyMode: boolean;
  }

  const [
    addressVerificationSurveyDetails,
    setAddressVerificationSurveyDetails,
  ] = useState<AddressVerificationSurveyDetails>({
    isResident: "",
    riskAssessmentFound: "",
    utilitiesAvailability: "",
    neighborConcern: "",
    additionalNotes: "",
    readOnlyMode: false,
  });

  const [SurveySave, setSurveySave] = React.useState(true);
  const [AddressSurveySave, setAddressSurveySave] = React.useState(true);

  useEffect(() => {
    // Check if required fields are filled
    const isProductDeliveryEmpty = surveyDetails.productDeliveryQn.length == 0;
    const isRentalAgrEmpty = surveyDetails.rentalAgrQn.length == 0;
    
    // RAF fields are only required if EnableRAFSurvey is turned on
    const isReferFriendProgramEmpty = EnableRAFSurvey == "1" && surveyDetails.referFriendProgram.length == 0;
    const isReferSomeoneEmpty = EnableRAFSurvey == "1" && surveyDetails.referSomeone.length == 0;
    
    // Check if user selected "Yes" for referSomeone but hasn't sent the referral link (only if RAF is enabled)
    const isReferralLinkRequired = EnableRAFSurvey == "1" && surveyDetails.referSomeone === "yes" && !referralLinkSentSuccess;

    if (
      isProductDeliveryEmpty ||
      isRentalAgrEmpty ||
      isReferFriendProgramEmpty ||
      isReferSomeoneEmpty ||
      isReferralLinkRequired
    ) {
      setSurveySave(true);
    } else {
      setSurveySave(false);
    }
  }, [surveyDetails, referralLinkSentSuccess, EnableRAFSurvey]);

  useEffect(() => {
    const {
      isResident,
      riskAssessmentFound,
      utilitiesAvailability,
      neighborConcern,
    } = addressVerificationSurveyDetails;

    const allFieldsFilled = [
      isResident,
      riskAssessmentFound,
      utilitiesAvailability,
      neighborConcern,
    ].every((field) => field.trim() !== "");

    if (allFieldsFilled) {
      setAddressSurveySave(false);
    } else {
      setAddressSurveySave(true);
    }
  }, [addressVerificationSurveyDetails]);

  useEffect(() => {
    const getRetentionOffers = async () => {
      await displayRetentionOffers();
    };
    getRetentionOffers();
  }, [currentappointmentDetails?.agreement?.agreementNumber]);

  const [OpenSurveySaveSuccessPopup, setOpenSurveySaveSuccessPopup] =
    useState(false);
  const [surveyError, setSurveyError] = useState(false);

  const [toShowSurvey, setToShowSurvey] = useState(false);

  const [readOnlySurvey, setReadOnlySurvey] = React.useState(false);

  const [offers, setOffers] = useState<any | null>(null);
  const [fieldVisitPhase2, setFieldVisitPhase2] = useState(false);
  const [timeSlot, setTimeSlot] = useState([]);

  const handleFieldVisitComplete = () => {
    if (fieldVisitPhase2) {
      handleShowFieldVisitNotes();
    } else {
      setModals({ ...modals, completeConfirmModal: true });
    }
  };

  const handleShowFieldVisitNotes = () => {
    setEnableFieldVisitPopup(false);
    setOpenFieldVisitModal(true);
  };

  const handleFieldVisitSaveSuccess = () => {
    setOpenFieldVisitModal(false);

    // now do the complete of the appointment
    setModals({ ...modals, completeConfirmModal: true });
  };

  const handleFieldVisitError = () => {
    setOpenFieldVisitModal(false);
    setServiceErrorMsg(LOG_ACTIVITY_ERROR_MESSAGE);
    seterrorMessagePopupOpen(true);
  };

  const resetSurvey = () => {
    setSurveyDetails({
      ...surveyDetails,
      readOnlyMode: false,
      productDeliveryQn: "",
      rentalAgrQn: "",
      renewalDateAndAmtQn: false,
      autoEnrollQn: false,
      timelyPayments: false,
      referFriendProgram: "",
      referSomeone: "",
      anyOtherQns: "",
      additionalNotes: "",
    });
  };

  const resetAddressSurvey = () => {
    setAddressVerificationSurveyDetails({
      ...addressVerificationSurveyDetails,
      isResident: "",
      riskAssessmentFound: "",
      utilitiesAvailability: "",
      neighborConcern: "",
      readOnlyMode: false,
      additionalNotes: "",
    });
  };

  const displayRetentionOffers = async () => {
    const agm = currentappointmentDetails?.agreement?.agreementNumber;
    if (agm && (await isRetentionOnForStore())) {
      const offers = await retentionOffersResult([agm]);
      setOffers(offers);
    }
  };

  const isRetentionOnForStore = async (): Promise<boolean> => {
    let out = false;
    const bodyobj = {
      storeNumbers: [window.sessionStorage.getItem("storeNumber")],
      paramKeyNames: ["CustomerRetention"],
    };
    const featureFlag = await featureFlags(bodyobj);

    const reten =
      featureFlag.data.storeProfileResponse.configDetails[0].configDetails.filter(
        (el: any) => el.paramKeyName == "CustomerRetention"
      )[0].paramValue;
    if (reten === "1") {
      out = true;
    }

    return out;
  };

  const isFieldPhase2OnForStore = async (): Promise<boolean> => {
    let out = false;
    try {
      const bodyobj = {
        storeNumbers: [window.sessionStorage.getItem("storeNumber")],
        paramKeyNames: ["PriorityFieldVisitPhase2"],
      };
      const featureFlag = await featureFlags(bodyobj);

      const reten =
        featureFlag.data.storeProfileResponse.configDetails[0].configDetails.filter(
          (el: any) => el.paramKeyName == "PriorityFieldVisitPhase2"
        )[0].paramValue;
      if (reten === "1") {
        out = true;
      }
    } catch (eee: any) {
      console.log(eee);
    }

    return out;
  };

  const retentionOffersResult = async (agms: string[]): Promise<any> => {
    const out = await getRetentionOffers({
      agreementNumbers: agms,
    });

    let filteredOffers = out?.data?.agreementOffers?.[0];

    if (out?.data?.agreementOffers?.length > 1) {
      filteredOffers = out?.data?.agreementOffers?.reduce(
        (latest: any, curr: any) => {
          const date1 = new Date(curr.updateDateTime);
          const date2 = new Date(latest.updateDateTime);

          if (
            !isNaN(date1.getTime()) &&
            !isNaN(date2.getTime()) &&
            date1 > date2
          ) {
            return curr;
          }

          return latest;
        },
        out?.data?.agreementOffers[0]
      );
    }

    if (filteredOffers) {
      return (
        <>
          <div>
            <Typography style={{ display: "inline-block" }}>
              {filteredOffers.epoOfferDescription}
            </Typography>
          </div>
          <div>
            <Typography style={{ display: "inline-block" }}>
              {filteredOffers.rateOfferDescription}
            </Typography>
          </div>
          <div>
            <Typography style={{ display: "inline-block" }}>
              {filteredOffers.extensionOfferDescription}
            </Typography>
          </div>
          <div>
            <Typography style={{ display: "inline-block" }}>
              {filteredOffers.termOfferReduction}
            </Typography>
          </div>
        </>
      );
    } else {
      return <></>;
    }
  };

  const getCustomerRewardDetails = async (customerInfo: any) => {
    setRewardProfileLoading(true);
    setRewardProfileSuccess(false);
    try {
      const storeNumber = window.sessionStorage.getItem("storeNumber");
      const payload = buildRewardProfilePayload(customerInfo, storeNumber);

      const rewardDetails = await makeApiClientCall({
        url: 'customer/rewards',
        method: 'POST',
        payload: { rewardProfile: payload },
        baseUrl: appConfig.apiUrls.customer,
      });
      console.log("RAF - rewardDetails", rewardDetails);

      if (isRewardDetailsSuccess(rewardDetails)) {
        const promotionProfile = buildPromotionProfile(rewardDetails, GRID_MOCK);
        setCustomerPromotionProfile([promotionProfile]);
        setRewardProfileSuccess(true);
        console.log("RAF - Customer Promotion Profile set:", promotionProfile);
      } else {
        console.log('Reward profile API returned non-success status');
        setRewardProfileSuccess(false);
      }
    } catch (error) {
      console.log("Error fetching customer reward details:", error);
      setRewardProfileSuccess(false);
    } finally {
      setRewardProfileLoading(false);
    }
  };

  const initializeSurvey = (response: any) => {
    setReadOnlySurvey(true);

    setSurveyDetails({
      ...surveyDetails,
      readOnlyMode: true,
      productDeliveryQn:
        response.deliveryOnTime && response.deliveryOnTime == "1"
          ? "yes"
          : "no",
      rentalAgrQn:
        response.questionsAnswered && response.questionsAnswered == "1"
          ? "yes"
          : "no",
      renewalDateAndAmtQn:
        response.renewalDiscussed && response.renewalDiscussed == "1"
          ? true
          : false,
      autoEnrollQn:
        response.autopayDiscussed && response.autopayDiscussed == "1"
          ? true
          : false,
      timelyPayments:
        response.paymentDiscussed && response.paymentDiscussed == "1"
          ? true
          : false,
      referFriendProgram:
        response.referralProgram && response.referralProgram == "1"
          ? "yes"
          : response.referralProgram == "0"
          ? "no"
          : "",
      anyOtherQns:
        response.otherQuestions && response.otherQuestions == "1"
          ? "yes"
          : "no",
      additionalNotes: response.notes ? response.notes : "",
    });
  };

  const initializeAddressSurvey = (response: any) => {
    setReadOnlyAddressSurvey(true);
    console.log(response, "getsurvey");
    setAddressVerificationSurveyDetails({
      ...addressVerificationSurveyDetails,
      readOnlyMode: true,
      isResident:
        response.isResident && response.isResident == "1" ? "yes" : "no",
      riskAssessmentFound:
        response.riskAssessmentFound && response.riskAssessmentFound == "1"
          ? "yes"
          : "no",
      utilitiesAvailability:
        response.basicUtilitiesAvailability &&
        response.basicUtilitiesAvailability == "1"
          ? "yes"
          : "no",
      neighborConcern:
        response.negativeNeighborFeedback &&
        response.negativeNeighborFeedback == "1"
          ? "yes"
          : "no",

      additionalNotes: response.notes ? response.notes : "",
    });
  };

  const [eligibleRole, setEligibleRole] = useState(false);
  const { updateRecieptKey, setUpdateRecieptKey } =
    useContext(FeatureFlagContext);
  const propData: any = {
    DeliveryDate,
    DeliveryTime,
    itemdata,
    storename,
    StoreAddressline2,
    StoreAddressline1,
    storecity,
    storezip,
    Storephonenum,
    CustomerName,
    CustomerAddressline2,
    CustomerAddressline1,
    customerplus4,
    customercity,
    customerzip,
    CustomerPhoneNumber,
    currentappointmentDetails,
    nextpaymentinfo,
    inventorydescswitchin,
    inventoryserialnumswitchin,
    inventorynumberswitchinitem,
    agreementInfoResponse,
  };

  const memoizedPropData = useMemo(
    () => propData,
    [
      propData.DeliveryDate,
      propData.DeliveryTime,
      propData.itemdata,
      propData.storename,
      propData.StoreAddressline2,
      propData.StoreAddressline1,
      propData.storecity,
      propData.storezip,
      propData.Storephonenum,
      propData.CustomerName,
      propData.CustomerAddressline2,
      propData.CustomerAddressline1,
      propData.customerplus4,
      propData.customercity,
      propData.customerzip,
      propData.CustomerPhoneNumber,
      propData.currentappointmentDetails,
      propData.nextpaymentinfo,
      propData.inventorydescswitchin,
      propData.inventoryserialnumswitchin,
      propData.inventorynumberswitchinitem,
      propData.agreementInfoResponse,
    ]
  );
  //functions
  useEffect(() => {
    pageLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    getWorkerRole();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    console.log("WindowSize", window.innerWidth);
    windowSizeFn();
  }, []);
  useEffect(() => {
    isFieldPhase2OnForStore().then((response: boolean) =>
      setFieldVisitPhase2(response)
    );
  }, []);

  const windowSizeFn = async () => {
    if (window.innerWidth <= 1280) {
      seteventLenght(2);
    } else {
      seteventLenght(4);
    }
  };
  useEffect(() => {
    console.log("UserStateContextRes", UserStateContextRes);
  }, [UserStateContextRes]);
  useEffect(() => {
    console.log("Calender action event");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    handleDSS(actionEvent);
  }, [actionEvent]);

  const handleDSS = async (sa: any) => {
    if (!actionEvent) return;
    setCurrentappointmentDetails(actionEvent);
    showCustomerSurveyForm();
  };
  const filteroutEvent = (item: any) => {
    if (!item || !item.appointmentInfo) return false;
    if (item.appointmentInfo.appointmentStatus == "DEL") return false;
    if (item.appointmentInfo.bestFit && item.appointmentInfo.bestFit == "1")
      return false;
    return true;
  };
  const filterBestFit = (item: any) => {
    if (!item || !item.appointmentInfo) return false;
    if (item.appointmentInfo.appointmentStatus == "DEL") return false;
    if (item.appointmentInfo.bestFit && item.appointmentInfo.bestFit == "1")
      return true;
    return false;
  };
  const pageLoad = async (date?: any, status?: any) => {
    try {
      // startDate: '2023-05-17', endDate: '2023-05-17' 04744 00535
      const payload: any = {
        storeNumber: window.sessionStorage.getItem("storeNumber"),
        appointmentTypes: [
          "CI",
          "CO",
          "D",
          "P",
          "S",
          "SCI",
          "SCO",
          "SD",
          "SO",
          "SP",
          "BE",
          "SE",
          "AD",
          "STOPIC",
          "FIELD",
        ],
        startDate: date || filterStateData.date,
        endDate: date || filterStateData.date,
      };
      const payloadForGetTimeSlot = {
        isLoaner: "Y",
        customerId: "108348922",
        endDate: date || filterStateData.date,
        eventSource: "STO",
        startDate: date || filterStateData.date,
        storeId: sessionStorage.getItem("storeNumber"),
      };
      // setloader(true)
      setModals((prevModals: any) => ({
        ...prevModals,
        initialLoad: true,
      }));
      // setModals({ ...modals, initialLoad: true,storeEventDetailModal: false, cancelEventReaspnModal: false, timeSlotExceedModal: false, apiErrorInfoMsg: false, reopenConfirmModal: false, completeConfirmModal: false, expandIconClicked: false })
      const apiCallStack: any = [getDapEvent(payload)];
      if (!date && !status) {
        apiCallStack.push(GetReferenceValues("appointment_type"));
        apiCallStack.push(getTimeSlot(payloadForGetTimeSlot));
      }
      if (date) {
        apiCallStack.push(getTimeSlot(payloadForGetTimeSlot));
      }
      const response: any = await Promise.all(apiCallStack);
      let bestFitEvents: any = [];
      console.log("apiCallStack response", response);
      // setloader(falses)
      setModals((prevModals: any) => ({
        ...prevModals,
        initialLoad: false,
      }));
      // const buildData = new Map()
      const buildDataCopy = new Map();

      const curDate = date || filterStateData.date;
      let timeSlotResponse: any = [];
      if (!date && !status) {
        bindDDHandler(response[1]);
        timeSlotResponse = response[2].data.timeSlots[curDate];
        setTimeSlot(timeSlotResponse);
        setFilterStateData({
          ...filterStateData,
          timeSlotDate: response[2].data.timeSlots[curDate],
        });
      }
      if (date) {
        timeSlotResponse = response[1].data.timeSlots[curDate];
      }
      if (timeSlotResponse && timeSlotResponse.length == 0) {
        setIsStoreClosed(true);
        return;
      }
      if (
        (response[0].data &&
          response[0].data.appointments &&
          response[0].data.appointments.length > 0) ||
        timeSlotResponse?.length > 0
      ) {
        console.log(
          "inside if condition to check the appointment",
          response,
          timeSlotResponse
        );
        let appointmentRespone: any = [];
        if (response[0].data && response[0].data?.appointments) {
          appointmentRespone = response[0].data?.appointments;
        }
        // appointmentRespone = appointmentRespone && appointmentRespone.length > 0 ? appointmentRespone.filter((el: any) => el.appointmentInfo && el.appointmentInfo.appointmentStatus !== 'DEL') : []
        bestFitEvents =
          appointmentRespone && appointmentRespone?.length > 0
            ? appointmentRespone?.filter(filterBestFit)
            : [];
        appointmentRespone =
          appointmentRespone && appointmentRespone?.length > 0
            ? appointmentRespone?.filter(filteroutEvent)
            : [];
        timeSlotResponse &&
          timeSlotResponse?.forEach((el: any) => {
            appointmentRespone.push({ timeSlotInfo: el });
          });
        appointmentRespone.push({
          timeSlotInfo: {
            timeSlot: "12P",
            startTime: "12:00:00",
            endTime: "13:00:00",
            status: "BREAK",
          },
        });
        const sortedRecord = appointmentRespone.sort(compareStartTime);

        sortedRecord.forEach((el: any) => {
          const startTime: any = moment(
            el.timeSlotInfo.startTime,
            "HH:mm:ss"
          ).format("hh:mm");
          const endTime: any = moment(
            el.timeSlotInfo.endTime,
            "HH:mm:ss"
          ).format("hh:mm");
          const keyName = startTime + "-" + endTime;
          if (buildDataCopy.has(keyName)) {
            if (el.appointmentInfo) {
              const data = buildDataCopy.get(keyName);
              data.push(el);
              buildDataCopy.set(keyName, data);
            }
          } else {
            buildDataCopy.set(keyName, [el]);
          }
        });
      }

      if (bestFitEvents.length == 0) {
        bestFitEvents.push({
          timeSlotInfo: {
            timeSlot: "BestFit",
            startTime: "08:00:00",
            endTime: "17:00:00",
          },
        });
      }
      buildDataCopy.set("bestFit", bestFitEvents);

      const originData: any = [];
      buildDataCopy.forEach((el: any, i: any, val: any) => {
        if (
          originData?.length < 3 &&
          (moment().isBetween(
            el[0]?.timeSlotInfo?.startTimeStamp,
            el[0]?.timeSlotInfo?.endTimeStamp
          ) ||
            moment().isBefore(el[0]?.timeSlotInfo?.startTimeStamp) ||
            el[0]?.appointmentInfo?.bestFit == "1")
        ) {
          if (el[0]?.appointmentInfo != undefined) {
            originData.push(el);
          }
        }
      });
      setAppointmentDetailsForExpand([...buildDataCopy.values()]);

      setAppointmentDetails(originData);
      setCancelEventReason("");

      // AppointmentResponse.appointments.map((el:any) => {
      //     const storeInd = initialArray.findIndex((a) => a.timeSlot.startTime == el.timeSlotInfo.startTime)
      //     console.log(" a.timeSlotInfo.startTime ", el.timeSlotInfo.startTime)
      //     console.log("storeInd", storeInd)
      //     if (storeInd >= 0) {
      //         const type = el.appointmentInfo.appointmentTypeDesc;
      //         const custumInfo = el.customerInfo;
      //         const agreementInfo = el.agreement;
      //         // const timeSlotInfo = el.timeSlotInfo;
      //         const inventories = el.invntories;
      //         //type
      //         const types = [...initialArray[storeInd].type, type];
      //         initialArray[storeInd].type = types;
      //         // custumInfo
      //         const custumInfoDetails = [...initialArray[storeInd].custumInfo, custumInfo];
      //         initialArray[storeInd].custumInfo = custumInfoDetails;
      //         // agreementInfo
      //         const agreementInfoDetails = [...initialArray[storeInd].agreementInfo, agreementInfo];
      //         initialArray[storeInd].agreementInfo = agreementInfoDetails;
      //         // //timeSlotInfo
      //         // const timeSlotInfoDetails = [...initialArray[storeInd].timeSlotInfo, timeSlotInfo];
      //         // initialArray[storeInd].timeSlotInfo = timeSlotInfoDetails;
      //         //inventories
      //         const inventoryDetails = [...initialArray[storeInd].inventories, inventories];
      //         initialArray[storeInd].inventories = inventoryDetails;
      //     }
      //     else {
      //         const formedOBJ = {
      //             timeSlot: el.timeSlotInfo,
      //             custumInfo: [el.customerInfo],
      //             agreementInfo: [el.agreement],
      //             inventories: [el.invntories],
      //             type: [el.appointmentInfo.appointmentTypeDesc]
      //         }
      //         initialArray.push(formedOBJ)
      //     }
      //     console.log("initialArray", initialArray)
      //     setAppointmentDetails({
      //         ...appointmentDetails,
      //         OriginalAppointmentDetails: initialArray,
      //         AlteredAppointmentDetails: initialArray
      //     })
      // });
    } catch (e) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
      console.log(e);
    }
  };

  const getWorkerRole = async () => {
    let role = "";
    if (containerData !== undefined) {
      role = containerData.GetRole();
    } else {
      const roleDetailsObj: any = await getmenuandstore();
      role = roleDetailsObj?.data?.coworkerProfile?.role;
    }
    if (role !== "CAR") {
      setEligibleRole(true);
    }
  };

  useEffect(() => {
    getDapEventWithAssginee();
  }, [assignee, store]);
  
  const getDapEventWithAssginee = async () => {
    try {
      const payload: any = {
     storeNumber :
     store === "" ? undefined :
     store === null || store === undefined 
      ? window.sessionStorage.getItem("storeNumber")
      : store,
      appointmentTypes: [
          "CI",
          "CO",
          "D",
          "P",
          "S",
          "SCI",
          "SCO",
          "SD",
          "SO",
          "SP",
          "BE",
          "SE",
          "AD",
          "STOPIC",
          "FIELD",
        ],
        startDate: filterStateData.date,
        endDate: filterStateData.date,
      assignee:  assignee === ""
      ? assigneeEventDD
          .filter((item) => item.value !== "") // exclude "ALL"
          .map((item) => item.value)           // get all employee IDs
      : [assignee] // wrap string as array
      };
      setModals((prevModals: any) => ({
        ...prevModals,
        initialLoad: true,
      }));
      let bestFitEvents: any = [];
      const buildDataCopy = new Map();
      const response = await getDapEvent(payload);
      if (
        (response.data &&
          response.data?.appointments &&
          response.data?.appointments?.length > 0) ||
        (timeSlot && timeSlot.length > 0)
      ) {
        let appointmentRespone: any = [];
        if (response.data && response.data?.appointments) {
          appointmentRespone = response.data?.appointments;
        }
        // appointmentRespone = appointmentRespone && appointmentRespone.length > 0 ? appointmentRespone.filter((el: any) => el.appointmentInfo && el.appointmentInfo.appointmentStatus !== 'DEL') : []
        bestFitEvents =
          appointmentRespone && appointmentRespone?.length > 0
            ? appointmentRespone?.filter(filterBestFit)
            : [];
        appointmentRespone =
          appointmentRespone && appointmentRespone?.length > 0
            ? appointmentRespone?.filter(filteroutEvent)
            : [];
        timeSlot &&
          timeSlot?.forEach((el: any) => {
            appointmentRespone.push({ timeSlotInfo: el });
          });
        appointmentRespone.push({
          timeSlotInfo: {
            timeSlot: "12P",
            startTime: "12:00:00",
            endTime: "13:00:00",
            status: "BREAK",
          },
        });
        const sortedRecord = appointmentRespone.sort(compareStartTime);

        sortedRecord.forEach((el: any) => {
          const startTime: any = moment(
            el.timeSlotInfo.startTime,
            "HH:mm:ss"
          ).format("hh:mm");
          const endTime: any = moment(
            el.timeSlotInfo.endTime,
            "HH:mm:ss"
          ).format("hh:mm");
          const keyName = startTime + "-" + endTime;
          if (buildDataCopy.has(keyName)) {
            if (el.appointmentInfo) {
              const data = buildDataCopy.get(keyName);
              data.push(el);
              buildDataCopy.set(keyName, data);
            }
          } else {
            buildDataCopy.set(keyName, [el]);
          }
        });
      }
      if (bestFitEvents.length == 0) {
        bestFitEvents.push({
          timeSlotInfo: {
            timeSlot: "BestFit",
            startTime: "08:00:00",
            endTime: "17:00:00",
          },
        });
      }
      buildDataCopy.set("bestFit", bestFitEvents);
      setModals((prevModals: any) => ({
        ...prevModals,
        initialLoad: false,
      }));

      const originData: any = [];
      buildDataCopy.forEach((el: any, i: any, val: any) => {
        if (
          originData?.length < 3 &&
          (moment().isBetween(
            el[0]?.timeSlotInfo?.startTimeStamp,
            el[0]?.timeSlotInfo?.endTimeStamp
          ) ||
            moment().isBefore(el[0]?.timeSlotInfo?.startTimeStamp) ||
            el[0]?.appointmentInfo?.bestFit == "1")
        ) {
          if (el[0]?.appointmentInfo != undefined) {
            originData.push(el);
          }
        }
      });
      setAppointmentDetailsForExpand([...buildDataCopy.values()]);

      setAppointmentDetails(originData);
      setCancelEventReason("");
    } catch (e) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
      console.log(e);
    }
  };
  const bindDDHandler = (response: any) => {
    const buildStateDropDown: any = [{ label: t("ALL"), value: "ALL" }];
    response.data.referenceDetails.forEach((value: any, index: any) => {
      // if (value.referenceCode !== 'SE') {
      buildStateDropDown.push({
        label: value.description,
        value: value.description,
      });
      // }
    });
    setEventDD(buildStateDropDown);
  };
  function compareStartTime(a: any, b: any) {
    const startTimeA = a.timeSlotInfo.startTime;
    const startTimeB = b.timeSlotInfo.startTime;

    if (startTimeA < startTimeB) {
      return -1;
    } else if (startTimeA > startTimeB) {
      return 1;
    }
    return 0;
  }
  const editStoreEventHandler = () => {
    history.push({
      pathname: `/storemgmt/createevent`,
      search: "?editevent=true",
      state: currentappointmentDetails,
    });
  };
  // Edit Pick Up
  const editPickupEventHandler = () => {
    history.push({
      pathname: `/storemgmt/storepickupevent`,
      search: "?editevent=true",
      state: currentappointmentDetails,
    });
  };

  const editFieldVisitEventHandler = () => {
    history.push({
      pathname: `/storemgmt/fieldvisitevent`,
      search: "?editevent=true",
      state: currentappointmentDetails,
    });
  };

  const cancelOrCompleteStoreEvent = async (eventType: any) => {
    try {
      setEnableDeliveryPopup(false);
      setEnableStorePickupPopup(false);
      setEnableFieldVisitPopup(false);
      // setModals({ ...modals, storeEventDetailModal: false })
      // if (cancelEventReason.length == 0 && eventType == 'Cancel') {
      //     setModals({ ...modals, cancelEventReaspnModal: true, storeEventDetailModal: false })
      //     return
      // }
      setModals({
        ...modals,
        storeEventDetailModal: false,
        reopenConfirmModal: false,
        cancelEventReaspnModal: false,
        completeConfirmModal: false,
      });
      setEnableDeliveryPopup(false);
      const payloadForAppointmentAction: any = {
        storeNumber: currentappointmentDetails.storeNumber,
        appointmentId: currentappointmentDetails.appointmentInfo.appointmentId,
        actionName: eventType,
      };
      const payloadForManageEvent: any = {
        storeNumber: sessionStorage.getItem("storeNumber"),
        appointmentId: currentappointmentDetails.appointmentInfo.appointmentId,
        coworkerId: EmpolyeeId,
        note: cancelEventReason,
      };
      setloader(true);
      // if (eventType == 'Cancel') {
      //     await manageAppointment(payloadForManageEvent)
      // }
      await updateEventStatus(payloadForAppointmentAction);
      await pageLoad(filterStateData?.date);
      setloader(false);
    } catch (e: any) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };
  const acimaPocancelEvent = async (eventType: any) => {
    try {
      setacimaEventDetails(false);
      const payloadForAppointmentAction: any = {
        storeNumber: window.sessionStorage.getItem("storeNumber"),
        appointmentId: acimaEventValues?.appointmentId,
        actionName: eventType,
      };
      setloader(true);
      setModals({ ...modals, reopenConfirmModal: false });
      await updateEventStatus(payloadForAppointmentAction);
      await pageLoad(filterStateData?.date);
      setloader(false);
    } catch (e: any) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };
  const normalizeinput = (phonenum: any) => {
    if (phonenum == "") return phonenum;
    if (!phonenum) return phonenum;
    const currentValue = phonenum.replace(/[^\d]/g, "");

    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
      3,
      6
    )}-${currentValue.slice(6, 10)}`;
  };
  const bindChecklist = (source?: string) => {
    if (itemdata !== undefined && itemdata !== null && itemdata.length > 0) {
      let data: any = itemdata;
      data = itemdata;
      console.log("agreementInfoData else data", data);
      const uniquedesc = [
        ...new Map(
          data.map((item: any) => [item.inventoryDesc, item])
        ).values(),
      ];
      return uniquedesc.map((value: any, index: any) => {
        return (
          <tr key={index} style={{ width: "100%" }}>
            <td
              style={{
                width: "15px",
                paddingLeft: "12px",
                paddingRight: "12px",
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              <span
                style={{
                  padding: PaddingConst,
                  borderRadius: borderRadiuss,
                  border: Constinter,
                  marginRight: "10px",
                }}
              />
            </td>
            <td
              style={{
                width: "300px",
                paddingLeft: "12px",
                paddingRight: "12px",
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              {value !== undefined && value.inventoryDesc !== undefined
                ? value.inventoryDesc
                : ""}
            </td>
            <td
              style={{
                width: "300px",
                paddingLeft: "12px",
                paddingRight: "12px",
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              {value !== undefined &&
              value.serialNumber !== undefined &&
              value.serialNumber !== null &&
              value.serialNumber != ""
                ? value.serialNumber
                : "-"}
            </td>
            <td
              style={{
                width: "300px",
                paddingLeft: "12px",
                paddingRight: "12px",
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              {value !== undefined && value.inventoryNumber !== undefined
                ? value.inventoryNumber
                : ""}
            </td>
          </tr>
        );
      });
    }
  };
  // function HandleDeliveryModalCard() {
  //     return (
  //         <RACModalCard
  //             isOpen={enableDeliveryPopup}
  //             maxWidth="md"
  //             closeIcon={true}
  //             borderRadius="20px"
  //             onClose={() => setEnableDeliveryPopup(false)}
  //             // eslint-disable-next-line react/no-children-prop
  //             children={DeliveryPopup()}
  //             title="Event Details"
  //             TitleVariantClassName={classes.popUpFont}
  //         />
  //     )
  // }
  const renderAppointmentTableHead = () => {
    return (
      <>
        <React.Fragment>
          <RACTableCell>
            <Typography variant="h5">{t("Inventory #")}</Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="h5">{t("Description")}</Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="h5">{t("Condition")}</Typography>
          </RACTableCell>
        </React.Fragment>
      </>
    );
  };
  const renderAppointmentTableHistoryHeader = () => {
    return (
      <>
        <React.Fragment>
          <RACTableCell>
            <Typography variant="h5">{t("Activity Date & Time")}</Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="h5">{t("Coworker")}</Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="h5">{t("Action")}</Typography>
          </RACTableCell>
        </React.Fragment>
      </>
    );
  };
  const renderAppointmentTableContent = () => {
    return currentappointmentDetails?.inventories?.map((data: any) => {
      return (
        <>
          <React.Fragment>
            {/* <Grid className={classes.racLightBlue}> */}
            <RACTableRow
              style={{ backgroundColor: "white", padding: "4px 14px" }}
            >
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>{data?.inventoryNumber}</Typography>
              </RACTableCell>
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>{data?.description}</Typography>
              </RACTableCell>
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>
                  {data.itemCondition &&
                  data.itemCondition.toLowerCase() == "new"
                    ? t("New")
                    : data.itemCondition.toLowerCase() == "ato"
                    ? t("Auto")
                    : data.itemCondition.toLowerCase() == "excp"
                    ? t("Exception")
                    : data.itemCondition}
                </Typography>
              </RACTableCell>
            </RACTableRow>
            {/* </Grid> */}
          </React.Fragment>
        </>
      );
    });
  };
  const renderAppointmentTableHistoryContent = () => {
    return appointmentHistoryRecord?.appointmentHistory?.map((data: any) => {
      return (
        <>
          <React.Fragment>
            {/* <Grid className={classes.racLightBlue}> */}
            <RACTableRow
              style={{ backgroundColor: "white", padding: "4px 14px" }}
            >
              <RACTableCell className={`${classes.racLightBlue}`}>
                
                  {dateTimeLocalization == 1 ? (
                                  <RACDateTimeLabel
                                    value={data?.actionTimeStamp}
                                    displayType="ShortDateTime12hr"  
                                    country={countryIdentification}
                                    className={classes.formvalue}
                                  />
                                ) : (<Typography>
                                  {moment(data?.actionTimeStamp).format("MM/DD/YYYY hh:mm A")}
                                </Typography>)}
              </RACTableCell>
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>{data?.createdBy}</Typography>
              </RACTableCell>
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>
                  {data.actionName == "CAN"
                    ? t("Cancelled")
                    : data.actionName == "EDITED"
                    ? t("Edited")
                    : data.actionName == "CMP"
                    ? t("Completed")
                    : t(data.actionName)}
                </Typography>
              </RACTableCell>
            </RACTableRow>
            {/* </Grid> */}
          </React.Fragment>
        </>
      );
    });
  };

  const renderAcimaAppointmentTableHistoryHeader = () => {
    return (
      <>
        <React.Fragment>
          <RACTableCell>
            <Typography variant="h5">{t("Activity Date & Time")}</Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="h5">{t("Coworker")}</Typography>
          </RACTableCell>
          <RACTableCell>
            <Typography variant="h5">{t("Action")}</Typography>
          </RACTableCell>
        </React.Fragment>
      </>
    );
  };

  const renderAcimaAppointmentTableHistoryContent = () => {
    return appointmentHistoryRecord?.appointmentHistory?.map((data: any) => {
      return (
        <>
          <React.Fragment>
            {/* <Grid className={classes.racLightBlue}> */}
            <RACTableRow
              style={{ backgroundColor: "white", padding: "4px 14px" }}
            >
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>
                  {moment(data?.actionTimeStamp).format("MM/DD/YYYY hh:mm A")}
                </Typography>
              </RACTableCell>
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>{data?.createdBy}</Typography>
              </RACTableCell>
              <RACTableCell className={`${classes.racLightBlue}`}>
                <Typography>
                  {data.actionName == "CAN"
                    ? t("Cancelled")
                    : data.actionName == "EDITED"
                    ? t("Edited")
                    : data.actionName == "CMP"
                    ? t("Completed")
                    : t(data.actionName)}
                </Typography>
              </RACTableCell>
            </RACTableRow>
            {/* </Grid> */}
          </React.Fragment>
        </>
      );
    });
  };
  const handleConfirmDelivery = async () => {
    try {

 
      setEnableDeliveryPopup(false);
      const updatedeliverystatus: any = {
        agreementId:
          currentappointmentDetails &&
          currentappointmentDetails?.agreement?.agreementId,
        documentId: updateRecieptKey,
      };
      if (
        currentappointmentDetails &&
        currentappointmentDetails.isSwitchoutEnabled == "1"
      ) {
        updatedeliverystatus.isSwitchOut = 1;
        updatedeliverystatus.switchInItem = Number(
          currentappointmentDetails.switchInItem
        );
        updatedeliverystatus.documentId = updateRecieptKey;
      }
      const payload: any = {
        storeNumber: currentappointmentDetails.storeNumber,
        appointmentId: currentappointmentDetails.appointmentInfo.appointmentId,
        actionName: "Complete",
        documentId: updateRecieptKey,
      };
      setloader(true);

      if (
        ["CI", "P", "S", "SCI", "SCO", "SD", "SP"].includes(
          currentappointmentDetails?.appointmentInfo?.appointmentType
        )
      ) {
        await updateEventStatus(payload);
        if (
          ["S", "SCI", "SCO", "SD", "SP"].includes(
            currentappointmentDetails?.appointmentInfo?.appointmentType
          )
        ) {
          const updatesign = {
            agreementId:
              currentappointmentDetails &&
              currentappointmentDetails?.agreement?.agreementId,
            value: 1,
          };
          Recieptsign(updatesign);
        }
      } else {

          if (enableDocumentsCheck == '1' && currentappointmentDetails?.isSwitchoutEnabled == '0' && (currentappointmentDetails.appointmentInfo?.appointmentType == 'CO' || currentappointmentDetails.appointmentInfo?.appointmentType == 'D' ) && currentappointmentDetails?.agreement?.agreementTypeDesc == 'Rental Agreement (RTO)')  {
          setloader(true);
          const valid = await getCustomerVerificationDocuments(currentappointmentDetails?.customerInfo?.customerId)
          if (!valid) {
            setloader(false);
            return;
          }
        }
        const ConfirmdeliveryRes = await Confirmdelivery(updatedeliverystatus);
        const updatesign = {
          agreementId:
            currentappointmentDetails &&
            currentappointmentDetails?.agreement?.agreementId,
          value: 1,
        };
        Recieptsign(updatesign);
        if (ConfirmdeliveryRes?.status == 200 && ConfirmdeliveryRes?.data) {
          if (currentappointmentDetails?.isSwitchoutEnabled == "1") {
            const payload: any = {
              storeException: [
                {
                  identifierId: Number(
                    currentappointmentDetails?.agreement?.agreementId
                  ),
                  identifierType: "AGREEMENT",
                  storeNumber: window.sessionStorage.getItem("storeNumber"),
                  exceptionTypeRefCode: "SWO",
                  exceptionText: null,
                },
              ],
            };
            storeException(payload);
          }
        }
      }
      setloader(false);
      SetOpendeliveryconfirmpopup(true);
    } catch (e: any) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }

    // window.location.reload();
  };
  const formatNum = (val: any) => {
    const cleaned = ("" + val).replace(/\D/g, "");
    const PhoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return cleaned.replace(PhoneRegex, "($1) $2-$3");
  };
  // const replaceEmtyString = ()=>{}
  const reScheduleBtnHandler = () => {
    if (
      ["S", "SCI", "SCO", "SD", "SP"].includes(
        currentappointmentDetails?.appointmentInfo?.appointmentType
      )
    ) {
      const invNumber =
        currentappointmentDetails?.inventories &&
        currentappointmentDetails?.inventories.length > 0 &&
        currentappointmentDetails?.inventories[0].inventoryNumber;
      history.push({
        pathname: `/inventory/${invNumber}/service`,
      });
    } else if (
      ["D", "P"].includes(
        currentappointmentDetails?.appointmentInfo?.appointmentType
      )
    ) {
      history.push({
        pathname: `/agreement/info/delivery/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
      });
    } else {
      history.push({
        pathname: `/agreement/info/details/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
      });
    }
  };

  // customer signature funtion
  const customerSignatureFn = async () => {
    SetCheckforSign(false);
    setloader(true);
    const result = await GetCustomerinfo(agreementValues.agreementId);
    console.log("GetCustomerinfo response : ", result.data);
    setloader(false);
    if (result?.status == 200) {
      if (result.data.coCustomer.length == 0) {
        console.log("customerdatalog", result.data.customer);
        const CustomerObj = [
          {
            customerId: result.data.customer[0].customerId,
            customerName: result.data.customer[0].customerName,
            phoneNumber: result.data.customer[0].phoneNumber,
            emailId: result.data.customer[0].emailAddress,
          },
        ];
        setcustomersArray(CustomerObj);
      } else {
        if (result.data.coCustomer[0].isDocumentGenerated === "1") {
          /* eslint-disable no-console */
          console.log("Co Customer : ", result.data);
          const CustomerObj = [
            {
              customerId: result.data.customer[0].customerId,
              customerName: result.data.customer[0].customerName,
              phoneNumber: result.data.customer[0].phoneNumber,
              emailId: result.data.customer[0].emailAddress,
            },
            {
              emailId: result.data.coCustomer[0].emailAddress,
              customerName: result.data.coCustomer[0].customerName,
              phoneNumber: result.data.coCustomer[0].phoneNumber,
              customerId: result.data.coCustomer[0].customerId,
            },
          ];
          setcustomersArray(CustomerObj);
        } else {
          console.log("No Co Customer : ", result.data);
          const CustomerObj = [
            {
              customerId: result.data.customer[0].customerId,
              customerName: result.data.customer[0].customerName,
              phoneNumber: result.data.customer[0].phoneNumber,
              emailId: result.data.customer[0].emailAddress,
            },
          ];
          setcustomersArray(CustomerObj);
        }
      }
      setcustomerSignEnabled(true);
    }
  };

  // Agreement Not Sign Check popup

  const SignCheckPopup = () => {
    return (
      <Grid className={classes.p2}>
        <Grid item md={12} className={classes.textCenter}>
          <Typography
            className={`${classes.agrDeliveryReceiptText} ${classes.semiBold}`}
          >
            {t("Agreement")}# {agreementValues.agreementNumber}{" "}
            {t(
              "has been unsigned. Do you like to sign the agreement to continue?"
            )}{" "}
          </Typography>
        </Grid>

        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            onClick={() => {
              SetCheckforSign(false);
            }}
            variant="outlined"
            color="primary"
          >
            {t("No")}
          </RACButton>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              customerSignatureFn();
            }}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  // digital Sign Function
  const storeNo = window.sessionStorage.getItem("storeNumber");


  const getCustomerVerificationDocuments = async (customerId: string): Promise<boolean> => {
  
    const incomeDocument: any = [];
    const residenceDocument: any = [];
    let customerTransactionId = null
    let verfDocsAvailable = false;

    const customerInfoResponse = await GetCustomer(customerId, storeNo);
    if (customerInfoResponse && customerInfoResponse.status == 200 && customerInfoResponse.data) {
       if (customerInfoResponse?.data?.GetCustomer?.value) {
          customerTransactionId = customerInfoResponse?.data?.GetCustomer?.value?.stgCustomerProfileId
       }
    }

  const getDocumentsPayload = (documentType: any) => {
    const payload: any = {
      identifier: (customerTransactionId !== undefined) ? customerTransactionId :null,
      documentStatus: 'signed',
      actionType: 'print',
      identifierType: 'CUST',
      customerVerificationDocument: 'true',
      documentType,
      customerId
    };

    return payload;
  };

  const getIncomeDocPayload = getDocumentsPayload(DOCUMENT_TYPE.EMPLOYMENT_DOC);
  const getResidenceDocPayload = getDocumentsPayload(DOCUMENT_TYPE.RESIDENCE_DOC);

  const [incomeDoc, residenceDoc] = await Promise.all([
    getVerificationDocuments(getIncomeDocPayload),
    getVerificationDocuments(getResidenceDocPayload)
  ]);


  if (incomeDoc && incomeDoc != undefined && incomeDoc?.documents?.length) {
    incomeDoc?.documents?.forEach((ele: any) => {
      incomeDocument.push(ele);
    })
  }
  if (residenceDoc && residenceDoc != undefined && residenceDoc?.documents?.length) {
    residenceDoc?.documents?.forEach((ele: any) => {
      residenceDocument.push(ele);
    })
  }
      if (incomeDocument.length > 0 && residenceDocument.length > 0) {
        verfDocsAvailable = true;       
      } else {
        verfDocsAvailable = false;
        setdigitalSignEnable(false);
        setMandatoryPopup(true);
      }
    return verfDocsAvailable;
  }


  const digitalSignClickFn = async () => {
    setloader(true);

    if (agreementValues.agreementSign == "0") {
      const apiResponse: any = await CheckSign(agreementValues?.agreementId);
      setloader(false);
      if (apiResponse?.data?.isSigned == "0") {
        // setEnableDeliveryPopup(false);
        SetCheckforSign(true);
      } else {
        setloader(false);
        setdigitalSignEnable(true);
      }
    } else {
      setloader(false);
      setdigitalSignEnable(true);
    }
  };
  // Customer Survery Form
  const showCustomerSurveyForm = async () => {
    resetSurvey();
    setToShowCustomerSurveyForm(true);
  };

  // Customer Survery Form
  const showReadOnlyCustomerSurveyForm = async () => {
    setToShowCustomerSurveyForm(true);
  };

  // Address Survey Form
  const showAddressSurveyForm = async () => {
    resetAddressSurvey();
    setToShowAddressSurveyForm(true);
  };

  // Address Survey Form
  const showReadOnlyAddressSurveyForm = async () => {
    setToShowAddressSurveyForm(true);
  };

  const AcimaDigitalSignClickFn = async () => {
    setacimaDeliveryDigitalsignEnbale(true);
  };
  const addressFormatFnResFn = () => {
    const address =
      currentappointmentDetails?.customerInfo?.address?.addressLine1 +
      "," +
      currentappointmentDetails?.customerInfo?.address?.addressLine2 +
      "," +
      currentappointmentDetails?.customerInfo?.address?.state;
    return address;
  };

   const addressFormatFnResFnMX = () => {
    console.log( mxCustomerAddress,"address")
        return (
      mxCustomerAddress?.addressLine1 + 
      "," +
      mxCustomerAddress?.exteriorNumber + 
      "," +
      mxCustomerAddress?.interiorNumber + 
      "," +
      mxCustomerAddress?.addressLine2 + 
      "," +
      mxCustomerAddress?.city + 
      "," +
      mxCustomerAddress?.state
    );
  };

  const handleAddressClick = async () => {
 let addressFormatFnRes;
   
    if(addressVerificationSurveyParamKey == '1'){
           addressFormatFnRes = await addressFormatFnResFnMX();
    }else{
           addressFormatFnRes = await addressFormatFnResFn();
    }    
    const encodedAddress = encodeURIComponent(addressFormatFnRes);
    const googleMapsURL = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsURL, "_blank");
  };

  const handlePhoneNumberClick = () => {
    window.location.href = `tel:${currentappointmentDetails?.customerInfo?.phoneNumber}`;
  };

  const DeliveryPopup = () => {
    currentappointmentDetails;

    // let flag: any = true
    // if (currentappointmentDetails && (currentappointmentDetails.appointmentInfo.appointmentStatus != 'CMP') && (currentappointmentDetails?.agreement?.agreementTypeDesc == 'Rental Agreement (RTO)' || currentappointmentDetails?.agreement?.agreementTypeDesc == 'Rent to Rent - Loaner') && (currentappointmentDetails?.appointmentInfo?.appointmentType == 'D' || currentappointmentDetails?.appointmentInfo?.appointmentType == 'CO') && (fieldDeviceParamKey == '1') && (currentappointmentDetails?.isSwitchoutEnabled == '0')) {
    //     flag = false
    // }
    let flag: any = true;
    if (
      currentappointmentDetails &&
      currentappointmentDetails.appointmentInfo.appointmentStatus != "CMP" &&
      fieldDeviceParamKey == "1"
    ) {
      flag = false;
    }

    return (
      <>
        {Number(MXStoreIdentifier) == 1 &&
        currentappointmentDetails &&
        currentappointmentDetails.storeNumber ? (
          <Grid
            style={{
              positive: "absolute",
              position: "absolute",
              top: "0.8rem",
              right: (language === 'es-MX' || language === 'es-US')? "39rem":"44rem",
              border: "2px solid #dbe3ea",
              padding: "5px",
              borderRadius: "2px",
              backgroundColor: "#f0f8ff",
            }}
          >
            <Typography>{`${t("Store")} - ${currentappointmentDetails.storeNumber}`}</Typography>
          </Grid>
        ) : null}
        <Grid item md={12}>
          <Grid
            item
            md={12}
            //  className={classes.textCenter}
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "50%" }}>
              <Typography>{t("Agreement #")}</Typography>
            </Grid>
            {/* <Grid style={{ width: "33%" }}>
                        <Typography>
                            Customer ID
                        </Typography>
                    </Grid> */}
            <Grid style={{ width: "50%" }}>
              <Typography>{t("Customer Name")}</Typography>
            </Grid>
          </Grid>

          <Grid
            //  className={classes.textCenter}
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "50%" }}>
              <a
                onClick={() => {
                  pilotStoreParamKey == "1"
                    ? history.push({
                        pathname: `/agreement/info/details/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
                      })
                    : null;
                }}
                className={
                  pilotStoreParamKey == "1"
                    ? classes.customerRaclink
                    : classes.customerRaclinkAcima
                }
              >
                {currentappointmentDetails &&
                  currentappointmentDetails?.agreement?.agreementNumber}
              </a>
            </Grid>
            {/* <Grid style={{ width: "33%" }}>
                        <a
                            onClick={() => history.push({ pathname: `/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer` })}
                            className={classes.customerRaclink}
                        >
                            {currentappointmentDetails && currentappointmentDetails?.customerInfo?.customerId}
                        </a>
                    </Grid> */}
            <Grid style={{ width: "50%" }}>
              <a
                onClick={() => {
                  pilotStoreParamKey == "1"
                    ? history.push({
                        pathname: `/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer`,
                      })
                    : null;
                }}
                className={
                  pilotStoreParamKey == "1"
                    ? classes.customerRaclink
                    : classes.customerRaclinkAcima
                }
              >
                {currentappointmentDetails?.customerInfo?.firstName +
                  ` ` +
                  currentappointmentDetails?.customerInfo?.lastName}
              </a>
            </Grid>
          </Grid>

          <Grid
            item
            md={12}
            //  className={classes.textCenter}
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "50%" }}>
              <Typography>{t("Customer Address")}</Typography>
            </Grid>
            {/* <Grid style={{ width: "33%" }}>
                        <Typography>
                            Customer ID
                        </Typography>
                    </Grid> */}
            <Grid style={{ width: "50%" }}>
              <Typography>{t("Phone")} #</Typography>
            </Grid>
          </Grid>

          <Grid
            //  className={classes.textCenter}
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
              <a
                onClick={() => {
                  {
                    currentappointmentDetails?.customerInfo?.address
                      ?.addressLine1
                      ? handleAddressClick()
                      : null;
                  }
                }}
              >
                  {addressVerificationSurveyParamKey == '1' ? 
              (
                <>
                {(mxCustomerAddress &&
                 (mxCustomerAddress?.addressLine1 || "") +
                  " " +
                  (mxCustomerAddress?.exteriorNumber || "")+
                  " " +
                  (mxCustomerAddress?.interiorNumber ||"")+
                    " " +
                  (mxCustomerAddress?.addressLine2 ||"")+
                    " " +
                   (mxCustomerAddress?.city ||"")+
                    " " +
                  (mxCustomerAddress?.state ||"")+
                    " " +
                  (mxCustomerAddress?.postalCode || "")) ||
                   ""}

                 
                 </>)
               :(
                 <>
                {(currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address
                  ?.addressLine1 || "") +
                  " " +
                  currentappointmentDetails?.customerInfo?.address
                    ?.addressLine2) ||
                ""}
                 {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address?.city || "")}
                </>
              )}
              </a>
            </Grid>
            <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
              <a
                onClick={() => {
                  {
                    currentappointmentDetails?.customerInfo?.phoneNumber
                      ? handlePhoneNumberClick()
                      : null;
                  }
                }}
              >
                {currentappointmentDetails &&
                  (currentappointmentDetails?.customerInfo?.phoneNumber
                    ? formatNum(
                        currentappointmentDetails?.customerInfo?.phoneNumber
                      )
                    : "")}
              </a>
            </Grid>
          </Grid>

          <Grid className={classes.racLightBlue} style={{ margin: "10px" }}>
            <RACTable
              renderTableHead={renderAppointmentTableHead}
              renderTableContent={renderAppointmentTableContent}
            />
          </Grid>

          {/* ----------------------------Toggle Start--------- */}
          {!flag ? (
            <div>
              <Grid style={{ display: "inline-block" }}>
                <RACToggle
                  checked={manualSignatureEnabled}
                  toggleColor="#0d6efd"
                  OnClick={() => {
                    manualSignatureEnabled
                      ? setmanualSignatureEnabled(false)
                      : setmanualSignatureEnabled(true);
                  }}
                />
              </Grid>
              <Typography style={{ display: "inline" }}>
                {t("Manual Signature")}
              </Typography>
            </div>
          ) : null}
          {/* ----------------------------Toggle Ending--------- */}

          {/*-------------------Delivery Digital Start-----------------------  */}

          {/* (!manualSignatureEnabled) && (currentappointmentDetails) && (currentappointmentDetails.appointmentInfo.appointmentStatus != 'CMP') && (currentappointmentDetails?.agreement?.agreementTypeDesc == 'Rental Agreement (RTO)' || currentaafppointmentDetails?.agreement?.agreementTypeDesc == 'Rent to Rent - Loaner') && (currentappointmentDetails?.appointmentInfo?.appointmentType == 'D' || currentappointmentDetails?.appointmentInfo?.appointmentType == 'CO') && (fieldDeviceParamKey == '1') && (currentappointmentDetails?.isSwitchoutEnabled == '0') */}

          {!manualSignatureEnabled &&
          currentappointmentDetails &&
          currentappointmentDetails.appointmentInfo.appointmentStatus !=
            "CMP" &&
          fieldDeviceParamKey == "1" ? (
            <div>
              {currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus ==
                "CMP" ? (
                <Grid style={{ display: "flex", justifyContent: "center" }}>
                  <Typography variant="h5" style={{ alignSelf: "center" }}>
                    {t("Status")} :
                  </Typography>
                  <span
                    style={{
                      marginLeft: "10px",
                      marginTop: "2px",
                      color: "#58af52",
                      border: "1px solid #58af52",
                      padding: "5px",
                      borderRadius: "5px",
                      fontWeight: "800",
                    }}
                  >
                    {t("Completed")}
                  </span>
                </Grid>
              ) : currentappointmentDetails &&
                currentappointmentDetails.appointmentInfo.appointmentStatus !==
                  "CAN" ? (
                <div data-testid="WizardTest">
                  <Grid className={classes.swThemeDefault}>
                    <Grid item className={classes.swThemeDefaultContainer}>
                      <List
                        className={classes.smartWizard}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <ListItem
                          className={classes.smartWizardList}
                          // onClick={() => WizardFieldClick('Itemsearch')}
                        >
                          <a
                            className={
                              dynamicClasses?.status?.Signature?.anchor
                            }
                          >
                            {status?.Signature === "complete" ? (
                              <Box
                                component="span"
                                className={`${classes.done} ${classes.borderDone}`}
                                style={{
                                  backgroundColor: "#5ae286",
                                  borderColor: "#5ae286",
                                }}
                              >
                                <CompletedIcon
                                  className={classes.paddingTop3}
                                />
                              </Box>
                            ) : null}

                            <span
                              className={
                                dynamicClasses?.status?.Signature?.spanDetail
                              }
                            >
                              {t("Agreement Signature")}
                            </span>
                          </a>
                        </ListItem>

                        <ListItem className={classes.smartWizardList}>
                          <a
                            className={
                              dynamicClasses?.status?.ConfirmDelivery?.anchor
                            }
                            style={{ cursor: "not-allowed" }}
                          >
                            {status?.ConfirmDelivery === "complete" ? (
                              <Box
                                component="span"
                                className={`${classes.done} ${classes.borderDone}`}
                                style={{
                                  backgroundColor: "#5ae286",
                                  borderColor: "#5ae286",
                                }}
                              >
                                <CompletedIcon
                                  className={classes.paddingTop3}
                                />
                              </Box>
                            ) : (
                              <span
                                className={
                                  dynamicClasses?.status?.ConfirmDelivery
                                    ?.spanNum
                                }
                                style={{
                                  color: "#ffffff",
                                  border: "2px solid #d9d9d9",
                                  margin: "0 5px",
                                  padding: "4px 11px",
                                  borderColor: "#1b4ae1",
                                  borderRadius: "50px",
                                  backgroundColor: "#1b4ae1",
                                }}
                              >
                                2
                              </span>
                            )}

                            <span
                              className={
                                dynamicClasses?.status?.ConfirmDelivery
                                  ?.spanDetail
                              }
                            >
                              {t("Sign Delivery Receipt")}
                            </span>
                          </a>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                </div>
              ) : null}
              {currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus !==
                "CMP" ? (
                <Grid style={{ textAlign: "center" }}>
                  {currentappointmentDetails &&
                  currentappointmentDetails.appointmentInfo.appointmentStatus ==
                    "CAN" ? (
                    <>
                      <Typography
                        variant="h4"
                        style={{
                          backgroundColor: "gray",
                          color: "black",
                          display: "contents",
                        }}
                      >
                        {t("Status")}:{t("Cancelled")}
                      </Typography>
                      <RACButton
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          setModals({ ...modals, reopenConfirmModal: true })
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        {t("Reopen Event")}
                      </RACButton>
                    </>
                  ) : (
                    <>
                      <RACButton
                        variant="outlined"
                        className={classes.unassignBtnClass}
                        onClick={() => cancelOrCompleteStoreEvent("Cancel")}
                      >
                        {t("Cancel Event")}
                      </RACButton>
                      {pilotStoreParamKey == "1" ? (
                        <RACButton
                          color="primary"
                          variant="contained"
                          className={classes.ms2}
                          onClick={() => reScheduleBtnHandler()}
                        >
                          {t("Reschedule")}
                        </RACButton>
                      ) : null}

                      <RACButton
                        className={classes.ms2}
                        color="primary"
                        type="button"
                        // disabled={handleDisable()}
                        variant="contained"
                        // onClick={() => { setEnableDeliveryPopup(false), setdigitalSignEnable(true) }}
                        onClick={() => {
                          digitalSignClickFn();
                        }}
                      >
                        {t("Sign and Confirm Delivery")}
                      </RACButton>

                      {customerSurveyParamKey == "1" ? (
                        toShowSurvey ? (
                          <RACButton
                            className={classes.ms2}
                            color="primary"
                            type="button"
                            variant="contained"
                            onClick={() => {
                              showCustomerSurveyForm();
                            }}
                          >
                            {t("Customer Survey")}
                          </RACButton>
                        ) : readOnlySurvey ? (
                          <RACButton
                            className={classes.ms2}
                            color="primary"
                            type="button"
                            variant="contained"
                            onClick={() => {
                              showReadOnlyCustomerSurveyForm();
                            }}
                          >
                            {t("Show Survey")}
                          </RACButton>
                        ) : null
                      ) : addressVerificationSurveyParamKey == "1" ? (
                        toShowAddressSurvey ? (
                          <RACButton
                            className={classes.ms2}
                            color="primary"
                            type="button"
                            variant="contained"
                            onClick={() => {
                              showAddressSurveyForm();
                            }}
                          >
                            {t("Address Verification by Coworker")}
                          </RACButton>
                        ) : readOnlyAddressSurvey ? (
                          <RACButton
                            className={classes.ms2}
                            color="primary"
                            type="button"
                            variant="contained"
                            onClick={() => {
                              showReadOnlyAddressSurveyForm();
                            }}
                          >
                            {t("Address Verification")}
                          </RACButton>
                        ) : null
                      ) : null}
                    </>
                  )}
                </Grid>
              ) : null}
            </div>
          ) : (
            <div>
              {/* ----------------------------Delivery Digital End--------------------- */}

              {/* --------------------------Manual Signature Start------------------- */}
              {currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus ==
                "CMP" ? (
                <Grid style={{ display: "flex", justifyContent: "center" }}>
                  <Typography variant="h5" style={{ alignSelf: "center" }}>
                    {t("Status")} :
                  </Typography>
                  <span
                    style={{
                      marginLeft: "10px",
                      marginTop: "2px",
                      color: "#58af52",
                      border: "1px solid #58af52",
                      padding: "10px",
                      borderRadius: "5px",
                      fontWeight: "800",
                    }}
                  >
                    {t("Completed")}
                  </span>

                  {customerSurveyParamKey == "1" ? (
                    toShowSurvey ? (
                      <RACButton
                        className={classes.ms2}
                        color="primary"
                        type="button"
                        variant="contained"
                        onClick={() => {
                          showCustomerSurveyForm();
                        }}
                      >
                        {t("Customer Survey")}
                      </RACButton>
                    ) : readOnlySurvey ? (
                      <RACButton
                        className={classes.ms2}
                        color="primary"
                        type="button"
                        variant="contained"
                        onClick={() => {
                          showReadOnlyCustomerSurveyForm();
                        }}
                      >
                        {t("Show Survey")}
                      </RACButton>
                    ) : null
                  ) : addressVerificationSurveyParamKey == "1" ? (
                    toShowAddressSurvey ? (
                      <RACButton
                        className={classes.ms2}
                        color="primary"
                        type="button"
                        variant="contained"
                        onClick={() => {
                          showAddressSurveyForm();
                        }}
                      >
                        {t("Address Verification by Coworker")}
                      </RACButton>
                    ) : readOnlyAddressSurvey ? (
                      <RACButton
                        className={classes.ms2}
                        color="primary"
                        type="button"
                        variant="contained"
                        onClick={() => {
                          showReadOnlyAddressSurveyForm();
                        }}
                      >
                        {t("Address Verification ")}
                      </RACButton>
                    ) : null
                  ) : null}
                </Grid>
              ) : currentappointmentDetails &&
                currentappointmentDetails.appointmentInfo.appointmentStatus !==
                  "CAN" ? (
                <div data-testid="WizardTest">
                  <Grid className={classes.swThemeDefault}>
                    <Grid item className={classes.swThemeDefaultContainer}>
                      <List
                        className={classes.smartWizard}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <ListItem
                          className={classes.smartWizardList}
                          // onClick={() => WizardFieldClick('Itemsearch')}
                        >
                          <a
                            className={
                              dynamicClasses?.status?.Signature?.anchor
                            }
                          >
                            {status?.Signature === "complete" ? (
                              <Box
                                component="span"
                                className={`${classes.done} ${classes.borderDone}`}
                                style={{
                                  backgroundColor: "#5ae286",
                                  borderColor: "#5ae286",
                                }}
                              >
                                <CompletedIcon
                                  className={classes.paddingTop3}
                                />
                              </Box>
                            ) : null}

                            <span
                              className={
                                dynamicClasses?.status?.Signature?.spanDetail
                              }
                            >
                              {t("Signature")}
                            </span>
                          </a>
                        </ListItem>
                        <ListItem
                          className={classes.smartWizardList}
                          // onClick={() => WizardFieldClick('AgrDetails')}
                        >
                          <a
                            className={dynamicClasses?.status?.Reprint?.anchor}
                          >
                            {status?.Reprint === "complete" ? (
                              <Box
                                component="span"
                                className={`${classes.done} ${classes.borderDone}`}
                                style={{
                                  backgroundColor: "#5ae286",
                                  borderColor: "#5ae286",
                                }}
                              >
                                <CompletedIcon
                                  className={classes.paddingTop3}
                                />
                              </Box>
                            ) : (
                              <span
                                className={
                                  dynamicClasses?.status?.Reprint?.spanNum
                                }
                                style={{
                                  color: "#ffffff",
                                  border: "2px solid #d9d9d9",
                                  margin: "0 5px",
                                  padding: "4px 11px",
                                  borderColor: "#1b4ae1",
                                  borderRadius: "50px",
                                  backgroundColor: "#1b4ae1",
                                }}
                              >
                                2
                              </span>
                            )}

                            <span
                              className={
                                dynamicClasses?.status?.Reprint?.spanDetail
                              }
                            >
                              {t("Re-print Delivery Receipt")}
                            </span>
                          </a>
                        </ListItem>
                        <ListItem className={classes.smartWizardList}>
                          <a
                            className={
                              dynamicClasses?.status?.ConfirmDelivery?.anchor
                            }
                            style={{ cursor: "not-allowed" }}
                          >
                            {status?.ConfirmDelivery === "complete" ? (
                              <Box
                                component="span"
                                className={`${classes.done} ${classes.borderDone}`}
                                style={{
                                  backgroundColor: "#5ae286",
                                  borderColor: "#5ae286",
                                }}
                              >
                                <CompletedIcon
                                  className={classes.paddingTop3}
                                />
                              </Box>
                            ) : (
                              <span
                                className={
                                  dynamicClasses?.status?.ConfirmDelivery
                                    ?.spanNum
                                }
                                style={{
                                  color: "#ffffff",
                                  border: "2px solid #d9d9d9",
                                  margin: "0 5px",
                                  padding: "4px 11px",
                                  borderColor: "#1b4ae1",
                                  borderRadius: "50px",
                                  backgroundColor: "#1b4ae1",
                                }}
                              >
                                3
                              </span>
                            )}

                            <span
                              className={
                                dynamicClasses?.status?.ConfirmDelivery
                                  ?.spanDetail
                              }
                            >
                              {t("Confirm Delivery")}
                            </span>
                          </a>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                </div>
              ) : null}
              {currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus !==
                "CMP" ? (
                <Grid style={{ textAlign: "center" }}>
                  {currentappointmentDetails &&
                  currentappointmentDetails.appointmentInfo.appointmentStatus ==
                    "CAN" ? (
                    <>
                      <Typography
                        variant="h4"
                        style={{
                          backgroundColor: "gray",
                          color: "black",
                          display: "contents",
                        }}
                      >
                        {t("Status")}:{t("Cancelled")}
                      </Typography>
                      <RACButton
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          setModals({ ...modals, reopenConfirmModal: true })
                        }
                        style={{ marginLeft: "40px" }}
                      >
                        {t("Reopen Event")}
                      </RACButton>
                    </>
                  ) : (
                    <>
                      <RACButton
                        variant="outlined"
                        className={classes.unassignBtnClass}
                        onClick={() => cancelOrCompleteStoreEvent("Cancel")}
                      >
                        {t("Cancel Event")}
                      </RACButton>
                      {pilotStoreParamKey == "1" ? (
                        <RACButton
                          color="primary"
                          variant="contained"
                          className={classes.ms2}
                          onClick={() => reScheduleBtnHandler()}
                        >
                          {t("Reschedule")}
                        </RACButton>
                      ) : null}

                      {!isReprintCompleted ? (
                        <RACButton
                          className={classes.ms2}
                          color="primary"
                          type="button"
                          // disabled={handleDisable()}
                          variant="contained"
                          onClick={() => handleRePrintDelivery()}
                        >
                          {t("Re-print Delivery Receipt")}
                        </RACButton>
                      ) : (
                        <RACButton
                          className={classes.ms2}
                          color="primary"
                          type="button"
                          // disabled={handleDisable()}
                          variant="contained"
                          onClick={() => handleConfirmDelivery()}
                        >
                          {t("Confirm Delivery")}
                        </RACButton>
                      )}
                    </>
                  )}
                </Grid>
              ) : null}
            </div>
          )}
          {/* -----------Manual Signature End-------------- */}
          <Grid style={{ width: "100%" }}>
            <Grid container style={{ width: "100%" }}>
              <Card
                className={`${customerStyleClasses.card} ${customerStyleClasses.w100}  ${customerStyleClasses.borderRadiusZero}`}
              >
                <CardContent
                  className={`${classes.headerTab} ${customerStyleClasses.floatLeft} ${customerStyleClasses.w100} ${classes.py0}`}
                  style={{ padding: "0px" }}
                >
                  <Grid
                    item
                    className={`${customerStyleClasses.floatLeft} ${customerStyleClasses.w100}`}
                  >
                    <Box className={customerStyleClasses.floatLeft}>
                      <List
                        className={`${classes.racpadTab} ${classes.py0}`}
                        id="CustTab"
                        role="tabList"
                      >
                        <ListItem
                          className={
                            activetab.notes
                              ? `${classes.navLinkActive} ${classes.navLinkItem}`
                              : `${classes.navLinkItem}`
                          }
                          id="employment-tab"
                          data-testid="employmentInfoTab"
                          data-bs-toggle="tab"
                          data-bs-target="#employmentinfo"
                          role="tab"
                          aria-controls="employment-tab"
                          aria-selected="false"
                          onClick={() =>
                            setactivetab({
                              ...activetab,
                              notes: true,
                              history: false,
                            })
                          }
                        >
                          {t("Notes")}
                        </ListItem>
                        <ListItem
                          className={
                            activetab.history
                              ? `${classes.navLinkActive} ${classes.navLinkItem}`
                              : `${classes.navLinkItem}`
                          }
                          id="Customerinfo-tab"
                          data-testid="customerInfoTab"
                          data-bs-toggle="tab"
                          data-bs-target="#customerinfo"
                          role="tab"
                          aria-controls="Customerinfo-tab"
                          aria-selected="true"
                          onClick={() =>
                            setactivetab({
                              ...activetab,
                              notes: false,
                              history: true,
                            })
                          }
                        >
                          {t("History")}
                        </ListItem>
                      </List>
                    </Box>
                  </Grid>
                  {updatingNotesLoader ? (
                    <div className={classes.Norecords}>
                      <CircularProgress />
                    </div>
                  ) : null}
                  {activetab.notes && !updatingNotesLoader ? (
                    <Grid
                      about="notesContent"
                      style={{
                        width: "100%",
                        minHeight: "150px",
                        marginTop: "40px",
                      }}
                    >
                      {currentappointmentDetails &&
                        currentappointmentDetails.notes &&
                        currentappointmentDetails.notes.map((el: any) => {
                          return (
                            <Grid
                              about="notesHeader"
                              key={el.appointmentNoteId}
                              style={{
                                padding: "1rem",
                                backgroundColor: "aliceblue",
                                marginBottom: "10px",
                              }}
                            >
                              <Grid
                                about="messageDetails"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography style={{ display: "inline-block" }}>
                                  {el.lastModifiedBy}
                                </Typography>   
                                {dateTimeLocalization == 1 ? (
                                  <RACDateTimeLabel
                                    value={el?.lastModifiedDate}
                                    displayType="ShortDateTime12hr"  
                                    country={countryIdentification}
                                  />
                                ) : (
                                   <span>
                                  {moment(el.lastModifiedDate).format(
                                    "MM/DD/YYYY"
                                  )}{" "}
                                  {moment(
                                    el.lastModifiedDate,
                                    "HH:mm:ss"
                                  ).format("hh:mm A")}
                                </span>
                                )} 
                              </Grid>
                              <Grid
                                about="message"
                                style={{ marginTop: "5px" }}
                              >
                                <span style={{ fontWeight: "500" }}>
                                  {el.noteContent}
                                </span>
                              </Grid>
                            </Grid>
                          );
                        })}
                      <Grid
                        about="notesFooter"
                        style={{ width: "100%", padding: "1rem" }}
                      >
                        <Typography>{t("Write a new Note")}</Typography>
                        <Grid
                          about="textFeilds"
                          className={classes.storeEventNots}
                        >
                          <RACTextbox
                            value={storeEventNotes}
                            OnChange={(e: any) => {
                              setStoreEventNotes(e.target.value);
                            }}
                            placeHolder={t("Enter the text here")}
                            className={`${classes.searchSpacing} ${classes.w100} ${classes.mr1}`}
                          />
                          <RACButton
                            type="button"
                            className={`${classes.ms2} ${classes.todayButton}`}
                            color="primary"
                            disabled={
                              storeEventNotes &&
                              storeEventNotes.trim().length !== 0
                                ? false
                                : true
                            }
                            style={{ height: "36px", margin: "0px" }}
                            variant="contained"
                            onClick={() => updateNotesHandler()}
                          >
                            {t("Add")}
                          </RACButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                  {activetab.history && !updatingNotesLoader ? (
                    <Grid>
                      <RACTable
                        renderTableHead={renderAppointmentTableHistoryHeader}
                        renderTableContent={
                          renderAppointmentTableHistoryContent
                        }
                      />
                    </Grid>
                  ) : null}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };
  const StorePickupEventPopup = () => {
    const startTime: any = moment(
      currentappointmentDetails?.timeSlotInfo?.startTime,
      "HH:mm:ss"
    ).format("hh:mm A");
    const endTime: any = moment(
      currentappointmentDetails?.timeSlotInfo?.endTime,
      "HH:mm:ss"
    ).format("hh:mm A");
    currentappointmentDetails?.storePickUpInfo;
    {
      return (
        <Grid item md={12}>
          <Grid
            item
            md={12}
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "45%" }}>
              <Typography>{t("Agreement #")}</Typography>
            </Grid>
            <Grid style={{ width: "30%" }}>
              <Typography>{t("Customer Name")}</Typography>
            </Grid>
            <Grid style={{ width: "25%" }}>
              <Typography>{t("Store Pick-up")}</Typography>
            </Grid>
          </Grid>

          <Grid
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "45%" }}>
              <a
                onClick={() => {
                  pilotStoreParamKey == "1"
                    ? history.push({
                        pathname: `/agreement/info/details/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
                      })
                    : null;
                }}
                className={
                  pilotStoreParamKey == "1"
                    ? classes.customerRaclink
                    : classes.customerRaclinkAcima
                }
              >
                {currentappointmentDetails &&
                  currentappointmentDetails?.agreement?.agreementNumber}
              </a>
            </Grid>
            <Grid style={{ width: "30%" }}>
              <a
                onClick={() => {
                  pilotStoreParamKey == "1"
                    ? history.push({
                        pathname: `/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer`,
                      })
                    : null;
                }}
                className={
                  pilotStoreParamKey == "1"
                    ? classes.customerRaclink
                    : classes.customerRaclinkAcima
                }
              >
                {currentappointmentDetails?.customerInfo?.firstName +
                  ` ` +
                  currentappointmentDetails?.customerInfo?.lastName}
              </a>
            </Grid>
            <Grid className={`${customerSurveyClasses.popUpContent}`}>
              {currentappointmentDetails &&
                (currentappointmentDetails?.storePickUpInfo?.locationNumber
                  ? formatNum(
                      currentappointmentDetails?.storePickUpInfo?.locationNumber
                    )
                  : "")}
              <span className={`${customerSurveyClasses.tabSpace}`}>
                {startTime + `-` + endTime}
              </span>
            </Grid>
          </Grid>

          <Grid
            item
            md={12}
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "45%" }}>
              <Typography>{t("Customer Address")}</Typography>
            </Grid>
            <Grid style={{ width: "30%" }}>
              <Typography>{t("Phone #")}</Typography>
            </Grid>
            <Grid style={{ width: "25%" }}>
              <Typography>{t("Store Address")}</Typography>
            </Grid>
          </Grid>
          <Grid
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "45%" }} className={classes.customerRaclink}>
              <a
                onClick={() => {
                  {
                    currentappointmentDetails?.customerInfo?.address
                      ?.addressLine1
                      ? handleAddressClick()
                      : null;
                  }
                }}
              >
                {currentappointmentDetails &&
                  (currentappointmentDetails?.customerInfo?.address
                    ?.addressLine1
                    ? currentappointmentDetails?.customerInfo?.address
                        ?.addressLine1
                    : "") +
                    " " +
                    (currentappointmentDetails?.customerInfo?.address
                      ?.addressLine2
                      ? currentappointmentDetails?.customerInfo?.address
                          ?.addressLine2
                      : "")}
                {/* //{currentappointmentDetails?.customerInfo?.address?.addressLine2 || ''} */}
                {currentappointmentDetails &&
                  (currentappointmentDetails?.customerInfo?.address?.city ||
                    "")}
              </a>
            </Grid>
            <Grid style={{ width: "30%" }} className={classes.customerRaclink}>
              <a
                onClick={() => {
                  {
                    currentappointmentDetails?.customerInfo?.phoneNumber
                      ? handlePhoneNumberClick()
                      : null;
                  }
                }}
              >
                {currentappointmentDetails &&
                  (currentappointmentDetails?.customerInfo?.phoneNumber
                    ? formatNum(
                        currentappointmentDetails?.customerInfo?.phoneNumber
                      )
                    : "")}
              </a>
            </Grid>
            <Grid className={`${customerSurveyClasses.popUpContent}`}>
              {currentappointmentDetails &&
                (currentappointmentDetails?.storePickUpInfo?.address
                  ?.addressLine1
                  ? currentappointmentDetails?.storePickUpInfo?.address
                      ?.addressLine1
                  : "") +
                  " " +
                  (currentappointmentDetails?.storePickUpInfo?.address
                    ?.addressLine2
                    ? currentappointmentDetails?.storePickUpInfo?.address
                        ?.addressLine2
                    : "")}
            </Grid>
          </Grid>
          <Grid
            className={classes.row}
            style={{ width: "100%", padding: "1px 14px" }}
          >
            <Grid style={{ width: "45%" }}></Grid>
            <Grid style={{ width: "30%" }}></Grid>
            <Grid className={`${customerSurveyClasses.popUpContent}`}>
              {currentappointmentDetails &&
                (currentappointmentDetails?.storePickUpInfo?.address?.city
                  ? currentappointmentDetails?.storePickUpInfo?.address?.city
                  : "")}
            </Grid>
          </Grid>
          <Grid className={classes.racLightBlue} style={{ margin: "10px" }}>
            <RACTable
              renderTableHead={renderAppointmentTableHead}
              renderTableContent={renderAppointmentTableContent}
            />
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Grid style={{ margin: "10px" }}>
              <Typography variant="h5">{t("Coworker required")}</Typography>
              <span>
                {currentappointmentDetails?.appointmentInfo
                  ?.requiredCoworkers || "-"}
              </span>
            </Grid>
          </Grid>
          {currentappointmentDetails &&
          currentappointmentDetails.appointmentInfo.appointmentStatus !==
            "CMP" ? (
            <Grid
              about="footer"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus ==
                "CAN" ? (
                <RACButton
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    setModals({ ...modals, reopenConfirmModal: true })
                  }
                  style={{ marginLeft: "20px" }}
                >
                  {t("Reopen Event")}
                </RACButton>
              ) : currentappointmentDetails &&
                currentappointmentDetails.appointmentInfo.appointmentStatus !=
                  "CMP" ? (
                <>
                  <RACButton
                    variant="outlined"
                    className={classes.unassignBtnClass}
                    onClick={() => cancelOrCompleteStoreEvent("Cancel")}
                  >
                    {t("Cancel Pick-up")}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={() => editPickupEventHandler()}
                    style={{ marginLeft: "20px" }}
                  >
                    {t("Edit Pick-up")}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      setModals({ ...modals, completeConfirmModal: true })
                    }
                    style={{ marginLeft: "20px" }}
                  >
                    {t("Mark As Completed")}
                  </RACButton>{" "}
                </>
              ) : null}
            </Grid>
          ) : null}
          {/* -----------Manual Signature End-------------- */}
          <Grid style={{ width: "100%" }}>
            <Grid container style={{ width: "100%" }}>
              <Card
                className={`${customerStyleClasses.card} ${customerStyleClasses.w100}  ${customerStyleClasses.borderRadiusZero}`}
              >
                <CardContent
                  className={`${classes.headerTab} ${customerStyleClasses.floatLeft} ${customerStyleClasses.w100} ${classes.py0}`}
                  style={{ padding: "0px" }}
                >
                  <Grid
                    item
                    className={`${customerStyleClasses.floatLeft} ${customerStyleClasses.w100}`}
                  >
                    <Box className={customerStyleClasses.floatLeft}>
                      <List
                        className={`${classes.racpadTab} ${classes.py0}`}
                        id="CustTab"
                        role="tabList"
                      >
                        <ListItem
                          className={
                            activetab.notes
                              ? `${classes.navLinkActive} ${classes.navLinkItem}`
                              : `${classes.navLinkItem}`
                          }
                          id="employment-tab"
                          data-testid="employmentInfoTab"
                          data-bs-toggle="tab"
                          data-bs-target="#employmentinfo"
                          role="tab"
                          aria-controls="employment-tab"
                          aria-selected="false"
                          onClick={() =>
                            setactivetab({
                              ...activetab,
                              notes: true,
                              history: false,
                            })
                          }
                        >
                          {t("Notes")}
                        </ListItem>
                        <ListItem
                          className={
                            activetab.history
                              ? `${classes.navLinkActive} ${classes.navLinkItem}`
                              : `${classes.navLinkItem}`
                          }
                          id="Customerinfo-tab"
                          data-testid="customerInfoTab"
                          data-bs-toggle="tab"
                          data-bs-target="#customerinfo"
                          role="tab"
                          aria-controls="Customerinfo-tab"
                          aria-selected="true"
                          onClick={() =>
                            setactivetab({
                              ...activetab,
                              notes: false,
                              history: true,
                            })
                          }
                        >
                          {t("History")}
                        </ListItem>
                      </List>
                    </Box>
                  </Grid>
                  {updatingNotesLoader ? (
                    <div className={classes.Norecords}>
                      <CircularProgress />
                    </div>
                  ) : null}
                  {activetab.notes && !updatingNotesLoader ? (
                    <Grid
                      about="notesContent"
                      style={{
                        width: "100%",
                        minHeight: "150px",
                        marginTop: "40px",
                      }}
                    >
                      {currentappointmentDetails &&
                        currentappointmentDetails.notes &&
                        currentappointmentDetails.notes.map((el: any) => {
                          return (
                            <Grid
                              about="notesHeader"
                              key={el.appointmentNoteId}
                              style={{
                                padding: "1rem",
                                backgroundColor: "aliceblue",
                                marginBottom: "10px",
                              }}
                            >
                              <Grid
                                about="messageDetails"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography style={{ display: "inline-block" }}>
                                  {el.lastModifiedBy}
                                </Typography>
                                {dateTimeLocalization == 1 ? (
                                  <RACDateTimeLabel
                                    value={el?.lastModifiedDate}
                                    displayType="ShortDateTime12hr"  
                                    country={countryIdentification}
                                  />
                                ) : (
                                  <span>
                                  {moment(el.lastModifiedDate).format(
                                    "MM/DD/YYYY"
                                  )}{" "}
                                  {moment(
                                    el.lastModifiedDate,
                                    "HH:mm:ss"
                                  ).format("hh:mm A")}
                                </span>
                                )}
                              </Grid>
                              <Grid
                                about="message"
                                style={{ marginTop: "5px" }}
                              >
                                <span style={{ fontWeight: "500" }}>
                                  {el.noteContent}
                                </span>
                              </Grid>
                            </Grid>
                          );
                        })}
                      <Grid
                        about="notesFooter"
                        style={{ width: "100%", padding: "1rem" }}
                      >
                        <Typography>{t("Write a new Note")}</Typography>
                        <Grid
                          about="textFeilds"
                          className={classes.storeEventNots}
                        >
                          <RACTextbox
                            value={storeEventNotes}
                            OnChange={(e: any) => {
                              setStoreEventNotes(e.target.value);
                            }}
                            placeHolder={t("Enter the text here")}
                            className={`${classes.searchSpacing} ${classes.w100} ${classes.mr1}`}
                          />
                          <RACButton
                            type="button"
                            className={`${classes.ms2} ${classes.todayButton}`}
                            color="primary"
                            disabled={
                              storeEventNotes &&
                              storeEventNotes.trim().length !== 0
                                ? false
                                : true
                            }
                            style={{ height: "36px", margin: "0px" }}
                            variant="contained"
                            onClick={() => updateNotesHandler()}
                          >
                            {t("Add")}
                          </RACButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                  {activetab.history && !updatingNotesLoader ? (
                    <Grid>
                      <RACTable
                        renderTableHead={renderAppointmentTableHistoryHeader}
                        renderTableContent={
                          renderAppointmentTableHistoryContent
                        }
                      />
                    </Grid>
                  ) : null}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      );
    }
  };
  const FieldVisitEventPopup = () => {
      const [isPrintFieldSheetOpen, setIsPrintFieldSheetOpen] = useState(false);
const [isPreviewOpen, setIsPreviewOpen] = useState(false);  
const [fieldSheets, setFieldSheets] = useState<FieldSheet[]>([]); 
const [retentionOffers, setRetentionOffers] = useState<FieldSheetSection6Retention[]>([]);
const [isLoading, setIsLoading] = useState(false);

useEffect(() => {
  const getRetentionOffers = async () => {
    await displayRetentionOffers();
  };
  getRetentionOffers();
}, [currentappointmentDetails?.agreement?.agreementNumber]);

const displayRetentionOffers = async () => {
  const agm = currentappointmentDetails?.agreement?.agreementNumber;
  if (agm && await isRetentionOnForStore()) {
    const offers = await retentionOffersResult([agm]);
    setRetentionOffers(Array.isArray(offers) ? offers : [offers]);
  }
};


const isRetentionOnForStore = async (): Promise<boolean> => {
  let out = false;
  const bodyobj = {
    storeNumbers: [window.sessionStorage.getItem('storeNumber')],
    paramKeyNames: ['CustomerRetention']
  };
  const featureFlag = await featureFlags(bodyobj);
  const reten = featureFlag.data.storeProfileResponse.configDetails[0].configDetails.filter((el: any) => el.paramKeyName === 'CustomerRetention')[0].paramValue;
  if (reten === '1') {
    out = true;
  }
  return out;
};

const retentionOffersResult = async (agms: string[]): Promise<any> => {
  const out = await getRetentionOffers({
    agreementNumbers: agms,
  });
  let filteredOffers = out?.data?.agreementOffers?.[0];

  if (out?.data?.agreementOffers?.length > 1) {
    filteredOffers = out?.data?.agreementOffers?.reduce(
      (latest: any, curr: any) => {
        const date1 = new Date(curr.updateDateTime);
        const date2 = new Date(latest.updateDateTime);
        return (!isNaN(date1.getTime()) && !isNaN(date2.getTime()) && date1 > date2) ? curr : latest;
      }, out?.data?.agreementOffers[0]
    );
  }

  if (filteredOffers) {
    return {
      epoOfferDescription: filteredOffers.epoOfferDescription,
      rateOfferDescription: filteredOffers.rateOfferDescription,
      extensionOfferDescription: filteredOffers.extensionOfferDescription,
      termOfferReduction: filteredOffers.termOfferReduction
    };
  }
  return [];
};

const handlePrintFieldSheetConfirm = async (selectedOption: string, retentionOffers: FieldSheetSection6Retention[], fieldSheets: FieldSheet[]) => {
  try {
    setIsLoading(true);
    setFieldSheets(fieldSheets);
    setIsPrintFieldSheetOpen(false);
    setIsPreviewOpen(true);
  } catch (error) {
    console.log('Error processing field sheets:', error);
  } finally {
    setIsLoading(false);
  }
};

const handlePreviewClose = () => {
  setIsPreviewOpen(false);
};

const handlePreviewSave = () => {
  console.log('Saving field sheets with retention offers:', fieldSheets, retentionOffers);
  setIsPreviewOpen(false);
};
    return (
      <Grid item md={12}>
        <Grid
          item
          md={12}
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Agreement #")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Customer Name")}</Typography>
          </Grid>
        </Grid>

        <Grid
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <a
              onClick={() => {
                pilotStoreParamKey == "1"
                  ? history.push({
                      pathname: `/agreement/info/details/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
                    })
                  : null;
              }}
              className={
                pilotStoreParamKey == "1"
                  ? classes.customerRaclink
                  : classes.customerRaclinkAcima
              }
            >
              {currentappointmentDetails &&
                currentappointmentDetails?.agreement?.agreementNumber}
            </a>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <a
              onClick={() => {
                pilotStoreParamKey == "1"
                  ? history.push({
                      pathname: `/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer`,
                    })
                  : null;
              }}
              className={
                pilotStoreParamKey == "1"
                  ? classes.customerRaclink
                  : classes.customerRaclinkAcima
              }
            >
              {currentappointmentDetails?.customerInfo?.firstName +
                ` ` +
                currentappointmentDetails?.customerInfo?.lastName}
            </a>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Customer Address")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Phone #")}</Typography>
          </Grid>
        </Grid>
        <Grid
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
            <a
              onClick={() => {
                {
                  currentappointmentDetails?.customerInfo?.address?.addressLine1
                    ? handleAddressClick()
                    : null;
                }
              }}
            >
              {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address?.addressLine1
                  ? currentappointmentDetails?.customerInfo?.address
                      ?.addressLine1
                  : "") +
                  " " +
                  (currentappointmentDetails?.customerInfo?.address
                    ?.addressLine2
                    ? currentappointmentDetails?.customerInfo?.address
                        ?.addressLine2
                    : "")}
              {/* //{currentappointmentDetails?.customerInfo?.address?.addressLine2 || ''} */}
              {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address?.city || "")}
            </a>
          </Grid>
          <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
            <a
              onClick={() => {
                {
                  currentappointmentDetails?.customerInfo?.phoneNumber
                    ? handlePhoneNumberClick()
                    : null;
                }
              }}
            >
              {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.phoneNumber
                  ? formatNum(
                      currentappointmentDetails?.customerInfo?.phoneNumber
                    )
                  : "")}
            </a>
          </Grid>
        </Grid>
        <Grid className={classes.racLightBlue} style={{ margin: "10px" }}>
          <RACTable
            renderTableHead={renderAppointmentTableHead}
            renderTableContent={renderAppointmentTableContent}
          />
        </Grid>
        {currentappointmentDetails &&
        currentappointmentDetails.appointmentInfo.appointmentStatus !==
          "CMP" ? (
          <Grid
            about="footer"
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            {currentappointmentDetails &&
            currentappointmentDetails.appointmentInfo.appointmentStatus ==
              "CAN" ? (
              <RACButton
                variant="contained"
                color="primary"
                onClick={() =>
                  setModals({ ...modals, reopenConfirmModal: true })
                }
                style={{ marginLeft: "20px" }}
              >
                {t("Reopen Event")}
              </RACButton>
            ) : currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus !=
                "CMP" ? (
              <>
                <RACButton
                  variant="outlined"
                  className={classes.unassignBtnClass}
                  onClick={() => cancelOrCompleteStoreEvent("Cancel")}
                >
                  {t("Cancel Field Visit")}
                </RACButton>
                <RACButton
                  variant="contained"
                  color="primary"
                  onClick={() => editFieldVisitEventHandler()}
                  style={{ marginLeft: "20px" }}
                >
                  {t("Edit Field Visit")}
                </RACButton>
                  {enableFieldVisitStrategy && (    
                        <RACButton
                          variant="contained"
                          color="primary"
                          onClick={() => setIsPrintFieldSheetOpen(true)}
                          style={{ marginLeft: '20px' }}
                        >
                        {t("View Field Sheet")}
                        </RACButton>
                      )}
          {isPrintFieldSheetOpen && (
            <PrintFieldSheetModal
              customerName={`${currentappointmentDetails?.customerInfo?.firstName} ${currentappointmentDetails?.customerInfo?.lastName}`}
              customerId={currentappointmentDetails?.customerInfo?.customerId}
              retentionOffers={retentionOffers}
              onClose={() => setIsPrintFieldSheetOpen(false)}
              onConfirm={handlePrintFieldSheetConfirm}
            />
          )}
          {isPreviewOpen && (
            <FieldSheetPreview
              fieldSheets={fieldSheets}
              retentionOffers={retentionOffers}
              isLoading={isLoading}
              onClose={handlePreviewClose}
              onSave={handlePreviewSave}
              carInstructions={carInstructions}
            />
          )}{
        isPreviewOpen && (
          <>{console.log(fieldSheets,retentionOffers)}</>
        )
      }
                <RACButton
                  variant="contained"
                  color="primary"
                  onClick={() => handleFieldVisitComplete()}
                  style={{ marginLeft: "20px" }}
                >
                  {t("Mark As Completed")}
                </RACButton>{" "}
              </>
            ) : null}
          </Grid>
        ) : null}
        {/* -----------Manual Signature End-------------- */}
        <Grid style={{ width: "100%" }}>
          <Grid container style={{ width: "100%" }}>
            <Card
              className={`${customerStyleClasses.card} ${customerStyleClasses.w100}  ${customerStyleClasses.borderRadiusZero}`}
            >
              <CardContent
                className={`${classes.headerTab} ${customerStyleClasses.floatLeft} ${customerStyleClasses.w100} ${classes.py0}`}
                style={{ padding: "0px" }}
              >
                <Grid
                  item
                  className={`${customerStyleClasses.floatLeft} ${customerStyleClasses.w100}`}
                >
                  <Box className={customerStyleClasses.floatLeft}>
                    <List
                      className={`${classes.racpadTab} ${classes.py0}`}
                      id="CustTab"
                      role="tabList"
                    >
                      <ListItem
                        className={
                          activetab.instructions
                            ? `${classes.navLinkActive} ${classes.navLinkItem}`
                            : `${classes.navLinkItem}`
                        }
                        id="employment-tab"
                        data-testid="employmentInfoTab"
                        data-bs-toggle="tab"
                        data-bs-target="#employmentinfo"
                        role="tab"
                        aria-controls="employment-tab"
                        aria-selected="false"
                        onClick={() =>
                          setactivetab({
                            ...activetab,
                            instructions: true,
                            notes: false,
                            history: false,
                          })
                        }
                      >
                        {t("CAR Instructions")}
                      </ListItem>
                      <ListItem
                        className={
                          activetab.notes
                            ? `${classes.navLinkActive} ${classes.navLinkItem}`
                            : `${classes.navLinkItem}`
                        }
                        id="employment-tab"
                        data-testid="employmentInfoTab"
                        data-bs-toggle="tab"
                        data-bs-target="#employmentinfo"
                        role="tab"
                        aria-controls="employment-tab"
                        aria-selected="false"
                        onClick={() =>
                          setactivetab({
                            ...activetab,
                            notes: true,
                            instructions: false,
                            history: false,
                          })
                        }
                      >
                        {fieldVisitPhase2 ? t("Offers") : t("Notes")}
                      </ListItem>
                      <ListItem
                        className={
                          activetab.history
                            ? `${classes.navLinkActive} ${classes.navLinkItem}`
                            : `${classes.navLinkItem}`
                        }
                        id="Customerinfo-tab"
                        data-testid="customerInfoTab"
                        data-bs-toggle="tab"
                        data-bs-target="#customerinfo"
                        role="tab"
                        aria-controls="Customerinfo-tab"
                        aria-selected="true"
                        onClick={() =>
                          setactivetab({
                            ...activetab,
                            notes: false,
                            instructions: false,
                            history: true,
                          })
                        }
                      >
                        {t("History")}
                      </ListItem>
                    </List>
                  </Box>
                </Grid>
                {updatingNotesLoader ? (
                  <div className={classes.Norecords}>
                    <CircularProgress />
                  </div>
                ) : null}
                {/* Render Car Instructions when the Instructions tab is active */}
                {activetab.instructions && !updatingNotesLoader ? (
                  <Grid
                    about="instructionsContent"
                    style={{
                      width: "100%",
                      minHeight: "150px",
                      marginTop: "40px",
                    }}
                  >
                    <Typography
                      style={{
                        paddingLeft: "10px",
                      }}
                    >{` ${carInstructions}`}</Typography>
                    {/* Assuming carInstructions is the state variable holding the instructions */}
                  </Grid>
                ) : null}
                {activetab.notes && !updatingNotesLoader ? (
                  <Grid
                    about="notesContent"
                    style={{
                      width: "100%",
                      minHeight: "150px",
                      marginTop: "40px",
                    }}
                  >
                    {currentappointmentDetails &&
                      currentappointmentDetails.notes &&
                      currentappointmentDetails.notes.map((el: any) => {
                        return (
                          <Grid
                            about="notesHeader"
                            key={el.appointmentNoteId}
                            style={{
                              padding: "1rem",
                              backgroundColor: "aliceblue",
                              marginBottom: "10px",
                            }}
                          >
                            <Grid
                              about="messageDetails"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography style={{ display: "inline-block" }}>
                                {el.lastModifiedBy}
                              </Typography>
                             {dateTimeLocalization == 1 ? (
                                  <RACDateTimeLabel
                                    value={el?.lastModifiedDate}
                                    displayType="ShortDateTime12hr"  
                                    country={countryIdentification}
                                  />
                                ) : (
                                  <span>
                                {moment(el.lastModifiedDate).format(
                                  "MM/DD/YYYY"
                                )}{" "}
                                {moment(el.lastModifiedDate, "HH:mm:ss").format(
                                  "hh:mm A")}
                                  </span>
                                )}
                            </Grid>
                            <Grid about="message" style={{ marginTop: "5px" }}>
                              <span style={{ fontWeight: "500" }}>
                                {el.noteContent}
                              </span>
                            </Grid>
                          </Grid>
                        );
                      })}
                    <Grid
                      about="notesFooter"
                      style={{ width: "100%", padding: "1rem" }}
                    >
                      {fieldVisitPhase2 ? (
                        offers
                      ) : (
                        <>
                          <Typography>{t("Write a new Note")}</Typography>
                          <Grid
                            about="textFeilds"
                            className={classes.storeEventNots}
                          >
                            <RACTextbox
                              value={storeEventNotes}
                              OnChange={(e: any) => {
                                setStoreEventNotes(e.target.value);
                              }}
                              placeHolder={t("Enter the text here")}
                              className={`${classes.searchSpacing} ${classes.w100} ${classes.mr1}`}
                            />
                            <RACButton
                              type="button"
                              className={`${classes.ms2} ${classes.todayButton}`}
                              color="primary"
                              disabled={
                                storeEventNotes &&
                                storeEventNotes.trim().length !== 0
                                  ? false
                                  : true
                              }
                              style={{ height: "36px", margin: "0px" }}
                              variant="contained"
                              onClick={() => updateNotesHandler()}
                            >
                              {t("Add")}
                            </RACButton>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Grid>
                ) : null}
                {activetab.history && !updatingNotesLoader ? (
                  <Grid>
                    <RACTable
                      renderTableHead={renderAppointmentTableHistoryHeader}
                      renderTableContent={renderAppointmentTableHistoryContent}
                    />
                  </Grid>
                ) : null}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    );
  };
  const SetSurveyRenewalDateAndAmtQn = () => {
    if (!surveyDetails.renewalDateAndAmtQn) {
      setSurveyDetails({ ...surveyDetails, renewalDateAndAmtQn: true });
    } else {
      setSurveyDetails({ ...surveyDetails, renewalDateAndAmtQn: false });
    }
  };
  const SetSurveyAutoEnrollQn = () => {
    if (!surveyDetails.autoEnrollQn) {
      setSurveyDetails({ ...surveyDetails, autoEnrollQn: true });
    } else {
      setSurveyDetails({ ...surveyDetails, autoEnrollQn: false });
    }
  };
  const SetSurveyTimelyPayments = () => {
    if (!surveyDetails.timelyPayments) {
      setSurveyDetails({ ...surveyDetails, timelyPayments: true });
    } else {
      setSurveyDetails({ ...surveyDetails, timelyPayments: false });
    }
  };

  const CustomerSurveyPopup = () => {
    currentappointmentDetails;
    return (
      <Grid item md={12}>
        <Grid
          item
          md={12}
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid
            className={`${customerSurveyClasses.w100} ${customerSurveyClasses.accordionHeader}`}
          >
            <Typography>{t("Delivery Information")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Agreement #")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Customer Name")}</Typography>
          </Grid>
        </Grid>

        <Grid
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <a
              onClick={() => {
                pilotStoreParamKey == "1"
                  ? history.push({
                      pathname: `/agreement/info/details/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
                    })
                  : null;
              }}
              className={
                pilotStoreParamKey == "1"
                  ? classes.customerRaclink
                  : classes.customerRaclinkAcima
              }
            >
              {currentappointmentDetails &&
                currentappointmentDetails?.agreement?.agreementNumber}
            </a>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <a
              onClick={() => {
                pilotStoreParamKey == "1"
                  ? history.push({
                      pathname: `/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer`,
                    })
                  : null;
              }}
              className={
                pilotStoreParamKey == "1"
                  ? classes.customerRaclink
                  : classes.customerRaclinkAcima
              }
            >
              {currentappointmentDetails?.customerInfo?.firstName +
                ` ` +
                currentappointmentDetails?.customerInfo?.lastName}
            </a>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Customer Address")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Phone")}#</Typography>
          </Grid>
        </Grid>

        <Grid
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
            <a
              onClick={() => {
                {
                  currentappointmentDetails?.customerInfo?.address?.addressLine1
                    ? handleAddressClick()
                    : null;
                }
              }}
            >
              {(currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address
                  ?.addressLine1 || "") +
                  " " +
                  currentappointmentDetails?.customerInfo?.address
                    ?.addressLine2) ||
                ""}
              {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address?.city || "")}
            </a>
          </Grid>
          <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
            <a
              onClick={() => {
                {
                  currentappointmentDetails?.customerInfo?.phoneNumber
                    ? handlePhoneNumberClick()
                    : null;
                }
              }}
            >
              {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.phoneNumber
                  ? formatNum(
                      currentappointmentDetails?.customerInfo?.phoneNumber
                    )
                  : "")}
            </a>
          </Grid>
        </Grid>
        <Grid style={{ margin: "10px", width: "100%" }}>
          <div style={{ width: "100%", float: "left" }}>
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.w100} ${customerSurveyClasses.accordionHeader}`}
              >
                <Typography>{t("Survey Form")}</Typography>
              </Grid>
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.w100} ${customerSurveyClasses.headerLabel}`}
                >
                  {t("Questions")}
                </Typography>
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  1.{" "}
                  {t("Are you 100% satisfied with the product and delivery?")} ({" "}
                  {t("if not, solve immediately")})
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    disabled={surveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setSurveyDetails({
                        ...surveyDetails,
                        productDeliveryQn: e.target.value,
                      });
                    }}
                    checked={surveyDetails.productDeliveryQn === "yes"}
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    defaultValue=""
                    id="inlineRadio2"
                    value="no"
                    disabled={surveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setSurveyDetails({
                        ...surveyDetails,
                        productDeliveryQn: e.target.value,
                      });
                    }}
                    checked={surveyDetails.productDeliveryQn === "no"}
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  2.{" "}
                  {t(
                    "Have we answered all of your questions regarding the rental agreement?"
                  )}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    disabled={surveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setSurveyDetails({
                        ...surveyDetails,
                        rentalAgrQn: e.target.value,
                      });
                    }}
                    checked={surveyDetails.rentalAgrQn === "yes"}
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultValue=""
                    value="no"
                    disabled={surveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setSurveyDetails({
                        ...surveyDetails,
                        rentalAgrQn: e.target.value,
                      });
                    }}
                    checked={surveyDetails.rentalAgrQn === "no"}
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.w100} ${customerSurveyClasses.headerLabel}`}
                >
                  {t("Reinforcements")}
                </Typography>
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  {" "}
                  1. {t("Timely Renewal Payments")}
                </Typography>
                <Grid className={`${customerSurveyClasses.reinforcementGrid}`}>
                  <Grid
                    className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                  >
                    <RACCheckBox
                      checked={surveyDetails.renewalDateAndAmtQn}
                      size={"small"}
                      disabled={surveyDetails.readOnlyMode}
                      onClick={SetSurveyRenewalDateAndAmtQn}
                    />
                    <Typography className={customerSurveyClasses.checkboxLabel}>
                      1.{" "}
                      {t(
                        "Can you tell me when your next renewal is due and the amount you will pay?"
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                  >
                    <RACCheckBox
                      checked={surveyDetails.autoEnrollQn}
                      size={"small"}
                      disabled={surveyDetails.readOnlyMode}
                      onClick={SetSurveyAutoEnrollQn}
                    />
                    <Typography className={customerSurveyClasses.checkboxLabel}>
                      2.{" "}
                      {t(
                        "AutoPay enrollment? If no, explain to them the benefits and close the deal"
                      )}
                      .
                    </Typography>
                  </Grid>
                  <Grid
                    className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline} ${customerSurveyClasses.flex}`}
                  >
                    <RACCheckBox
                      checked={surveyDetails.timelyPayments}
                      size={"small"}
                      disabled={surveyDetails.readOnlyMode}
                      onClick={SetSurveyTimelyPayments}
                    />
                    <Typography className={customerSurveyClasses.checkboxLabel}>
                      3.{" "}
                      {t("Reinforce the importance of timely payments and to contact the store")}{" "}
                      <span
                        style={{
                          color: "#2179FE",
                          fontFamily: "OpenSans-bold",
                        }}
                      >
                        {t("BEFORE payment is due")}
                      </span>{" "}
                      {t("should you have any issue")}{" "}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {EnableRAFSurvey == "1" && (
              <>
                <Grid
                  className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
                >
                  <Grid
                    className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
                  >
                    <Typography
                      className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                    >
                      2.{" "}
                      {t(
                        "Do you know about our Refer a Friend Program?"
                      )}
                      <span style={{ color: "red" }}> *</span>
                    </Typography>
                    <Grid
                      className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                    >
                      <RACRadio
                        name="referFriendProgram"
                        id="referFriendYes"
                        defaultValue=""
                        value="yes"
                        size={"small"}
                        disabled={surveyDetails.readOnlyMode}
                        onClick={(e: any) => {
                          setSurveyDetails({
                            ...surveyDetails,
                            referFriendProgram: e.target.value,
                          });
                        }}
                        checked={surveyDetails.referFriendProgram === "yes"}
                      />
                      <Typography className={customerSurveyClasses.checkboxLabel}>
                        {t("Yes")}
                      </Typography>
                    </Grid>
                    <Grid
                      className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                    >
                      <RACRadio
                        name="referFriendProgram"
                        id="referFriendNo"
                        defaultValue=""
                        value="no"
                        size={"small"}
                        disabled={surveyDetails.readOnlyMode}
                        onClick={(e: any) => {
                          setSurveyDetails({
                            ...surveyDetails,
                            referFriendProgram: e.target.value,
                          });
                        }}
                        checked={surveyDetails.referFriendProgram === "no"}
                      />
                      <Typography className={customerSurveyClasses.checkboxLabel}>
                        {t("No")}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
                >
                  <Grid
                    className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
                  >
                    <Typography
                      className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                    >
                      3.{" "}
                      {t(
                        "Would you like to refer someone now and earn rewards?"
                      )}
                      <span style={{ color: "red" }}> *</span>
                    </Typography>
                    <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                      <Grid
                        className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                      >
                        <RACRadio
                          name="referSomeone"
                          id="referSomeoneYes"
                          defaultValue=""
                          value="yes"
                          size={"small"}
                          disabled={referralLinkSentSuccess || surveyDetails.readOnlyMode}
                          onClick={(e: any) => {
                            setSurveyDetails({
                              ...surveyDetails,
                              referSomeone: e.target.value,
                            });
                          }}
                          checked={surveyDetails.referSomeone === "yes"}
                        />
                        <Typography className={customerSurveyClasses.checkboxLabel}>
                          {t("Yes")}
                        </Typography>
                      </Grid>
                      <Grid
                        className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                      >
                        <RACRadio
                          name="referSomeone"
                          id="referSomeoneNo"
                          defaultValue=""
                          value="no"
                          size={"small"}
                          disabled={referralLinkSentSuccess || surveyDetails.readOnlyMode}
                          onClick={(e: any) => {
                            setSurveyDetails({
                              ...surveyDetails,
                              referSomeone: e.target.value,
                            });
                          }}
                          checked={surveyDetails.referSomeone === "no"}
                        />
                        <Typography className={customerSurveyClasses.checkboxLabel}>
                          {t("No")}
                        </Typography>
                      </Grid>
                      <RACButton
                        variant="contained"
                        color="primary"
                        className={classes.mx1}
                        style={{ marginTop: "-8px" }}
                        disabled={surveyDetails.referSomeone !== "yes" ||
                          referralLinkSentSuccess ||
                          rewardProfileLoading ||
                          !rewardProfileSuccess ||
                          surveyDetails.readOnlyMode}
                        onClick={() => {
                          setShowSendReferralLinkPopup(true);
                        }}
                      >
                        {rewardProfileLoading ? (
                          <CircularProgress size={20} style={{ color: "white" }} />
                        ) : referralLinkSentSuccess ? (
                          t("Referral Link Sent")
                        ) : (
                          t("Send Referral Link")
                        )}
                      </RACButton>
                    </div>
                  </Grid>
                </Grid>
              </>
            )}
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  {EnableRAFSurvey == "1" ? "4." : "2."}{" "}
                  {t(
                    "Do you have any other questions or is there anything I can do for you?"
                  )}
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    size={"small"}
                    disabled={surveyDetails.readOnlyMode}
                    onClick={(e: any) => {
                      setSurveyDetails({
                        ...surveyDetails,
                        anyOtherQns: e.target.value,
                      });
                    }}
                    checked={surveyDetails.anyOtherQns === "yes"}
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultValue=""
                    value="no"
                    size={"small"}
                    disabled={surveyDetails.readOnlyMode}
                    onClick={(e: any) => {
                      setSurveyDetails({
                        ...surveyDetails,
                        anyOtherQns: e.target.value,
                      });
                    }}
                    checked={surveyDetails.anyOtherQns === "no"}
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Typography
                className={`${customerSurveyClasses.headerLabel} ${customerSurveyClasses.w100}`}
              >
                {t("Notes")}
              </Typography>
              <Typography
                className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
              >
                {t("Additional Comments")}
              </Typography>
              <RACTextbox
                maxlength={500}
                placeHolder={t(
                  "Enter the additional comments if you have anything"
                )}
                value={surveyDetails.additionalNotes}
                disabled={surveyDetails.readOnlyMode}
                OnChange={(e: any) => {
                  setSurveyDetails({
                    ...surveyDetails,
                    additionalNotes: e.target.value,
                  });
                }}
              />
            </Grid>
            <Grid
              item
              md={12}
              className={`${classes.pb4} ${classes.px3} ${classes.textRight} ${customerSurveyClasses.buttonsContent}`}
              style={{ marginTop: "100px" }}
            >
              <RACButton
                color="primary"
                variant="outlined"
                className={classes.mx1}
                onClick={() => cancelSurvey()}
              >
                {t("Cancel")}
              </RACButton>
              {surveyDetails.readOnlyMode ? null : (
                <RACButton
                  variant="contained"
                  color="primary"
                  className={classes.mx1}
                  disabled={SurveySave}
                  onClick={() => saveSurveyDetails(surveyDetails)}
                >
                  {t("Save")}
                </RACButton>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
    );
  };

  const AddressVerificationSurveyPopup = () => {
    currentappointmentDetails;
    return (
      <Grid item md={12}>
        <Grid
          item
          md={12}
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid
            className={`${customerSurveyClasses.w100} ${customerSurveyClasses.accordionHeader}`}
          >
            <Typography>{t("Delivery Information")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Agreement")} #</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Customer Name")}</Typography>
          </Grid>
        </Grid>

        <Grid
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <a
              onClick={() => {
                pilotStoreParamKey == "1"
                  ? history.push({
                      pathname: `/agreement/info/details/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
                    })
                  : null;
              }}
              className={
                pilotStoreParamKey == "1"
                  ? classes.customerRaclink
                  : classes.customerRaclinkAcima
              }
            >
              {currentappointmentDetails &&
                currentappointmentDetails?.agreement?.agreementNumber}
            </a>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <a
              onClick={() => {
                pilotStoreParamKey == "1"
                  ? history.push({
                      pathname: `/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer`,
                    })
                  : null;
              }}
              className={
                pilotStoreParamKey == "1"
                  ? classes.customerRaclink
                  : classes.customerRaclinkAcima
              }
            >
              {currentappointmentDetails?.customerInfo?.firstName +
                ` ` +
                currentappointmentDetails?.customerInfo?.lastName}
            </a>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Customer Address")}</Typography>
          </Grid>
          <Grid style={{ width: "50%" }}>
            <Typography>{t("Phone")} #</Typography>
          </Grid>
        </Grid>

        <Grid
          className={classes.row}
          style={{ width: "100%", padding: "1px 14px" }}
        >
          <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
            <a
              onClick={() => {
                {
                  currentappointmentDetails?.customerInfo?.address?.addressLine1
                    ? handleAddressClick()
                    : null;
                }
              }}
            >
                  {addressVerificationSurveyParamKey == '1' ? 
              (
                <>
                {(mxCustomerAddress &&
                 (mxCustomerAddress?.addressLine1 || "") +
                  " " +
                  (mxCustomerAddress?.exteriorNumber || "")+
                  " " +
                  (mxCustomerAddress?.interiorNumber ||"")+
                    " " +
                  (mxCustomerAddress?.addressLine2 ||"")+
                    " " +
                   (mxCustomerAddress?.city ||"")+
                    " " +
                  (mxCustomerAddress?.state ||"")+
                    " " +
                  (mxCustomerAddress?.postalCode || "")) ||
                   ""}

                 
                 </>)
               :(
                 <>
                {(currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address
                  ?.addressLine1 || "") +
                  " " +
                  currentappointmentDetails?.customerInfo?.address
                    ?.addressLine2) ||
                ""}
                 {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.address?.city || "")}
                </>
              )}
            </a>
          </Grid>
          <Grid style={{ width: "50%" }} className={classes.customerRaclink}>
            <a
              onClick={() => {
                {
                  currentappointmentDetails?.customerInfo?.phoneNumber
                    ? handlePhoneNumberClick()
                    : null;
                }
              }}
            >
              {currentappointmentDetails &&
                (currentappointmentDetails?.customerInfo?.phoneNumber
                  ? formatNum(
                      currentappointmentDetails?.customerInfo?.phoneNumber
                    )
                  : "")}
            </a>
          </Grid>
        </Grid>
        <Grid style={{ margin: "10px", width: "100%" }}>
          <div style={{ width: "100%", float: "left" }}>
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.w100} ${customerSurveyClasses.accordionHeader}`}
              >
                <Typography>{t("Survey Form")}</Typography>
              </Grid>
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.w100} ${customerSurveyClasses.headerLabel}`}
                >
                  {t("Questions")}
                </Typography>
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  1. {t("Does the customer live there ?")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        isResident: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.isResident === "yes"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    defaultValue=""
                    id="inlineRadio2"
                    value="no"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        isResident: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.isResident === "no"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  2.{" "}
                  {t(
                    "Did you find any situations that could put the product or collection visits at risk ?"
                  )}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        riskAssessmentFound: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.riskAssessmentFound ===
                      "yes"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultValue=""
                    value="no"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        riskAssessmentFound: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.riskAssessmentFound ===
                      "no"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  3.{" "}
                  {t("Does it have basic utilities ? (Water and electricity)")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        utilitiesAvailability: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.utilitiesAvailability ===
                      "yes"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultValue=""
                    value="no"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        utilitiesAvailability: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.utilitiesAvailability ===
                      "no"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Grid
                className={`${customerSurveyClasses.colMD12} ${customerSurveyClasses.floatStart}`}
              >
                <Typography
                  className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100}`}
                >
                  4.{" "}
                  {t(
                    "Are there any negative comments from the neighbors (troublesome person, doesn't pay on time) ?"
                  )}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    defaultValue=""
                    value="yes"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        neighborConcern: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.neighborConcern === "yes"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("Yes")}
                  </Typography>
                </Grid>
                <Grid
                  className={`${customerSurveyClasses.formCheck} ${customerSurveyClasses.formCheckInline}`}
                >
                  <RACRadio
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    defaultValue=""
                    value="no"
                    disabled={addressVerificationSurveyDetails.readOnlyMode}
                    size={"small"}
                    onClick={(e: any) => {
                      setAddressVerificationSurveyDetails({
                        ...addressVerificationSurveyDetails,
                        neighborConcern: e.target.value,
                      });
                    }}
                    checked={
                      addressVerificationSurveyDetails.neighborConcern === "no"
                    }
                  />
                  <Typography className={customerSurveyClasses.checkboxLabel}>
                    {t("No")}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>

            <Grid
              className={`${customerSurveyClasses.w100} ${customerSurveyClasses.floatStart}`}
            >
              <Typography className={` ${customerSurveyClasses.w100}`}>
                <span className={customerSurveyClasses.headerLabel}>
                  {t("Note : ")}{" "}
                </span>
                {t(
                  "If the delivery is not completed, there is no need to fill out the previous questions. Please use this field to explain why the delivery was NOT made."
                )}
              </Typography>
              <Typography
                className={`${customerSurveyClasses.formLabel} ${customerSurveyClasses.w100} ${customerSurveyClasses.commentsField}`}
              >
                {t("Coworker Comments")}
              </Typography>

              <RACTextbox
                maxlength={500}
                value={addressVerificationSurveyDetails.additionalNotes}
                disabled={addressVerificationSurveyDetails.readOnlyMode}
                OnChange={(e: any) => {
                  setAddressVerificationSurveyDetails({
                    ...addressVerificationSurveyDetails,
                    additionalNotes: e.target.value,
                  });
                }}
              />
            </Grid>

            <Grid
              item
              md={12}
              className={`${classes.pb4} ${classes.px3} ${classes.textRight} ${customerSurveyClasses.buttonsContent}`}
              style={{ marginTop: "100px" }}
            >
              <RACButton
                color="primary"
                variant="outlined"
                className={classes.mx1}
                onClick={() => cancelAddressSurvey()}
              >
                {t("Cancel")}
              </RACButton>
              {addressVerificationSurveyDetails.readOnlyMode ? null : (
                <RACButton
                  variant="contained"
                  color="primary"
                  className={classes.mx1}
                  disabled={AddressSurveySave}
                  onClick={() =>
                    saveAddressSurveyDetails(addressVerificationSurveyDetails)
                  }
                >
                  {t("Save")}
                </RACButton>
              )}
            </Grid>
          </div>
        </Grid>
      </Grid>
    );
  };

  const cancelSurvey = async () => {
    setToShowCustomerSurveyForm(false);
    setReferralLinkSentSuccess(false);
    setloader(true);
    await pageLoad(filterStateData?.date);
    setloader(false);
  };

  const cancelAddressSurvey = async () => {
    setToShowAddressSurveyForm(false);
    setloader(true);
    await pageLoad(filterStateData?.date);
    setloader(false);
  };

  const saveSurveyDetails = async (surveyDetails: any) => {
    try {
      setloader(true);
      currentappointmentDetails;
      const currentTime = new Date();
      let userIdValue = "";
      if (!EmpolyeeId) {
        const coWorkerDetailsObj: any = await getmenuandstore();
        userIdValue = coWorkerDetailsObj?.data?.coworkerProfile?.employeeId;
        setEmpolyeeId(userIdValue);
      }
      const bodyobj = {
        agreementId:
          currentappointmentDetails &&
          currentappointmentDetails?.agreement?.agreementId.toString(),
        managerUserId: EmpolyeeId ? EmpolyeeId : userIdValue,
        surveyDate: currentTime,
        notes: surveyDetails.additionalNotes,
        reinforcements: {
          autopayDiscussed: surveyDetails.autoEnrollQn ? "1" : "0",
          renewalDiscussed: surveyDetails.renewalDateAndAmtQn ? "1" : "0",
          paymentsDiscussed: surveyDetails.timelyPayments ? "1" : "0",
        },
        questionsAsked: {
          deliveryOnTime: surveyDetails.productDeliveryQn === "yes" ? "1" : "0",
          questionsAnswered: surveyDetails.rentalAgrQn === "yes" ? "1" : "0",
          otherQuestions: surveyDetails.anyOtherQns === "yes" ? "1" : "0",
          referralProgram: surveyDetails.referFriendProgram === "yes" ? "1" : "0",
        },
      };
      const response = await saveSurveyForm(bodyobj);
      if (response?.status == 200) {
        // now we log the activity
        await logWorkedHistory({
          storeNumber: sessionStorage.getItem("storeNumber") || "",
          customerId: Number(
            currentappointmentDetails?.customerInfo?.customerId
          ),
          agreementId:
            currentappointmentDetails &&
            currentappointmentDetails?.agreement?.agreementId.toString(),
          acctActivityRefCode: "CUSTSURV",
          notes: "Completed Survey",
          coWorkerId: EmpolyeeId ? EmpolyeeId : userIdValue,
          activityDate: new Date().toISOString(),
        });

        setToShowSurvey(false);
        setReadOnlySurvey(true);
        setOpenSurveySaveSuccessPopup(true);
      } else {
        setSurveyError(true);
      }
      setloader(false);
    } catch (e: any) {
      setloader(false);
      setSurveyError(true);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };

  const saveAddressSurveyDetails = async (
    addressVerificationSurveyDetails: any
  ) => {
    try {
      setloader(true);
      currentappointmentDetails;
      const currentTime = new Date();
      let userIdValue = "";
      if (!EmpolyeeId) {
        const coWorkerDetailsObj: any = await getmenuandstore();

        userIdValue = coWorkerDetailsObj?.data?.coworkerProfile?.employeeId;
        setEmpolyeeId(userIdValue);
      }
      const bodyobj = {
        agreementId:
          currentappointmentDetails &&
          currentappointmentDetails?.agreement?.agreementId.toString(),
        managerUserId: EmpolyeeId ? EmpolyeeId : userIdValue,
        surveyDate: currentTime,
        notes: addressVerificationSurveyDetails.additionalNotes,
        addressVerification: {
          isResident:
            addressVerificationSurveyDetails.isResident === "yes" ? "1" : "0",
          riskAssessmentFound:
            addressVerificationSurveyDetails.riskAssessmentFound === "yes"
              ? "1"
              : "0",
          utilitiesAvailability:
            addressVerificationSurveyDetails.utilitiesAvailability === "yes"
              ? "1"
              : "0",
          neighborConcern:
            addressVerificationSurveyDetails.neighborConcern === "yes"
              ? "1"
              : "0",
        },
      };
      console.log("bodyobject", bodyobj);
      const response = await saveSurveyForm(bodyobj);
      if (response?.status == 200) {
        setToShowAddressSurvey(false);
        setReadOnlyAddressSurvey(true);
        setOpenSurveySaveSuccessPopup(true);
      } else {
        setSurveyError(true);
      }
      setloader(false);
    } catch (e: any) {
      setloader(false);
      setSurveyError(true);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };

  const SurveySavedSuccess = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={`${classes.popupText} ${classes.mt3}`}>
            {t("Feedback Saved Successfully")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={SurveySavedOk}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };

  const SurveryErrorPopup = () => {
    const message =
      customerSurveyParamKey === "1"
        ? t("Customer Survey is not saved")
        : addressVerificationSurveyParamKey === "1"
        ? t("Address Survey is not saved")
        : "";
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Alert></Alert>
          <Typography className={`${classes.popupText} ${classes.mt3}`}>
            {t(message)}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setSurveyError(false);
            }}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const SurveySavedOk = async () => {
    setEnableDeliveryPopup(false);
    setOpenSurveySaveSuccessPopup(false);
    setToShowCustomerSurveyForm(false);
    setloader(true);
    window.location.reload();
    await pageLoad(filterStateData?.date);
    setloader(false);
  };
  const errorMessagePopup = () => {
    return (
      <div
        id="initialpayment"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <Grid className={classes.textCenter}>
          <Alert></Alert>
          <Typography className={classes.formLabel}>
            {serviceErrorMsg}
          </Typography>
        </Grid>
        <Grid
          item
          md={12}
          className={`${classes.mt3} ${classes.pb4} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setEnableDeliveryPopup(false);
              setModals({
                ...modals,
                expandIconClicked: false,
                timeSlotExceedModal: false,
              });
              seterrorMessagePopupOpen(false);
            }}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  function HandleRePrintModalCard() {
    return (
      <RACModalCard
        isOpen={reprintPopUp}
        maxWidth="xs"
        borderRadius="20px"
        // eslint-disable-next-line react/no-children-prop
        children={RePrintPopup()}
        title={t("Re-Print Pickup Checklist")}
        TitleVariantClassName={classes.popUpFont}
      />
    );
  }
  const StoreEventModal = () => {
    return (
      <>
        <Grid style={{ width: "100%" }}>
          <Grid about="body" style={{ width: "100%" }}>
            <Grid
              about="content"
              style={{ height: "auto", marginBottom: "10px" }}
            >
              <Grid style={{ width: "100%", display: "flex" }}>
                <Grid style={{ width: "50%" }}>
                  <Grid style={{ margin: "10px" }}>
                    <Typography variant="h5">{t("Title")}</Typography>
                    <span>
                      {currentappointmentDetails?.appointmentInfo?.title || ""}
                    </span>
                  </Grid>
                </Grid>
                <Grid style={{ width: "50%" }}>
                  <Grid style={{ margin: "10px" }}>
                    <Typography variant="h5">{t("Description")}</Typography>
                    <span>
                      {currentappointmentDetails?.appointmentInfo
                        ?.instructions || ""}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid style={{ width: "100%", display: "flex" }}>
                <Grid style={{ width: "50%" }}>
                  <Grid style={{ margin: "10px" }}>
                    <Typography variant="h5">
                      {t("Coworker required")}
                    </Typography>
                    <span>
                      {currentappointmentDetails?.appointmentInfo
                        ?.requiredCoworkers || "-"}
                    </span>
                  </Grid>
                </Grid>

                {currentappointmentDetails &&
                currentappointmentDetails.appointmentInfo.appointmentStatus ==
                  "CMP" ? (
                  <Grid style={{ width: "50%" }}>
                    <Grid style={{ margin: "10px" }}>
                      <Typography variant="h5">{t("Status")}</Typography>
                      <span>{t("Completed")}</span>
                    </Grid>
                  </Grid>
                ) : null}
              </Grid>
            </Grid>
            {/* {currentappointmentDetails && currentappointmentDetails.appointmentInfo.appointmentStatus !== 'CMP' ?  */}

            <Grid
              about="footer"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {currentappointmentDetails &&
              currentappointmentDetails.appointmentInfo.appointmentStatus ==
                "CAN" ? (
                <RACButton
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    setModals({ ...modals, reopenConfirmModal: true })
                  }
                  style={{ marginLeft: "20px" }}
                >
                  {t("Reopen Event")}
                </RACButton>
              ) : currentappointmentDetails &&
                currentappointmentDetails.appointmentInfo.appointmentStatus !=
                  "CMP" ? (
                <>
                  <RACButton
                    variant="outlined"
                    className={classes.unassignBtnClass}
                    onClick={() => cancelOrCompleteStoreEvent("Cancel")}
                  >
                    {t("Cancel Event")}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={() => editStoreEventHandler()}
                    style={{ marginLeft: "20px" }}
                  >
                    {t("Edit Event")}
                  </RACButton>
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      setModals({ ...modals, completeConfirmModal: true })
                    }
                    style={{ marginLeft: "20px" }}
                  >
                    {t("Mark As Completed")}
                  </RACButton>{" "}
                </>
              ) : null}
            </Grid>
            {/* : null} */}
          </Grid>
          <Grid style={{ width: "100%" }}>
            <Grid container style={{ width: "100%" }}>
              <Card
                className={`${customerStyleClasses.card} ${customerStyleClasses.w100}  ${customerStyleClasses.borderRadiusZero}`}
              >
                <CardContent
                  className={`${classes.headerTab} ${customerStyleClasses.floatLeft} ${customerStyleClasses.w100} ${classes.py0}`}
                  style={{ padding: "0px" }}
                >
                  <Grid
                    item
                    className={`${customerStyleClasses.floatLeft} ${customerStyleClasses.w100}`}
                  >
                    <Box className={customerStyleClasses.floatLeft}>
                      <List
                        className={`${classes.racpadTab} ${classes.py0}`}
                        id="CustTab"
                        role="tabList"
                      >
                        <ListItem
                          className={
                            activetab.notes
                              ? `${classes.navLinkActive} ${classes.navLinkItem}`
                              : `${classes.navLinkItem}`
                          }
                          id="employment-tab"
                          data-testid="employmentInfoTab"
                          data-bs-toggle="tab"
                          data-bs-target="#employmentinfo"
                          role="tab"
                          aria-controls="employment-tab"
                          aria-selected="false"
                          onClick={() =>
                            setactivetab({
                              ...activetab,
                              notes: true,
                              history: false,
                            })
                          }
                        >
                          {t("Notes")}
                        </ListItem>
                        <ListItem
                          className={
                            activetab.history
                              ? `${classes.navLinkActive} ${classes.navLinkItem}`
                              : `${classes.navLinkItem}`
                          }
                          id="Customerinfo-tab"
                          data-testid="customerInfoTab"
                          data-bs-toggle="tab"
                          data-bs-target="#customerinfo"
                          role="tab"
                          aria-controls="Customerinfo-tab"
                          aria-selected="true"
                          onClick={() =>
                            setactivetab({
                              ...activetab,
                              notes: false,
                              history: true,
                            })
                          }
                        >
                          {t("History")}
                        </ListItem>
                      </List>
                    </Box>
                  </Grid>
                  {updatingNotesLoader ? (
                    <div className={classes.Norecords}>
                      <CircularProgress />
                    </div>
                  ) : null}
                  {activetab.notes && !updatingNotesLoader ? (
                    <Grid
                      about="notesContent"
                      style={{
                        width: "100%",
                        minHeight: "150px",
                        marginTop: "40px",
                      }}
                    >
                      {currentappointmentDetails &&
                        currentappointmentDetails.notes &&
                        currentappointmentDetails.notes.map((el: any) => {
                          return (
                            <Grid
                              about="notesHeader"
                              key={el.appointmentNoteId}
                              style={{
                                padding: "1rem",
                                backgroundColor: "aliceblue",
                                marginBottom: "10px",
                              }}
                            >
                              <Grid
                                about="messageDetails"
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Typography style={{ display: "inline-block" }}>
                                  {el.lastModifiedBy}
                                </Typography>
                                {dateTimeLocalization == 1 ? (
                                  <RACDateTimeLabel
                                    value={el?.lastModifiedDate}
                                    displayType="ShortDateTime12hr"  
                                    country={countryIdentification}
                                  />
                                ) : (
                                  <span>
                                    {moment(el?.lastModifiedDate).format("MM/DD/YYYY")}{" "}
                                    {moment(el.lastModifiedDate,
                                    "HH:mm:ss"
                                  ).format("hh:mm A")}
                                </span>
                                )}
                              </Grid>
                              <Grid
                                about="message"
                                style={{ marginTop: "5px" }}
                              >
                                <span style={{ fontWeight: "500" }}>
                                  {el.noteContent}
                                </span>
                              </Grid>
                            </Grid>
                          );
                        })}
                      <Grid
                        about="notesFooter"
                        style={{ width: "100%", padding: "1rem" }}
                      >
                        <Typography>{t("Write a new Note")}</Typography>
                        <Grid
                          about="textFeilds"
                          className={classes.storeEventNots}
                        >
                          <RACTextbox
                            value={storeEventNotes}
                            placeHolder={t("Enter the text here")}
                            OnChange={(e: any) => {
                              setStoreEventNotes(e.target.value);
                            }}
                            className={`${classes.searchSpacing} ${classes.w100} ${classes.mr1}`}
                          />
                          <RACButton
                            type="button"
                            className={`${classes.ms2} ${classes.todayButton}`}
                            color="primary"
                            disabled={
                              storeEventNotes &&
                              storeEventNotes.trim().length !== 0
                                ? false
                                : true
                            }
                            style={{ height: "36px", margin: "0px" }}
                            variant="contained"
                            onClick={() => updateNotesHandler()}
                          >
                            {t("Add")}
                          </RACButton>
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                  {activetab.history && !updatingNotesLoader ? (
                    <Grid>
                      <RACTable
                        renderTableHead={renderAppointmentTableHistoryHeader}
                        renderTableContent={
                          renderAppointmentTableHistoryContent
                        }
                      />
                    </Grid>
                  ) : null}
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </>
    );
  };
  function isCurrentTimeInTimeSlot(timeSlotObj: any) {
    const currentTime = moment(); // Get current time
    const startTime = moment(timeSlotObj.startTime, "HH:mm:ss");
    const endTime = moment(timeSlotObj.endTime, "HH:mm:ss");

    return currentTime.isBetween(startTime, endTime);
  }
  const RePrintPopup = () => {
    return (
      <div>
        <Grid container spacing={2} className={classes.p3}>
          <Grid item md={12}>
            {/* <Images className={classes.me2}></Images> */}
            <Typography variant="caption" className={classes.formLabel}>
              {/* {isReturnStart || returnReschedule */}
              {/* ?  */}
              {t("Pickup Receipt")}
              {/* :
                       'Delivery Receipt' */}
              {/* } */}
            </Typography>
            <RACButton
              className={classes.agrPrintDoc}
              onClick={() => {
                //   isReturnStart || returnReschedule
                // ?
                printHTML(document.getElementById("pickupreciptPrintHTML"));
                // : printHTML(
                //     document.getElementById('DeliveryReceiptrentalPrintHTML')
                //   );
              }}
            >
              {t("View")}
            </RACButton>
          </Grid>
          <Grid item md={12}>
            {/* <PDFImage className={classes.me2}></PDFImage> */}
            <Typography variant="caption" className={classes.formLabel}>
              {/* {isReturnStart || returnReschedule
                      ?  */}
              {t("Pickup Checklist")}
              {/* :
                       'Delivery Checklist'} */}
            </Typography>
            <RACButton
              className={classes.agrPrintDoc}
              onClick={
                () =>
                  //   isReturnStart || returnReschedule
                  //     ?
                  printHTML(document.getElementById("pickupchecklistprintHTML"))
                // :
                // printHTML(
                //     document.getElementById('DeliveryChecklistrentalPdf')
                //   )
              }
            >
              {t("View")}
            </RACButton>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={`${classes.pb4pp} ${classes.px3pp} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1pp}
            variant="contained"
            color="primary"
            onClick={() => Ok_Popup()}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const handleRePrintDelivery = async () => {
    setloader(true);
    setEnableDeliveryPopup(false);
    if (agreementValues?.agreementSign == "0") {
      const apiResponse: any = await CheckSign(agreementValues?.agreementId);
      if (apiResponse?.data?.isSigned == "0") {
        setisManualAgreementSigned(true);
        SetCheckforSign(true);
        setloader(false);
      } else {
        if (
          currentappointmentDetails.appointmentInfo.appointmentType == "P" ||
          currentappointmentDetails.appointmentInfo.appointmentType == "CI"
        ) {
          await agreementsignedmethod("3");
        } else {
          await agreementsignedmethod();
        }
      }
    } else {
      if (!isManualAgreementSigned) {
        if (
          currentappointmentDetails.appointmentInfo.appointmentType == "P" ||
          currentappointmentDetails.appointmentInfo.appointmentType == "CI"
        ) {
          await agreementsignedmethod("3");
        } else {
          await agreementsignedmethod();
        }
      }
    }
    // setloader(false)

    // setReprintPopUp(true);
  };
  const UpdateInfoMsgPopup = () => {
    return (
      <Grid item md={12}>
        <Grid item md={12} className={classes.textCenter}>
          <Alerticon></Alerticon>
          <Typography
            variant={"body2"}
            className={`${classes.my3} ${classes.RACPOPMsg}`}
          >
            {t("Something went wrong")}
          </Typography>
        </Grid>
        <Grid
          item
          className={`${classes.textCenter} ${classes.mt4} ${classes.w100}`}
        >
          <RACButton
            variant="contained"
            color="primary"
            onClick={() => setModals({ ...modals, apiErrorInfoMsg: false })}
          >
            {t("Ok")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const getFontBackgroundColour = (
    appointmentStatus: any,
    appointmentEndTime: any
  ) => {
    const currentTime = new Date();
    const targetDateTime = new Date(appointmentEndTime);
    const isCurrentTimeGreaterThanTarget = currentTime > targetDateTime;
    if (appointmentStatus == "CAN") {
      return {
        fontColor: "#5a5a5a",
        backgroundColor: "#f6f6f6",
      };
    }
    if (appointmentStatus == "CMP") {
      return {
        fontColor: "#539b4d",
        backgroundColor: "#f7fff7",
      };
    }
    if (isCurrentTimeGreaterThanTarget) {
      return {
        fontColor: "#cc1f1f",
        backgroundColor: "#fff1ef",
      };
    }
    if (!isCurrentTimeGreaterThanTarget) {
      return {
        fontColor: "#2e31be",
        backgroundColor: "#f4f7ff",
      };
    }
  };
  const getBatchColorByappointmentType = (appointmentType: any) => {
    if (appointmentType == "CI" || appointmentType == "CO") {
      return "#26c0c7";
    }
    if (appointmentType == "D") {
      return "#ff77ad";
    }
    if (appointmentType == "P") {
      return "#ff77ad";
    }
    if (
      appointmentType == "S" ||
      appointmentType == "SCI" ||
      appointmentType == "SCO" ||
      appointmentType == "SD" ||
      appointmentType == "SP"
    ) {
      return "#ffcb7b";
    }
    if (appointmentType == "SO") {
      return "#5DBB6E";
    }
    if (appointmentType == "SE") {
      return "#ff77ad";
    }
    if (appointmentType == "STOPIC") {
      return "#9933ff";
    }
    if (appointmentType == "FIELD") {
      return "#96daeb";
    }
    return "#26c0c7";
  };
  const UploadeDocLoaderFn = async () => {
    setloader(true);
  };
  const generateReceiptFn = async (generatereceiptpayload: any) => {
    setloader(true);
    console.log("view payload", generatereceiptpayload);
    let deliveryReceiptElement: any;
    let deliveryChecklistElement: any;
    let deliveryaddendumElement: any;
    let pickupReceiptElement: any;
    let pickChecklistElement: any;
    const serviceTypes: any = ["SCI", "SP", "S"];
    const UploadeDocLoaderRes = await UploadeDocLoaderFn();

    // Rental document Delivery Receipt and delivery checklist
    if (
      !generatereceiptpayload?.action &&
      !serviceTypes.includes(
        currentappointmentDetails?.appointmentInfo?.appointmentType
      )
    ) {
      deliveryReceiptElement = document.getElementById(
        "DeliveryReceiptrentalPrintHTML"
      );
      deliveryChecklistElement = document.getElementById(
        "DeliveryChecklistrentalPdf"
      );
    }
    // Return Documnet Pick receipt and Pick check list
    else if (
      generatereceiptpayload?.action == 3 ||
      serviceTypes.includes(
        currentappointmentDetails?.appointmentInfo?.appointmentType
      )
    ) {
      deliveryReceiptElement = document.getElementById("pickupreciptPrintHTML");
      deliveryChecklistElement = document.getElementById(
        "pickupchecklistprintHTML"
      );
    }
    // customer order agreement
    else if (generatereceiptpayload?.action == 2) {
      deliveryReceiptElement = document.getElementById(
        "DeliveryReceiptrentalPrintHTML"
      );
      deliveryChecklistElement = document.getElementById(
        "DeliveryChecklistrentalPdf"
      );
      deliveryaddendumElement = document.getElementById("deliveryaddendum");
    }
    //  Switch out agreement
    else if (generatereceiptpayload?.action == 1) {
      deliveryReceiptElement = document.getElementById(
        "DeliveryReceiptPrintHTML"
      );
      deliveryChecklistElement = document.getElementById(
        "DeliveryChecklistPdf"
      );
      pickupReceiptElement = document.getElementById("pickupreciptPrintHTML");
      pickChecklistElement = document.getElementById(
        "pickupchecklistprintHTML"
      );
    }

    if (
      !generatereceiptpayload?.action ||
      generatereceiptpayload?.action == 3
    ) {
      html2pdf()
        .from(deliveryReceiptElement)
        .outputPdf("blob")
        .then((pdfBlob) => {
          const DRreader: any = new FileReader();
          console.log("reader deliveryReceipt", DRreader);
          DRreader.onloadend = async () => {
            console.log("after Reader deliveryReceipt", DRreader);
            const b64DeliveryReceipt = DRreader?.result.split(",")[1];
            //delivery check list flow
            html2pdf()
              .from(deliveryChecklistElement)
              .outputPdf("blob")
              .then((pdfBlob) => {
                const CLreader: any = new FileReader();
                console.log("reader deliveryChecklist", CLreader);
                CLreader.onloadend = async () => {
                  console.log("after Reader deliveryReceipt", CLreader);
                  const b64DeliveryCheckList = CLreader?.result.split(",")[1];
                  makeUploadDocument(
                    b64DeliveryReceipt,
                    b64DeliveryCheckList,
                    generatereceiptpayload?.action
                  );
                };
                CLreader.readAsDataURL(pdfBlob);
              });
            //end of check list flow
          };
          DRreader.readAsDataURL(pdfBlob);
        });
    } else if (generatereceiptpayload?.action == 1) {
      html2pdf()
        .from(deliveryReceiptElement)
        .outputPdf("blob")
        .then((pdfBlob) => {
          const DRreader: any = new FileReader();
          console.log("reader deliveryReceipt", DRreader);
          DRreader.onloadend = async () => {
            console.log("after Reader deliveryReceipt", DRreader);
            const b64DeliveryReceipt = DRreader?.result.split(",")[1];
            //delivery check list flow
            html2pdf()
              .from(deliveryChecklistElement)
              .outputPdf("blob")
              .then((pdfBlob) => {
                const CLreader: any = new FileReader();
                console.log("reader deliveryChecklist", CLreader);
                CLreader.onloadend = async () => {
                  console.log("after Reader deliveryReceipt", CLreader);
                  const b64DeliveryCheckList = CLreader?.result.split(",")[1];
                  html2pdf()
                    .from(pickupReceiptElement)
                    .outputPdf("blob")
                    .then((pdfBlob) => {
                      const PRreader: any = new FileReader();
                      console.log("reader deliveryReceipt", PRreader);
                      PRreader.onloadend = async () => {
                        console.log("after Reader deliveryReceipt", PRreader);
                        const b64PickUpReceipt = PRreader?.result.split(",")[1];
                        html2pdf()
                          .from(pickChecklistElement)
                          .outputPdf("blob")
                          .then((pdfBlob) => {
                            const PCreader: any = new FileReader();
                            console.log("reader deliveryReceipt", PCreader);
                            PCreader.onloadend = async () => {
                              console.log(
                                "after Reader deliveryReceipt",
                                PCreader
                              );
                              const b64PickupCheckList =
                                PCreader?.result.split(",")[1];
                              makeUploadDocument(
                                b64DeliveryReceipt,
                                b64DeliveryCheckList,
                                1,
                                "",
                                b64PickUpReceipt,
                                b64PickupCheckList
                              );
                            };
                            PCreader.readAsDataURL(pdfBlob);
                            //
                          });
                      };
                      PRreader.readAsDataURL(pdfBlob);
                      //
                    });
                };
                CLreader.readAsDataURL(pdfBlob);
              });
            //end of check list flow
          };
          DRreader.readAsDataURL(pdfBlob);
        });
    } else {
      html2pdf()
        .from(deliveryReceiptElement)
        .outputPdf("blob")
        .then((pdfBlob) => {
          const DRreader: any = new FileReader();
          console.log("reader deliveryReceipt", DRreader);
          DRreader.onloadend = async () => {
            console.log("after Reader deliveryReceipt", DRreader);
            const b64DeliveryReceipt = DRreader?.result.split(",")[1];
            //delivery check list flow
            html2pdf()
              .from(deliveryChecklistElement)
              .outputPdf("blob")
              .then((pdfBlob) => {
                const CLreader: any = new FileReader();
                console.log("reader deliveryChecklist", CLreader);
                CLreader.onloadend = async () => {
                  console.log("after Reader deliveryReceipt", CLreader);
                  const b64DeliveryCheckList = CLreader?.result.split(",")[1];
                  html2pdf()
                    .from(deliveryaddendumElement)
                    .outputPdf("blob")
                    .then((pdfBlob) => {
                      const DAreader: any = new FileReader();
                      console.log("reader deliveryReceipt", DAreader);
                      DAreader.onloadend = async () => {
                        console.log("after Reader deliveryReceipt", DAreader);
                        const b64DeliveryAddendumReceipt =
                          DAreader?.result.split(",")[1];
                        makeUploadDocument(
                          b64DeliveryReceipt,
                          b64DeliveryCheckList,
                          generatereceiptpayload?.action,
                          b64DeliveryAddendumReceipt
                        );
                      };
                      DAreader.readAsDataURL(pdfBlob);
                      //
                    });
                };
                CLreader.readAsDataURL(pdfBlob);
              });
            //end of check list flow
          };
          DRreader.readAsDataURL(pdfBlob);
        });
    }
  };
  const makeUploadDocument = async (
    deliveryReceiptFile?: any,
    deliveryCheckListFile?: any,
    type?: any,
    deliveryAddendumFile?: any,
    pickupReceiptFile?: any,
    pickupChecklistFile?
  ) => {
    setloader(true);
    let uploadDeliveryReceiptPayload: any;
    if (!type) {
      uploadDeliveryReceiptPayload = {
        agreementId: Number(currentappointmentDetails?.agreement?.agreementId),
        documents: [
          {
            documentType: "DLRCT",
            file: deliveryReceiptFile,
          },
          {
            documentType: "DCL",
            file: deliveryCheckListFile,
          },
        ],
      };
    } else if (type == 3) {
      uploadDeliveryReceiptPayload = {
        action: 3,
        agreementId: Number(currentappointmentDetails?.agreement?.agreementId),
        documents: [
          {
            documentType: "PKRCT",
            file: deliveryReceiptFile,
          },
          {
            documentType: "PCL",
            file: deliveryCheckListFile,
          },
        ],
      };
    } else if (type == 2) {
      uploadDeliveryReceiptPayload = {
        action: 2,
        agreementId: Number(currentappointmentDetails?.agreement?.agreementId),
        documents: [
          {
            documentType: "DLRCT",
            file: deliveryReceiptFile,
          },
          {
            documentType: "DCL",
            file: deliveryCheckListFile,
          },
          {
            documentType: "DELAD",
            file: deliveryAddendumFile,
          },
        ],
      };
    } else if (type == 1) {
      uploadDeliveryReceiptPayload = {
        action: 1,
        agreementId: Number(currentappointmentDetails?.agreement?.agreementId),
        documents: [
          {
            documentType: "DLRCT",
            file: deliveryReceiptFile,
          },
          {
            documentType: "DCL",
            file: deliveryCheckListFile,
          },
          {
            documentType: "PKRCT",
            file: pickupReceiptFile,
          },
          {
            documentType: "PCL",
            file: pickupChecklistFile,
          },
        ],
      };
    }
    const uploadDeliveryReceiptResponse = await GenerateReceipt(
      uploadDeliveryReceiptPayload
    );

    setloader(false);
    if (uploadDeliveryReceiptResponse?.status == 200) {
      let i = 0;
      for (
        i = 0;
        i < uploadDeliveryReceiptResponse?.data?.documents?.length;
        i++
      ) {
        if (
          uploadDeliveryReceiptResponse?.data?.documents[i]?.documentName ==
            "Delivery Receipt" ||
          uploadDeliveryReceiptResponse?.data?.documents[i]?.documentName ==
            "Pickup Receipt"
        ) {
          setUpdateRecieptKey(
            uploadDeliveryReceiptResponse?.data?.documents[i]?.documentId
          );
          break;
        }
      }
      if (isCustomerorderenabled === true) {
        setopenCOprintpopup(true);
      } else if (
        currentappointmentDetails &&
        currentappointmentDetails.appointmentInfo.appointmentType === "SO"
      ) {
        setprintswitchoutpopup(true);
      } else {
        currentappointmentDetails;
        SetOpenprintpopup(true);
      }
    } else if (uploadDeliveryReceiptResponse?.status == 400) {
      setServiceErrorMsg(uploadDeliveryReceiptResponse?.data?.errors[0]?.error);
      seterrorMessagePopupOpen(true);
    } else {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };
  const agreementsignedmethod = async (actionUpdate?: string) => {
    try {
      currentappointmentDetails;
      const bodyobj = {
        agreementIdCustomerId: [
          {
            agreementId: parseInt(
              currentappointmentDetails &&
                currentappointmentDetails?.agreement?.agreementId
            ),
          },
        ],
      };
      let getamountresponse: any = {
        getamountdata: {},
      };

      let deliveryreceiptresponse: any = {
        deliverydata: {},
      };
      setloader(true);
      const apiCallStack = [getnextpaymentamount(bodyobj)];
      if (
        currentappointmentDetails &&
        (currentappointmentDetails.appointmentInfo.appointmentType == "SO" ||
          currentappointmentDetails.isSwitchoutEnabled == "1") &&
        !isCustomerorderenabled
      ) {
        apiCallStack.push(
          LoadswitchoutDeliveryreceipt(
            currentappointmentDetails &&
              currentappointmentDetails?.agreement?.agreementId
          )
        );
      } else {
        apiCallStack.push(
          LoadDeliveryreceipt(
            currentappointmentDetails &&
              currentappointmentDetails?.agreement?.agreementId
          )
        );
      }
      await Promise.all(apiCallStack).then((resp) => {
        [getamountresponse, deliveryreceiptresponse] = resp;
        const deliveryreceiptres = deliveryreceiptresponse;

        console.log("asydnchronous api calls", getamountresponse);
        console.log(
          "asynchronous api calls for reprint",
          deliveryreceiptresponse
        );
        console.log("responseData", deliveryreceiptresponse.responseData);
        console.log(
          "amountdueresponse",
          getamountresponse.data.amountDueResponse
        );
        deliveryreceiptresponse = deliveryreceiptresponse.data || [];
        if (
          deliveryreceiptresponse !== undefined &&
          deliveryreceiptresponse.responseData !== undefined &&
          getamountresponse.status == 200
        ) {
          // setloader(false);

          const resUniqueValue: any =
            deliveryreceiptresponse.responseData.filter(
              (obj: any, index: any) => {
                return (
                  index ===
                  deliveryreceiptresponse.responseData.findIndex(
                    (o: any) => obj.inventoryId === o.inventoryId
                  )
                );
              }
            );
          setitemdata(resUniqueValue);

          console.log("view response", deliveryreceiptresponse);
          // if (isReturnStart || returnReschedule) {
          //     setinventorynumber(
          //         deliveryreceiptresponse.responseData[0].inventoryNumber
          //     );
          //     setinventorydesc(
          //         deliveryreceiptresponse.responseData[0].inventoryDesc
          //     );
          //     setinventoryserialnum(
          //         deliveryreceiptresponse.responseData[0].serialNumber
          //     );
          // }
          Setstorename(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].storeName
              : ""
          );

          // SetstoreNumber(
          //     deliveryreceiptresponse !== undefined &&
          //         deliveryreceiptresponse.responseData !== undefined &&
          //         deliveryreceiptresponse.responseData.length > 0
          //         ? deliveryreceiptresponse.responseData[0].storeNumber
          //         : ''
          // );
          // Setstorestate(
          //     deliveryreceiptresponse !== undefined &&
          //         deliveryreceiptresponse.responseData !== undefined &&
          //         deliveryreceiptresponse.responseData.length > 0
          //         ? deliveryreceiptresponse.responseData[0].storeState
          //         : ''
          // );
          Setstorezip(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].storeZip
              : ""
          );

          Setstorecity(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].storeCity
              : ""
          );
          SetStorephonenum(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].storePhoneNumber
              : ""
          );
          SetStoreAddressline1(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].storeAddressLine1
              : ""
          );
          SetStoreAdressline2(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].storeAddressLine2
              : ""
          );
          SetCustomerName(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].customerName
              : ""
          );
          SetCustomerAddressline1(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].addressLine1
              : ""
          );
          SetCustomerAddressline2(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].addressLine2
              : ""
          );
          Setcustomercity(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].customerCity
              : ""
          );
          SetCustomerstate(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].customerState
              : ""
          );

          Setcustomerzip(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].customerZip
              : ""
          );

          Setcustomerplus4(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].customerPlus4
              : ""
          );
          SetCustomerPhoneNumber(
            deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined &&
              deliveryreceiptresponse.responseData.length > 0
              ? deliveryreceiptresponse.responseData[0].customerPhoneNumber
              : ""
          );
          if (
            getamountresponse !== undefined &&
            getamountresponse !== null &&
            getamountresponse.data.amountDueResponse !== undefined &&
            getamountresponse.data.amountDueResponse !== null
          ) {
            const AmountResponse =
              getamountresponse.data.amountDueResponse.find(
                (x: { agreementId: string }) =>
                  x.agreementId ==
                  currentappointmentDetails?.agreement?.agreementId
              );
            console.log("agreementid related data", AmountResponse);

            if (
              AmountResponse !== undefined &&
              AmountResponse !== null &&
              AmountResponse !== "" &&
              AmountResponse.ldwAmount !== undefined &&
              AmountResponse.ldwAmount !== null
            ) {
              const Totalamountdue =
                parseFloat(AmountResponse.amountDue) +
                parseFloat(AmountResponse.ldwAmount);
              console.log("agreementid Total Amount", Totalamountdue);
              setnextpaymentinfo({
                ...nextpaymentinfo,
                nextamountdue: Totalamountdue.toFixed(2),
                nextduedate: AmountResponse.nextDueDate,
              });
              console.log("next amount due", nextpaymentinfo);
            } else {
              console.log("nextpaymentamount", getamountresponse);

              setnextpaymentinfo({
                ...nextpaymentinfo,
                nextamountdue:
                  getamountresponse.data.amountDueResponse[0].amountDue,
                nextduedate:
                  getamountresponse.data.amountDueResponse[0].nextDueDate,
              });
              console.log("next amount due", nextpaymentinfo);
              console.log(
                "getamountdue response",
                getamountresponse?.data?.amountDueResponse[0].amountDue
              );
            }

            const TempArr: any = [];
            if (
              deliveryreceiptresponse !== undefined &&
              deliveryreceiptresponse.responseData !== undefined
            ) {
              for (
                let i = 0;
                i <= deliveryreceiptresponse.responseData.length - 1;
                i++
              ) {
                let obj: any;
                if (isCustomerorderenabled === true) {
                  obj = {
                    inventoryId:
                      deliveryreceiptresponse.responseData[i].inventoryId,
                    inventoryNumber:
                      deliveryreceiptresponse.responseData[i].inventoryNumber,
                    serialNumber:
                      deliveryreceiptresponse.responseData[i].serialNumber,
                    inventoryDesc:
                      deliveryreceiptresponse.responseData[i].inventoryDesc,
                    modelNumber:
                      deliveryreceiptresponse.responseData[i].modelNumber,
                  };
                } else {
                  obj = {
                    inventoryId:
                      deliveryreceiptresponse.responseData[i].inventoryId,
                    inventoryNumber:
                      deliveryreceiptresponse.responseData[i].inventoryNumber,
                    serialNumber:
                      deliveryreceiptresponse.responseData[i].serialNumber,
                    inventoryDesc:
                      deliveryreceiptresponse.responseData[i].inventoryDesc,
                  };
                }
                TempArr.push(obj);
              }
            }
            let generatereceiptpayload: any;
            if (isCustomerorderenabled === true) {
              generatereceiptpayload = {
                action: 2,
                inventorydescription: TempArr,
                customerName:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].customerName
                    : "",
                addressLine1:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].addressLine1
                    : "",
                addressLine2:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0 &&
                  deliveryreceiptresponse.responseData[0].addressLine2 !==
                    null &&
                  deliveryreceiptresponse.responseData[0].addressLine2 !== ""
                    ? deliveryreceiptresponse.responseData[0].addressLine2
                    : "",
                customerCity:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].customerCity
                    : "",
                customerZip:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0 &&
                  deliveryreceiptresponse.responseData[0].customerZip !==
                    null &&
                  deliveryreceiptresponse.responseData[0].customerPlus4 !== null
                    ? deliveryreceiptresponse.responseData[0].customerZip +
                      "-" +
                      deliveryreceiptresponse.responseData[0].customerPlus4
                    : deliveryreceiptresponse.responseData[0].customerZip,
                customerState:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].customerState
                    : "",

                storeName:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeName
                    : "",
                storeNumber:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeNumber
                    : "",
                storeAddressLine1:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeAddressLine1
                    : "",
                storeAddressLine2:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0 &&
                  deliveryreceiptresponse.responseData[0].storeAddressLine2 !==
                    null &&
                  deliveryreceiptresponse.responseData[0].storeAddressLine2 !==
                    ""
                    ? deliveryreceiptresponse.responseData[0].storeAddressLine2
                    : "",
                storeCity:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeCity
                    : "",
                storeState:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeState
                    : "",
                storeZip:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeZip
                    : "",
                deliveryDate: DeliveryDate,
                agreementNumber:
                  currentappointmentDetails &
                  currentappointmentDetails.agreement.agreementNumber,
              };
            } else if (currentappointmentDetails.isSwitchoutEnabled == "1") {
              generatereceiptpayload = {
                action: 1,
              };
            } else {
              generatereceiptpayload = {
                ...(actionUpdate == "3" && {
                  action: 3,
                }),
                inventorydescription: TempArr,
                customerName:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].customerName
                    : "",
                addressLine1:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].addressLine1
                    : "",
                addressLine2:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0 &&
                  deliveryreceiptresponse.responseData[0].addressLine2 !==
                    null &&
                  deliveryreceiptresponse.responseData[0].addressLine2 !== ""
                    ? deliveryreceiptresponse.responseData[0].addressLine2
                    : "",
                customerCity:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].customerCity
                    : "",
                customerZip:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0 &&
                  deliveryreceiptresponse.responseData[0].customerZip !==
                    null &&
                  deliveryreceiptresponse.responseData[0].customerPlus4 !== null
                    ? deliveryreceiptresponse.responseData[0].customerZip +
                      "-" +
                      deliveryreceiptresponse.responseData[0].customerPlus4
                    : deliveryreceiptresponse.responseData[0].customerZip,
                customerState:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].customerState
                    : "",
                customerPhoneNumber:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0]
                        .customerPhoneNumber
                    : "",

                storeName:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeName
                    : "",
                storeNumber:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeNumber
                    : "",
                storeAddressLine1:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeAddressLine1
                    : "",
                storeAddressLine2:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0 &&
                  deliveryreceiptresponse.responseData[0].storeAddressLine2 !==
                    null &&
                  deliveryreceiptresponse.responseData[0].storeAddressLine2 !==
                    ""
                    ? deliveryreceiptresponse.responseData[0].storeAddressLine2
                    : "",
                storePhoneNumber:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storePhoneNumber
                    : "",
                storeCity:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeCity
                    : "",
                storeState:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeState
                    : "",
                storeZip:
                  deliveryreceiptresponse !== undefined &&
                  deliveryreceiptresponse.responseData !== undefined &&
                  deliveryreceiptresponse.responseData.length > 0
                    ? deliveryreceiptresponse.responseData[0].storeZip
                    : "",
                nexDueAmount:
                  AmountResponse.amountDue !== undefined &&
                  AmountResponse.amountDue !== null &&
                  AmountResponse.ldwAmount !== undefined &&
                  AmountResponse.ldwAmount !== null
                    ? (
                        parseFloat(AmountResponse.amountDue) +
                        parseFloat(AmountResponse.ldwAmount)
                      )

                        .toFixed(2)
                        .toString()
                    : getamountresponse.data.amountDueResponse[0].amountDue.toString(),

                deliveryDate: DeliveryDate,
                deliveryTime: DeliveryTime,
                agreementNumber:
                  currentappointmentDetails &&
                  currentappointmentDetails.agreement.agreementNumber,
                agreementId: parseInt(
                  currentappointmentDetails &&
                    currentappointmentDetails?.agreement?.agreementId
                ),
                customerId:
                  currentappointmentDetails &&
                  currentappointmentDetails?.customerInfo?.customerId,
              };
            }
            setloader(true);
            generateReceiptFn(generatereceiptpayload);
          }
        } else if (deliveryreceiptres.status == 400) {
          setServiceErrorMsg(deliveryreceiptresponse?.errors[0]?.error);
          setloader(false);
          seterrorMessagePopupOpen(true);
        } else if (getamountresponse.status == 400) {
          setServiceErrorMsg(getamountresponse?.errors[0]?.error);
          setloader(false);
          seterrorMessagePopupOpen(true);
        } else {
          setloader(false);
          setModals({ ...modals, apiErrorInfoMsg: true });
        }
      });
    } catch (e: any) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };
  const updateNotesHandler = async () => {
    try {
      setUpdatingNotesLoader(true);
      // setModals({ ...modals, storeEventDetailModal: false })
      const payload: any = {
        storeNumber: sessionStorage.getItem("storeNumber"),
        appointmentId: currentappointmentDetails.appointmentInfo.appointmentId,
        coworkerId: EmpolyeeId,
        note: storeEventNotes,
        // appointmentInfo: {
        //     appointmentType: 'SE',
        //     appointmentSource: 'STO',
        //     appointmentDate: filterStateData.date,
        //     instructions: Cadbury, formerly Cadbury's and Cadbury Schweppes,
        //     requiredCoworkers: 2,
        //     title: Cadburry
        // }
      };
      // setloader(true);
      const response = await manageAppointment(payload);
      if (response.status == 200) {
        setCurrentappointmentDetails({
          ...currentappointmentDetails,
          notes: response.data.notes,
        });
        // setModals({ ...modals, storeEventDetailModal: true })
      }
      setStoreEventNotes("");
      setUpdatingNotesLoader(false);
    } catch (e) {
      setUpdatingNotesLoader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
      console.log(e);
    }
  };

  //Function for Showing the Delivery popup.
  const handleEventDetails: any = async (popupVal: any) => {
    try {
      setCarInstructions(popupVal.appointmentInfo?.instructions || "");
      setToShowSurvey(false);
      if (
        eligibleRole &&
        customerSurveyParamKey == "1" &&
        (popupVal?.appointmentInfo?.appointmentType == "D" ||
          popupVal?.appointmentInfo?.appointmentType == "CI" ||
          popupVal?.appointmentInfo?.appointmentType == "CO") &&
        popupVal?.agreement?.agreementId
      ) {
        getSurveyStatus(popupVal.agreement.agreementId);
      }
      if (
        eligibleRole &&
        addressVerificationSurveyParamKey == "1" &&
        (popupVal?.appointmentInfo?.appointmentType == "D" ||
          popupVal?.appointmentInfo?.appointmentType == "CI" ||
          popupVal?.appointmentInfo?.appointmentType == "CO") &&
        popupVal?.agreement?.agreementId
      ) {
        getAddressSurveyStatus(popupVal.agreement.agreementId);
      }
      setModals({ ...modals, timeSlotExceedModal: false });
      if (popupVal.appointmentInfo.appointmentType == "AD") {
        setloader(true);
        setisManaul(false);
        setacimaManulaSign(false);
        setmanualSignature(false);
        setacimaEventValues({
          ...acimaEventValues,
          poNumber: popupVal?.appointmentInfo?.additionalDetails?.poNumber,
          addressLine1:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo
              ?.addressLine1,
          addressLine2:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo
              ?.addressLine2,
          state:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo?.state,
          city: popupVal?.appointmentInfo?.additionalDetails?.customerInfo
            ?.city,
          zip: popupVal?.appointmentInfo?.additionalDetails?.customerInfo?.zip,
          phoneNumber:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo
              ?.phoneNumber,
          firstName:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo
              ?.firstName,
          lastName:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo
              ?.lastName,
          itemInformation:
            popupVal?.appointmentInfo?.additionalDetails?.itemInformation,
          appointmentStatus: popupVal?.appointmentInfo?.appointmentStatus,
          appointmentId: popupVal?.appointmentInfo?.appointmentId,
          appiontmnetDate: popupVal?.appointmentInfo?.appointmentDate,
          appiontmnetTime: popupVal?.timeSlotInfo?.startTimeStamp,
          emailId:
            popupVal?.appointmentInfo?.additionalDetails?.customerInfo?.emailId,
        });
        const response: any = await EventHistory({
          appointmentId: popupVal?.appointmentInfo?.appointmentId,
        });
        setloader(false);
        setacimaEventDetails(true);
        setAppointmentHistoryRecord(response?.data);
        return;
      }
      if (popupVal.appointmentInfo.appointmentType == "SE") {
        // setEnableDeliveryPopup(true)
        setloader(true);
        const apiCallStack: any = [
          EventHistory({
            appointmentId: popupVal.appointmentInfo.appointmentId,
          }),
        ];
        if (!EmpolyeeId) {
          apiCallStack.push(getmenuandstore());
        }
        const response: any = await Promise.all(apiCallStack);
        setAppointmentHistoryRecord(response[0].data);
        if (!EmpolyeeId) {
          setEmpolyeeId(response[1]?.coworkerProfile?.employeeId);
        }
        setloader(false);
        setModals({ ...modals, storeEventDetailModal: true });
        setCurrentappointmentDetails({ ...popupVal, isSwitchoutEnabled: "0" });
        return;
      }
      // const agrInfoResponse = await getAgreementInfo(popupVal.agreement.agreementId);
      // const del = await getAgreementDelivery(popupVal.agreement.agreementId);

      // if ((appointmentHistoryRecord && appointmentHistoryRecord.appointmentId !== popupVal.appointmentInfo.appointmentId) || appointmentHistoryRecord.length == 0) {
      setloader(true);
      const apiCallStack: any = [
        getAgreementInfo(popupVal.agreement.agreementId),
        getAgreementDelivery(
          popupVal.agreement.agreementId,
          popupVal.appointmentInfo.appointmentId
        ),
        EventHistory({ appointmentId: popupVal.appointmentInfo.appointmentId }),
      ];

      if (!EmpolyeeId) {
        apiCallStack.push(getmenuandstore());
      }
      const response: any = await Promise.all(apiCallStack);

      const appointmentRes = response[1].data
      
      if(appointmentRes.customerInfo){
        console.log("appointmentRes",appointmentRes.customerInfo.address);
        
      setMxCustomerAddress(appointmentRes.customerInfo.address)
      }
      if (response && response.length > 0 && response[1].data) {
        setappiontmentId(response[1]?.data?.appointmentInfo?.appointmentId);
        setagrDelStatus(
          response[1]?.data?.appointmentInfo?.appointmentStatusDesc
        );
      }
      if (
        response &&
        response.length > 0 &&
        response[0].data &&
        response[0].data.agreementWorkflow &&
        response[0].data.agreementWorkflow.isSwitchoutEnabled == "1"
      ) {
        const switchInItem: any = response[0].data.agreementInventories.find(
          (el: any) => el.isItemSwitchedIn == "1"
        );
        setCurrentappointmentDetails({
          ...popupVal,
          isSwitchoutEnabled: "1",
          switchInItem: switchInItem?.inventoryId,
          // To bind the Notes with Instruction at first.
          notes: buildNotesListWithInstruction(response?.[1]?.data || {}),
        });
        setagreementValues({
          ...agreementValues,
          agreementSign:
            response[0]?.data?.agreementWorkflow?.isAgreementSigned,
          agreementNumber:
            response[0]?.data?.agreementWorkflow?.agreementNumber,
          agreementId: response[0]?.data?.agreementWorkflow?.agreementId,
        });
        setAgreementInfoResponse(response[0]?.data);
      } else {
        setCurrentappointmentDetails({
          ...popupVal,
          isSwitchoutEnabled: "0",
          // To bind the Notes with Instruction at first.
          notes: buildNotesListWithInstruction(response?.[1]?.data || {}),
        });
        setagreementValues({
          ...agreementValues,
          agreementSign:
            response[0]?.data?.agreementWorkflow?.isAgreementSigned,
          agreementNumber:
            response[0]?.data?.agreementWorkflow?.agreementNumber,
          agreementId: response[0]?.data?.agreementWorkflow?.agreementId,
        });
        setAgreementInfoResponse(response[0]?.data);
      }

      // Default Notes tab and prepend instructions for D/P types
      if (isDeliveryOrPickupType(popupVal?.appointmentInfo?.appointmentType)) {
        setactivetab({ instructions: false, notes: true, history: false });
      }

      if (
        response &&
        response.length > 0 &&
        response[0].data.agreementWorkflow.isCOAgreement == "1"
      ) {
        setisCustomerorderenabled(true);
      }
      if (!EmpolyeeId) {
        setEmpolyeeId(response[1]?.coworkerProfile?.employeeId);
      }
      const modifiedEndtime = popupVal?.timeSlotInfo?.endTime || "";
      const modifiedStarttime =
        popupVal?.timeSlotInfo?.startTime ||
        "".replace(" PM", "").replace(" AM", "");
      const slicedStartTimeslot =
        modifiedStarttime.slice(0, 5) +
        modifiedStarttime.slice(8, modifiedStarttime.length);
      const slotDuration =
        moment(modifiedStarttime, "HH:mm").format("hh:mm") +
        " - " +
        moment(modifiedEndtime, "HH:mm").format("hh:mm A");
      setDeliveryTime(slotDuration);
      setDeliveryDate(
        popupVal?.appointmentInfo?.appointmentDate
          ? moment(popupVal?.appointmentInfo?.appointmentDate).format(
              "MM/DD/YYYY"
            )
          : ""
      );
      popupVal?.appointmentInfo?.appointmentDatee || "";
      // constsetDeliveryDate historyAppointmentRes = await EventHistory({ appointmentId: popupVal.appointmentInfo.appointmentId })
      setloader(false);
      setAppointmentHistoryRecord(response[2].data);
      // } else {
      //     setloader(true);
      //     const response: any = await EventHistory({ appointmentId: popupVal.appointmentInfo.appointmentId })
      //     if (response && response.status == 200) {
      //         setAppointmentHistoryRecord(response.data)
      //     }
      //     setloader(false);
      // }
      if (popupVal?.appointmentInfo?.appointmentType == "STOPIC") {
        setEnableStorePickupPopup(true);
      } else if (popupVal?.appointmentInfo?.appointmentType == "FIELD") {
        setEnableFieldVisitPopup(true);
      } else {
        console.log("RAF - ON CLICK")
        // Fetch customer reward details when delivery popup is opened (only if RAF Survey is enabled)
        if (popupVal?.customerInfo && EnableRAFSurvey == "1") {
          getCustomerRewardDetails(popupVal.customerInfo);
        }
        setEnableDeliveryPopup(true);
      }
      // if (currentappointmentDetails && (currentappointmentDetails.appointmentInfo.appointmentStatus != 'CMP') && (currentappointmentDetails?.agreement?.agreementTypeDesc == 'Rental Agreement (RTO)' || currentappointmentDetails?.agreement?.agreementTypeDesc == 'Rent to Rent - Loaner') && (currentappointmentDetails?.appointmentInfo?.appointmentType == '1D' || currentappointmentDetails?.appointmentInfo?.appointmentType == 'C1O')) {
      //     setmanualSignatureEnabled(false);
      // }

      console.log("popupVal", popupVal);
      setStatus({
        ...status,
        Signature: "complete",
        Reprint: "inprogress",
        ConfirmDelivery: "pending",
      });
      setPopUpValues(popupVal);
    } catch (e: any) {
      setloader(false);
      setModals({ ...modals, apiErrorInfoMsg: true });
    }
  };

  const getSurveyStatus = async (agreementId) => {
    const getSurveyDone: any = await getSavedSurvey(agreementId);
    console.log(getSurveyDone, "get Response");

    setReadOnlySurvey(false);
    if (
      getSurveyDone?.status != 200 ||
      (getSurveyDone?.status == 200 && getSurveyDone?.data?.length == 0)
    ) {
      console.log("setToShowSurvey: " + agreementId + ":" + toShowSurvey);
      setToShowSurvey(true);
    } else {
      setToShowSurvey(false);
      if (getSurveyDone?.status == 200 && getSurveyDone?.data?.agreementId) {
        setReadOnlySurvey(true);
        initializeSurvey(getSurveyDone.data);
      }
      console.log("setToShowSurvey: " + agreementId + ":" + toShowSurvey);
    }
  };

  const getAddressSurveyStatus = async (agreementId) => {
    const getSurveyDone: any = await getSavedSurvey(agreementId);
    console.log(getSurveyDone, "get Response");

    setReadOnlyAddressSurvey(false);

    if (
      getSurveyDone?.status != 200 ||
      (getSurveyDone?.status == 200 &&
        (getSurveyDone?.data?.length == 0 || !getSurveyDone?.data?.agreementId))
    ) {
      console.log(
        "setToShowSurvey: " + agreementId + ":" + toShowAddressSurvey
      );
      setToShowAddressSurvey(true);
    } else {
      setToShowAddressSurvey(false); // chhange this to be 204 and 200

      if (getSurveyDone?.status == 200 && getSurveyDone?.data?.agreementId) {
        setReadOnlyAddressSurvey(true);
        initializeAddressSurvey(getSurveyDone.data);
      }
      console.log(
        "setToShowSurvey: " + agreementId + ":" + toShowAddressSurvey
      );
    }
  };

  // Appoinment Events to bind.
  const eventToBind: any = (binder: any, index: any) => {
    if (eventType !== "ALL") {
      binder = binder.filter(
        (filterEl: any) =>
          !filterEl.storeNumber ||
          filterEl.appointmentInfo.appointmentTypeDesc == eventType
      );
    }
    if (documentName) {
      binder = binder.filter(
        (filterEl: any) =>
          !filterEl.storeNumber ||
          (filterEl.appointmentInfo &&
            filterEl.appointmentInfo.instructions &&
            filterEl.appointmentInfo.instructions
              .toLowerCase()
              .includes(documentName)) ||
          (filterEl.customerInfo &&
            filterEl.customerInfo.firstName &&
            filterEl.customerInfo.firstName
              .toLowerCase()
              .includes(documentName.toLowerCase())) ||
          (filterEl.customerInfo &&
            filterEl.customerInfo.lastName &&
            filterEl.customerInfo.lastName.toLowerCase().includes(documentName))
      );
    }
    const InactiveCheck = [
      "Paid in Full",
      "Same As Cash",
      "Early Purchase Option",
      "Charged Off",
      "Return To Vendor",
    ];
    binder = binder.filter(
      (filterEl: any) =>
        !InactiveCheck.includes(filterEl?.agreement?.agreementStatusDesc)
    );

    // if (!modals.expandIconClicked) {
    //     binder = binder.filter((filterEl: any) => (!filterEl.storeNumber || (filterEl.appointmentInfo && filterEl.appointmentInfo?.appointmentStatus && filterEl.appointmentInfo?.appointmentStatus == 'TD')))
    // }
    console.log(binder, "...bind");
    return binder?.map((el: any, index: any) => {
      // return binder?.agreementInfo.map((agree:any)=>{
      if (index < eventLenght) {
        return (
          <Grid
            style={{
              width: "24%",
              margin: "0.5%",
              zIndex: 0,
              textDecoration: "none",
              fontSize: "medium",
              fontWeight: "bold",
              color: "#2179FE",
              borderLeft: `4px solid ${
                getFontBackgroundColour(
                  el.appointmentInfo.appointmentStatus,
                  el.timeSlotInfo.endTimeStamp
                )?.fontColor
              }`,
              display: "flex",
              position: "relative",
            }}
            className={`${classes1.DAPcardwidget} ${classes1.DAPsmallcardwidget}`}
            key={index}
          >
            <a
              style={{
                width: "100%",
                position: "relative",
                display: "block",
                padding: "0.5rem1rem",
                color: "#212529",
                textDecoration: "none",
                backgroundColor: `${
                  getFontBackgroundColour(
                    el.appointmentInfo.appointmentStatus,
                    el.timeSlotInfo.endTimeStamp
                  )?.backgroundColor
                }`,
                // border: '1px solid rgba(0, 0, 0, 0.125)',
                paddingLeft: "5%",
                cursor: "pointer",
                borderRadius: "3px",
                paddingTop: "2%",
                paddingBottom: "2%",
                boxShadow: "0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important",
              }}
              className={classes1.DAPeventcardparent}
              onClick={() => {
                el.appointmentInfo?.appointmentSource !== "OFFSITE"
                  ? handleEventDetails(el)
                  : el?.appointmentInfo?.appointmentStatus == "TD" &&
                    el?.agreement?.agreementStatus == "PRELIM"
                  ? history.push({
                      pathname: `/payment1/customerorder/preliminary/${el?.customerInfo?.customerId}/${el?.agreement?.agreementId}`,
                    })
                  : (el?.appointmentInfo?.appointmentStatus == "TD" ||
                      el?.appointmentInfo?.appointmentStatus == "CAN") &&
                    (el.agreement?.agreementStatus == "PRELIMINV" ||
                      el?.agreement?.agreementStatus == "PRELIMPAID")
                  ? history.push({
                      pathname: `/agreement/customerorder/postatus/${el?.customerInfo?.customerId}/${el?.agreement?.agreementId}`,
                    })
                  : el?.appointmentInfo?.appointmentStatus == "CMP"
                  ? history.push({
                      pathname: `/agreement/info/details/${el?.customerInfo?.customerId}/${el?.agreement?.agreementId}`,
                    })
                  : null;
              }}
            >
              <Grid style={{ width: "100%", display: "flex" }}>
                <Grid style={{ width: "60%", display: "flex" }}>
                  {el.appointmentInfo?.appointmentType == "AD" ? (
                    <Typography
                      style={{
                        fontFamily: "OpenSans-bold",
                        fontSize: " 13px",
                        display: "inline-block",
                        color: `${
                          getFontBackgroundColour(
                            el.appointmentInfo.appointmentStatus,
                            el.timeSlotInfo.endTimeStamp
                          )?.fontColor
                        }`,
                      }}
                      className={classes1.DAPeventcardfont}
                    >
                      {`${
                        el?.appointmentInfo?.additionalDetails?.customerInfo
                          ?.firstName +
                        " " +
                        el?.appointmentInfo?.additionalDetails?.customerInfo
                          ?.lastName
                      }`}
                    </Typography>
                  ) : (
                    <Typography
                      style={{
                        fontFamily: "OpenSans-bold",
                        fontSize: " 13px",
                        display: "flex",
                        wordBreak: "break-word",
                        width: `${
                          el.appointmentInfo?.appointmentSource == "OFFSITE"
                            ? "60%"
                            : "100%"
                        }`,
                        color: `${
                          getFontBackgroundColour(
                            el.appointmentInfo.appointmentStatus,
                            el.timeSlotInfo.endTimeStamp
                          )?.fontColor
                        }`,
                      }}
                      className={classes1.DAPeventcardfont}
                    >
                      {el.appointmentInfo.appointmentType == "SE"
                        ? el.appointmentInfo.title || ""
                        : `${
                            (el?.customerInfo?.firstName || "") +
                            " " +
                            (el?.customerInfo?.lastName || "")
                          }`}
                    </Typography>
                  )}
                  {el.appointmentInfo?.appointmentSource == "OFFSITE" ? (
                    <>
                      <span
                        style={{
                          width: "7px",
                          height: "7px",
                          background: `#4c4fc7`,
                          display: "inline-block",
                          borderRadius: "50%",
                          marginTop: "8px",
                        }}
                      ></span>
                      <span
                        style={{
                          fontSize: "11px",
                          paddingLeft: "3px",
                          paddingTop: "4px",
                        }}
                      >{`${t("Tire Buyer")}`}</span>
                    </>
                  ) : null}
                </Grid>
                <Grid style={{ width: "50%", display: "flex" }}>
                  {/* PS_10 */}
                  {(el.appointmentInfo.appointmentType == "D" ||
                    el.appointmentInfo.appointmentType == "CO") &&
                  el?.approvals?.verificationStatus == "PENDING" &&
                  customerVerification == 1 ? (
                    <WarningIcon></WarningIcon>
                  ) : null}
                  {/* PS_11 */}
                  {el.appointmentInfo.appointmentType !== "SE" ? (
                    <RACBadge
                      className={`${classes.w100Px} ${classes1.w100Px} ${classes.floatRight}`}
                      handleOnClick={function (event: any): void {
                        throw new Error("Function not implemented.");
                      }}
                      backgroundColor={getBatchColorByappointmentType(
                        el.appointmentInfo.appointmentType
                      )}
                      color={"white"}
                      TextValue={t(el.appointmentInfo.appointmentTypeDesc)}
                      OnclickNeed={false}
                    ></RACBadge>
                  ) : null}
                </Grid>
              </Grid>

              <Grid
                className={classes.mb1}
                style={{ width: "100%", display: "flex" }}
              >
                <Grid style={{ width: "60%" }}>
                  {el.appointmentInfo?.appointmentType == "AD" ? (
                    <Typography className={`${classes.fs12}`}>
                      <Grid>
                        {" "}
                        {`${
                          (el?.appointmentInfo?.additionalDetails?.customerInfo
                            ?.addressLine1 || "") +
                          "," +
                          (el?.appointmentInfo?.additionalDetails?.customerInfo
                            ?.addressLine2 || "")
                        }`}
                      </Grid>
                      <Grid>{`${
                        (el.appointmentInfo?.additionalDetails?.customerInfo
                          ?.city || "") +
                        " " +
                        (el.appointmentInfo?.additionalDetails?.customerInfo
                          ?.state || "") +
                        " " +
                        (el?.appointmentInfo?.additionalDetails?.customerInfo
                          ?.zip || "")
                      }`}</Grid>{" "}
                    </Typography>
                  ) : (
                    <Typography className={`${classes.fs12}`}>
                      <Grid>
                        {el.appointmentInfo.appointmentType == "SE"
                          ? el.appointmentInfo.instructions || ""
                          : (el.customerInfo?.address?.addressLine1 || "") +
                            " " +
                            (el.customerInfo?.address?.addressLine2 || "")}
                      </Grid>
                      <Grid>
                        {el.appointmentInfo.appointmentType == "SE"
                          ? ""
                          : `${
                              (el.customerInfo?.address?.city || "") +
                              (el.customerInfo?.city ? "," : "") +
                              (el.customerInfo?.address?.state || "") +
                              (el.customerInfo?.postalCode ? "-" : "") +
                              (el.customerInfo?.address?.postalCode || "")
                            }`}
                      </Grid>
                    </Typography>
                  )}
                </Grid>
                <Grid style={{ width: "40%", alignSelf: "end" }}>
                  {Number(MXStoreIdentifier) == 1 ? (
                    <Typography className={`${classes.fs12}`}>
                      <Grid style={{ textAlign: "center" }}>
                        {el.storeNumber}
                      </Grid>
                    </Typography>
                  ) : (
                    <></>
                  )}
                  <Typography className={`${classes.fs12}`}>
                    <Grid style={{ textAlign: "center" }}>
                      {el.appointmentInfo.appointmentType == "SE"
                        ? t("Store Event")
                        : t("Event")}
                    </Grid>
                  </Typography>
                </Grid>
              </Grid>
            </a>
          </Grid>
        );
      }
      // })
    });
  };
  // color to be binded
  const colorBind: any = (index: any) => {
    if (index == "Delivery") {
      return "Pink";
    }
    if (index == "Service") {
      return "#DD4F89";
    }
    if (index == "CarryOut") {
      return "#26C0C7";
    }
    if (index == "CarryIn") {
      return "#B36458";
    }
    if (index == "Pickup") {
      return "#3DCFA3";
    }
    if (index == "In home service") {
      return "#AF7AB3";
    }
  };
  const onChangeDate = (val: any) => {
    setIsStoreClosed(false);
    pageLoad(moment(val).format("YYYY-MM-DD"));
    setFilterStateData({ ...filterStateData, date: val });
  };
  const handleDisable = () => {
    const Date = moment().format("YYYY-MM-DD");
    console.log("Date", Date);
    console.log("dateDap", dateDap);
    if (filterStateData.date == Date.toString()) {
      console.log("true");
      return true;
    } else {
      console.log("false");
      return false;
    }
  };
  const handleEventDropdown = (val: any) => {
    appointmentDetails;
    console.log("events", val.target.value);
    setEventType(val.target.value);
  };

  // function handleCreateStoreEvent(){
  // }

  const handleKeypress = (event: any) => {
    console.log("charCode", event.charCode);
    console.log("key pressed");
    if (event.charCode === 13) {
      event.preventDefault();
      console.log("enter pressed");
    }
  };
  const storeClosedGrid = (content: string) => {
    return (
      <Grid style={{ width: "100%", height: "220px" }}>
        {content ==
        "We are currently working on this feature and will launch soon!" ? (
          <Typography
            className={classes.textcenterImage}
            style={{ textAlign: "center" }}
          >
            {t("Coming Soon!")}
          </Typography>
        ) : (
          <Grid
            className={classes.textcenterNorecords}
            style={{ textAlign: "center" }}
          >
            {" "}
            <InfoIcon className={classes.racErrorIcon}></InfoIcon>
          </Grid>
        )}
        <Typography
          className={classes.textcenterImage}
          style={{ textAlign: "center" }}
        >
          {content}
        </Typography>
      </Grid>
    );
  };
  const NOUpcomingEventGrid = () => {
    return (
      <Grid style={{ width: "90%", height: "100%", display: "flex" }}>
        {/* <Grid className={classes.textcenterNorecords} style={{ textAlign: 'center' }}>
                    {' '}
                    <InfoIcon className={classes.racErrorIcon}></InfoIcon>
                </Grid> */}
        <Typography
          className={classes.textcenterImage}
          style={{ textAlign: "center", marginTop: "0px" }}
        >
          {t("No Upcoming Records Found")}
        </Typography>
      </Grid>
    );
  };
  const LunchBreakGrid = () => {
    return (
      <Grid
        style={{ width: "100%", display: "flex" }}
        className={classes1.DAPlunchbreak}
      >
        <span
          style={{
            width: "46%",
            height: "1px",
            alignSelf: "center",
            color: "gray",
            background:
              "repeating-linear-gradient(to right, transparent, transparent 5px, gray 5px, gray 10px)",
          }}
        ></span>
        <Typography
          style={{
            display: "inline-block",
            textAlign: "center",
            alignSelf: "center",
            width: "14%",
            color: "gray",
          }}
          className={classes1.breaktext}
        >
          {t("Lunch Break")}
        </Typography>
        <span
          style={{
            width: "46%",
            alignSelf: "center",
            height: "1px",
            color: "gray",
            background:
              "repeating-linear-gradient(to right, transparent, transparent 5px, gray 5px, gray 10px)",
          }}
        ></span>
      </Grid>
    );
  };
  const printHTML = (html: any) => {
    if (html !== undefined && html !== null) {
      const divContents = html.innerHTML;
      const a: any = window.open("/h", "_blank", "height=1000, width=1200");
      a.document.write("<html>");
      a.document.write(divContents);
      a.document.write("</html>");
      a.document.close();
      a.print();
    }
  };
  const TimeSlotExceedRecord = () => {
    return (
      <Grid style={{ width: "100%", display: "flex", flexWrap: "wrap" }}>
        {timeSlotExceedRecordsDetails?.appointmentDetails?.map(
          (el: any, index: any) => {
            // return binder?.agreementInfo.map((agree:any)=>{
            // if (el?.appointmentInfo?.appointmentStatus == 'TD') {
            return (
              <Grid
                key={el?.appointmentInfo?.appointmentId}
                style={{ width: "32%", display: "flex", padding: "0.5rem" }}
                className={classes1.popupcard}
              >
                <Grid
                  style={{
                    width: "100%",
                    margin: "0.5%",
                    zIndex: 0,
                    textDecoration: "none",
                    fontSize: "medium",
                    fontWeight: "bold",
                    color: "#2179FE",
                    borderLeft: `4px solid ${
                      getFontBackgroundColour(
                        el.appointmentInfo.appointmentStatus,
                        el.timeSlotInfo.endTimeStamp
                      )?.fontColor
                    }`,
                    display: "flex",
                    position: "relative",
                  }}
                  key={index}
                >
                  <a
                    style={{
                      width: "100%",
                      position: "relative",
                      display: "block",
                      padding: "0.5rem1rem",
                      color: "#212529",
                      textDecoration: "none",
                      backgroundColor: `${
                        getFontBackgroundColour(
                          el.appointmentInfo.appointmentStatus,
                          el.timeSlotInfo.endTimeStamp
                        )?.backgroundColor
                      }`,
                      // border: '1px solid rgba(0, 0, 0, 0.125)',
                      paddingLeft: "5%",
                      cursor: "pointer",
                      borderRadius: "3px",
                      paddingTop: "2%",
                      paddingBottom: "2%",
                      boxShadow:
                        "0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important",
                    }}
                    onClick={() => {
                      el.appointmentInfo?.appointmentSource !== "OFFSITE"
                        ? handleEventDetails(el)
                        : el?.appointmentInfo?.appointmentStatus == "TD" &&
                          el?.agreement?.agreementStatus == "PRELIM"
                        ? history.push({
                            pathname: `/payment1/customerorder/preliminary/${el?.customerInfo?.customerId}/${el?.agreement?.agreementId}`,
                          })
                        : (el?.appointmentInfo?.appointmentStatus == "TD" ||
                            el?.appointmentInfo?.appointmentStatus == "CAN") &&
                          (el.agreement?.agreementStatus == "PRELIMINV" ||
                            el?.agreement?.agreementStatus == "PRELIMPAID")
                        ? history.push({
                            pathname: `/agreement/customerorder/postatus/${el?.customerInfo?.customerId}/${el?.agreement?.agreementId}`,
                          })
                        : el?.appointmentInfo?.appointmentStatus == "CMP"
                        ? history.push({
                            pathname: `/agreement/info/details/${el?.customerInfo?.customerId}/${el?.agreement?.agreementId}`,
                          })
                        : null;
                    }}
                    // onClick={() => handleEventDetails({ wholeEl: el, agreementInfo: el?.agreementInfo, customerInfo: el?.custumInfo, inventory: el?.inventories })}
                  >
                    <Grid style={{ width: "100%", display: "flex" }}>
                      <Grid
                        style={{ width: "60%", display: "flex" }}
                        className={classes1.eventnamewidth}
                      >
                        {el.appointmentInfo?.appointmentType == "AD" ? (
                          <Typography
                            style={{
                              fontFamily: "OpenSans-bold",
                              fontSize: " 13px",
                              display: "inline-block",
                              color: `${
                                getFontBackgroundColour(
                                  el.appointmentInfo.appointmentStatus,
                                  el.timeSlotInfo.endTimeStamp
                                )?.fontColor
                              }`,
                            }}
                            className={classes1.DAPeventcardfont}
                          >
                            {`${
                              el?.appointmentInfo?.additionalDetails
                                ?.customerInfo?.firstName +
                              " " +
                              el?.appointmentInfo?.additionalDetails
                                ?.customerInfo?.lastName
                            }`}
                          </Typography>
                        ) : (
                          <Typography
                            style={{
                              fontFamily: "OpenSans-bold",
                              fontSize: " 13px",
                              display: "flex",
                              wordBreak: "break-word",
                              color: `${
                                getFontBackgroundColour(
                                  el.appointmentInfo.appointmentStatus,
                                  el.timeSlotInfo.endTimeStamp
                                )?.fontColor
                              }`,
                            }}
                            className={classes1.fontsize13}
                          >
                            {el.appointmentInfo.appointmentType == "SE"
                              ? el.appointmentInfo.title || ""
                              : `${
                                  (el?.customerInfo?.firstName || "") +
                                  " " +
                                  (el?.customerInfo?.lastName || "")
                                }`}
                          </Typography>
                        )}
                        {el.appointmentInfo?.appointmentSource == "OFFSITE" ? (
                          <>
                            <span
                              style={{
                                width: "7px",
                                height: "7px",
                                background: `#4c4fc7`,
                                display: "inline-block",
                                borderRadius: "50%",
                                marginTop: "8px",
                              }}
                            ></span>
                            <span
                              style={{
                                fontSize: "11px",
                                paddingLeft: "3px",
                                paddingTop: "4px",
                              }}
                            >{`${t("Tire Buyer")}`}</span>
                          </>
                        ) : null}
                      </Grid>
                      <Grid style={{ width: "60%", display: "flex" }}>
                        {/* PS_10 */}
                        {(el.appointmentInfo.appointmentType == "D" ||
                          el.appointmentInfo.appointmentType == "CO") &&
                        el?.approvals?.verificationStatus == "PENDING" &&
                        customerVerification == 1 ? (
                          <WarningIcon></WarningIcon>
                        ) : null}
                        {/* PS_11 */}
                        {el.appointmentInfo.appointmentType !== "SE" ? (
                          <RACBadge
                            className={`${classes.w100Px} ${classes1.badgefontsize}`}
                            handleOnClick={function (event: any): void {
                              throw new Error("Function not implemented.");
                            }}
                            backgroundColor={getBatchColorByappointmentType(
                              el.appointmentInfo.appointmentType
                            )}
                            color={"white"}
                            TextValue={t(
                              el.appointmentInfo.appointmentTypeDesc
                            )}
                            OnclickNeed={false}
                          ></RACBadge>
                        ) : null}
                      </Grid>
                    </Grid>

                    <Grid
                      className={classes.mb1}
                      style={{ width: "100%", display: "flex" }}
                    >
                      <Grid style={{ width: "60%" }}>
                        {el.appointmentInfo?.appointmentType == "AD" ? (
                          <Typography className={`${classes.fs12}`}>
                            <Grid>
                              {" "}
                              {`${
                                (el?.appointmentInfo?.additionalDetails
                                  ?.customerInfo?.addressLine1 || "") +
                                "," +
                                (el?.appointmentInfo?.additionalDetails
                                  ?.customerInfo?.addressLine2 || "")
                              }`}
                            </Grid>
                            <Grid>{`${
                              (el.appointmentInfo?.additionalDetails
                                ?.customerInfo?.city || "") +
                              " " +
                              (el.appointmentInfo?.additionalDetails
                                ?.customerInfo?.state || "") +
                              " " +
                              (el?.appointmentInfo?.additionalDetails
                                ?.customerInfo?.zip || "")
                            }`}</Grid>{" "}
                          </Typography>
                        ) : (
                          <Typography className={`${classes.fs12}`}>
                            <Grid>
                              {el.appointmentInfo.appointmentType == "SE"
                                ? el.appointmentInfo.instructions || ""
                                : el.customerInfo?.address?.addressLine1 || ""}
                            </Grid>
                            <Grid>
                              {el.appointmentInfo.appointmentType == "SE"
                                ? ""
                                : `${
                                    (el.customerInfo?.address?.city || "") +
                                    (el.customerInfo?.city ? "," : "") +
                                    (el.customerInfo?.address?.state || "") +
                                    (el.customerInfo?.postalCode ? "-" : "") +
                                    (el.customerInfo?.address?.postalCode || "")
                                  }`}
                            </Grid>
                          </Typography>
                        )}
                      </Grid>
                      <Grid style={{ width: "40%", alignSelf: "end" }}>
                        <Typography className={`${classes.fs12}`}>
                          <Grid style={{ textAlign: "center" }}>
                            {el.appointmentInfo.appointmentType == "SE"
                              ? t("Store Event")
                              : t("Event")}
                          </Grid>
                        </Typography>
                      </Grid>
                    </Grid>
                  </a>
                </Grid>
              </Grid>
            );
            // }
          }
        )}
      </Grid>
    );
  };
  const expandHeaderForUpcomingEvents = () => {
    return (
      <>
        {Number(MXStoreIdentifier) == 1 ? (
          <>
            <ListItem
              className={`${customerStyleClasses.w100} ${classes.listSyle} ${classes.p0} ${classes.listTag} ${classes.formatDropdown}`}
            >
              <Grid className={`${classes.listSyle} ${classes.dropdownWidth}`}>
                <Typography>{t("Store")}</Typography>
                <RACSelect
                  name="store"
                  classes={{ formControl: classes.p3 }}
                  options={storeEventDD}
                  onChange={(e: any) => {
                    setStore(e.target.value);
                  }}
                  defaultValue={
                    store !== undefined && store !== null && store !== ""
                      ? String(store)
                      : ""
                  }
                />
              </Grid>
              <Grid className={`${classes.listSyle} ${classes.dropdownWidth}`}>
                <Typography>{t("Assignee")}</Typography>
                <RACSelect
                  name="assignee"
                  classes={{ formControl: classes.p3 }}
                  options={assigneeEventDD}
                  onChange={(e: any) => {
                     setassignee(e.target.value)
                    }}
                  loading ={isLoading}
                  defaultValue={
                     assignee !== undefined &&
                    assignee !== null &&
                    assignee !== ""
                      ? String(assignee)
                      : ""
                  }
                />
              </Grid>
            </ListItem>
          </>
        ) : (
          <></>
        )}
        <Grid
          container
          spacing={0}
          className={classes.fixedheadertableonlinePopup}
          key="uniqueonlinetransaction"
        >
          <Expandicon
            className={classes.RACexpandIconclose}
            data-bs-toggle="modal"
            style={{ cursor: "pointer", marginTop: "8px" }}
            data-bs-target="#onlineTransaction"
            onClick={() => setModals({ ...modals, expandIconClicked: false })}
            data-testid="expandonlineClose"
            key="gridcomponentIcon"
          ></Expandicon>
        </Grid>
        {bindAppointmentDetails()}
      </>
    );
  };
  //to bind the appoinment Details
  const bindAppointmentDetails = (): any => {
    const appDetails: any = modals.expandIconClicked
      ? appointmentDetailsForExpand
      : appointmentDetails;
    return appDetails?.map((el: any, index: any) => {
      const [firstEl] = el;
      let firstColumnName = "";
      const startTime: any = moment(
        firstEl.timeSlotInfo.startTime,
        "HH:mm:ss"
      ).format("hh:mm A");
      const endTime: any = moment(
        firstEl.timeSlotInfo.endTime,
        "HH:mm:ss"
      ).format("hh:mm A");

      if (firstEl.timeSlotInfo.timeSlot == "BestFit") {
        firstColumnName = t("Best Fit");
      } else if (
        firstEl.appointmentInfo &&
        firstEl.appointmentInfo.bestFit &&
        firstEl.appointmentInfo.bestFit == "1"
      ) {
        firstColumnName = t("Best Fit");
      } else {
        firstColumnName = startTime + `-` + endTime;
      }

      return (
        <>
          {/* <CardContent className={classes.cardBody}>
                        
                    </CardContent> */}
          <Grid
            style={{
              // display: 'flex',
              flexDirection: "column",
              paddingLeft: 0,
              marginBottom: 0,
              borderRadius: "0.25rem",
            }}
            className={classes1.responsiveeventcontainer}
          >
            <Grid
              className={`${classes.row} ${classes1.DAPcardwidgetmain}`}
              style={{ width: "100%", height: "80px" }}
            >
              <Grid
                className={`${classes1.eventtimecontainer}`}
                style={{
                  width: "10%",
                  justifyContent: "center",
                  height: "100px",
                }}
              >
                <Typography
                  style={{ marginTop: "18%" }}
                  className={`${classes.racstrapTablecellBgColor} ${classes1.DAPmargintopcustom}`}
                >
                  {firstColumnName}
                </Typography>
              </Grid>
              {firstEl?.timeSlotInfo?.status == "BREAK" ? (
                <LunchBreakGrid />
              ) : (
                <Grid
                  style={{ width: "88%", height: "100%" }}
                  className={classes1.eventitemcontainer}
                >
                  {/* <RACTableCell style={{width:"100%"}}> */}
                  {firstEl.storeNumber ? (
                    <Grid className={`${classes.row}`}>{eventToBind(el)}</Grid>
                  ) : !modals.expandIconClicked ? (
                    <NOUpcomingEventGrid />
                  ) : null}
                  {/* </RACTableCell>  */}
                </Grid>
              )}
              {/* {!firstEl.appointmentInfo ? <NOUpcomingEventGrid /> : null} */}
              {el && el.length > eventLenght ? (
                <Grid
                  style={{
                    width: "2%",
                    paddingLeft: "15px",
                    paddingTop: "25px",
                    height: "100%",
                  }}
                  className={classes1.DAPextraevents}
                >
                  {/* <RACTableCell style={{width:"100%"}}> */}
                  <a
                    onClick={() => {
                      setTimeSlotExceedRecordsDetails({
                        timeSlot: `${startTime + " " + endTime}`,
                        appointmentDetails: el,
                      });
                      setModals({ ...modals, timeSlotExceedModal: true });
                    }}
                    className={classes.customerRaclink}
                  >
                    +{el.length - eventLenght}
                  </a>
                  {/* </RACTableCell>  */}
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </>
      );
    });
  };
  const Okpopup = () => {
    setIsReprintCompleted(true);
    Setdisableconfirmdelivery(false);
    setopenCOprintpopup(false);
  };
  const Coprintpopupopen = () => {
    return (
      <div>
        <Grid container spacing={2} className={classes.p3}>
          <Grid item md={12} style={{ display: "flex" }}>
            <Grid>
              <Images className={classes.me2}></Images>
              <Typography variant="caption" className={classes.formLabel}>
                {t("Delivery Receipt")}
              </Typography>
            </Grid>
            <Grid>
              <RACButton
                className={classes.agrPrintDoc}
                onClick={() =>
                  printHTML(
                    document.getElementById("DeliveryReceiptrentalPrintHTML")
                  )
                }
              >
                {t("View PDF")}
              </RACButton>
            </Grid>
          </Grid>
          <Grid item md={12}>
            <PDFImage className={classes.me2}></PDFImage>
            <Typography variant="caption" className={classes.formLabel}>
              {t("Delivery Checklist")}
            </Typography>
            <RACButton
              className={classes.agrPrintDoc}
              onClick={() =>
                printHTML(document.getElementById("DeliveryChecklistrentalPdf"))
              }
            >
              {t("View PDF")}
            </RACButton>
          </Grid>
          <Grid item md={12}>
            <PDFImage className={classes.me2}></PDFImage>
            <Typography variant="caption" className={classes.formLabel}>
              {t("Delivery Addendum")}
            </Typography>
            <RACButton
              className={classes.agrPrintDoc}
              onClick={() =>
                printHTML(document.getElementById("deliveryaddendum"))
              }
            >
              {t("View PDF")}
            </RACButton>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={`${classes.pb4} ${classes.px3} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => Okpopup()}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const Ok_Popup = () => {
    setReprintPopUp(false);
    setIsReprintCompleted(true);
    setStatus({ ...status, Reprint: "complete" });
    setEnableDeliveryPopup(true);
    Setdisableconfirmdelivery(false);
    SetOpenprintpopup(false);
  };
  const PrintPopupOpen = () => {
    return (
      <div>
        <Grid container spacing={2} className={classes.p3}>
          <Grid item md={12}>
            <Images className={classes.me2}></Images>
            <Typography variant="caption" className={classes.formLabel}>
              {currentappointmentDetails &&
              (currentappointmentDetails.appointmentInfo.appointmentType ==
                "P" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "CI" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "SCI" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "SP")
                ? `${
                    currentappointmentDetails &&
                    currentappointmentDetails?.appointmentInfo?.appointmentType.includes(
                      "SCI",
                      "CI"
                    )
                      ? t("Service Pickup Receipt")
                      : t("Pickup Receipt")
                  }`
                : `${
                    currentappointmentDetails &&
                    currentappointmentDetails?.appointmentInfo?.appointmentType.includes(
                      "SCO",
                      "CO"
                    )
                      ? t("Service Delivery Receipt")
                      : t("Delivery Receipt")
                  }`}
            </Typography>
            <RACButton
              className={classes.agrPrintDoc}
              onClick={() => {
                currentappointmentDetails &&
                (currentappointmentDetails.appointmentInfo.appointmentType ==
                  "P" ||
                  currentappointmentDetails.appointmentInfo.appointmentType ==
                    "CI" ||
                  currentappointmentDetails.appointmentInfo.appointmentType ==
                    "SCI" ||
                  currentappointmentDetails.appointmentInfo.appointmentType ==
                    "SP")
                  ? printHTML(document.getElementById("pickupreciptPrintHTML"))
                  : printHTML(
                      document.getElementById("DeliveryReceiptrentalPrintHTML")
                    );
              }}
            >
              {t("View PDF")}
            </RACButton>
          </Grid>
          <Grid item md={12}>
            <PDFImage className={classes.me2}></PDFImage>
            <Typography variant="caption" className={classes.formLabel}>
              {currentappointmentDetails &&
              (currentappointmentDetails.appointmentInfo.appointmentType ==
                "P" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "CI" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "SCI" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "SP")
                ? `${
                    currentappointmentDetails &&
                    currentappointmentDetails?.appointmentInfo?.appointmentType.includes(
                      "SCI",
                      "CI"
                    )
                      ? t("Service Pickup Checklist")
                      : t("Pickup Checklist")
                  }`
                : `${
                    currentappointmentDetails &&
                    currentappointmentDetails?.appointmentInfo?.appointmentType.includes(
                      "SCO",
                      "CO"
                    )
                      ? t("Service Delivery Checklist")
                      : t("Delivery Checklist")
                  }`}
            </Typography>
            <RACButton
              className={classes.agrPrintDoc}
              onClick={() =>
                (currentappointmentDetails &&
                  currentappointmentDetails.appointmentInfo.appointmentType ==
                    "P") ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "CI" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "SCI" ||
                currentappointmentDetails.appointmentInfo.appointmentType ==
                  "SP"
                  ? printHTML(
                      document.getElementById("pickupchecklistprintHTML")
                    )
                  : printHTML(
                      document.getElementById("DeliveryChecklistrentalPdf")
                    )
              }
            >
              {t("View PDF")}
            </RACButton>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={`${classes.pb4} ${classes.px3} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => Ok_Popup()}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const switchoutokclick = () => {
    setprintswitchoutpopup(false);
  };
  const switchoutpopup = () => {
    return (
      <div>
        <Grid container spacing={2} className={classes.p3}>
          <Grid
            item
            md={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid>
              <Images className={classes.me2}></Images>
              <Typography variant="caption" className={classes.formLabel}>
                {t("Delivery Receipt")}
              </Typography>
            </Grid>
            <Grid>
              <RACButton
                className={classes.agrPrintDoc}
                onClick={() =>
                  printHTML(document.getElementById("DeliveryReceiptPrintHTML"))
                }
              >
                {t("View PDF")}
              </RACButton>
            </Grid>
          </Grid>
          <Grid
            item
            md={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid>
              {" "}
              <PDFImage className={classes.me2}></PDFImage>
              <Typography variant="caption" className={classes.formLabel}>
                {t("Delivery Checklist")}
              </Typography>
            </Grid>
            <Grid>
              <RACButton
                className={classes.agrPrintDoc}
                onClick={() =>
                  printHTML(document.getElementById("DeliveryChecklistPdf"))
                }
              >
                {t("View PDF")}
              </RACButton>
            </Grid>
          </Grid>
          <Grid
            item
            md={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid>
              <Images className={classes.me2}></Images>
              <Typography variant="caption" className={classes.formLabel}>
                {t("Pickup Receipt")}
              </Typography>
            </Grid>
            <Grid>
              <RACButton
                className={classes.agrPrintDoc}
                onClick={() =>
                  printHTML(document.getElementById("pickupreciptPrintHTML"))
                }
              >
                {t("View PDF")}
              </RACButton>
            </Grid>
          </Grid>
          <Grid
            item
            md={12}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid>
              <Images className={classes.me2}></Images>
              <Typography variant="caption" className={classes.formLabel}>
                {t("Pickup Checklist")}
              </Typography>
            </Grid>
            <Grid>
              <RACButton
                className={classes.agrPrintDoc}
                onClick={() =>
                  printHTML(document.getElementById("pickupchecklistprintHTML"))
                }
              >
                {t("View PDF")}
              </RACButton>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          md={12}
          className={`${classes.pb4} ${classes.px3} ${classes.textCenter}`}
        >
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => switchoutokclick()}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const cancelEventReasonPopUp = () => {
    return (
      <Grid style={{ width: "100%" }}>
        <Grid className={classes.row}>
          <Grid style={{ width: "100%", marginRight: "2%" }}>
            <Typography
              className={classes.RACPOPMsg}
              style={{ marginTop: "-1rem" }}
            >
              {t("Reason for Canceling the event")}
              <span style={{ color: "red" }}> *</span>
            </Typography>
            <textarea
              style={{
                marginTop: "5%",
                width: "100%",
                padding: "6px",
                paddingBottom: "31px",
                resize: "none",
                border: "1px solid #C4C4C4",
                paddingTop: "5px",
                paddingRight: "5px",
                // marginRight:"4px",
                // paddingLeft:"20px",
                borderRadius: "0.6rem",
                backgroundColor: "#fff",
                transition:
                  "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                fontSize: "14px",
                fontFamily: "OpenSans-semibold",
              }}
              // onChange={(e) => handleDropNotesInp(e)}
              rows={6}
              cols={54}
              value={cancelEventReason}
              onChange={(e) => setCancelEventReason(e.target.value)}
              className={classes.cancelReason}
            ></textarea>
          </Grid>
        </Grid>
        <Grid
          style={{ float: "right" }}
          container
          className={`${classes.explanationContent} ${classes.spacerMT4}`}
        >
          <RACButton
            className={`${classes.spacerMR2} ${classes.foc}`}
            size="small"
            variant="outlined"
            color="primary"
            isRounded={false}
            onClick={() =>
              setModals({ ...modals, cancelEventReaspnModal: false })
            }
          >
            {t("Cancel")}
          </RACButton>
          <RACButton
            disabled={cancelEventReason.length == 0 ? true : false}
            variant="contained"
            color="primary"
            isRounded={false}
            onClick={() => cancelOrCompleteStoreEvent("Cancel")}
          >
            {t("Save")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };
  const reopenPopup = () => {
    return (
      <>
        <Grid item md={12}>
          <Grid item md={12} className={classes.textCenter}>
            <Typography className={classes.RACPOPMsg}>
              {t("Are you sure you want to Reopen this event?")}
            </Typography>
          </Grid>
          <Grid
            container
            className={`${classes.justifyContentCenter} ${classes.spacerMT4}`}
          >
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.me2}
              onClick={() => {
                setModals({ ...modals, reopenConfirmModal: false });
              }}
            >
              {t("No")}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              className={`${classes.me2} ${classes.foc}`}
              onClick={() => {
                acimaEventDetails
                  ? acimaPocancelEvent("Reopen")
                  : cancelOrCompleteStoreEvent("Reopen");
              }}
            >
              {t("Yes")}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  };
  const completeAckPopup = () => {
    return (
      <>
        <Grid item md={12}>
          <Grid item md={12} className={classes.textCenter}>
            <Typography className={classes.RACPOPMsg}>
              {t("Are you sure you want to Complete this event?")}
            </Typography>
          </Grid>
          <Grid
            container
            className={`${classes.justifyContentCenter} ${classes.spacerMT4}`}
          >
            <RACButton
              variant="outlined"
              color="primary"
              className={classes.me2}
              onClick={() => {
                setModals({ ...modals, completeConfirmModal: false });
              }}
            >
              {t("No")}
            </RACButton>
            <RACButton
              variant="contained"
              color="primary"
              className={`${classes.me2} ${classes.foc}`}
              onClick={() => cancelOrCompleteStoreEvent("Complete")}
            >
              {t("Yes")}
            </RACButton>
          </Grid>
        </Grid>
      </>
    );
  };
  const DeliveryConfirmPopupOpen = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Successimage></Successimage>
          <Typography className={`${classes.popupText} ${classes.mt3}`}>
            {t("Delivery has been confirmed.")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={Delivery_confirmed_ok}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const deliveryerrorconfirm = () => {
    return (
      <div>
        <Grid item md={12} className={classes.textCenter}>
          <Alert></Alert>
          <Typography className={`${classes.popupText} ${classes.mt3}`}>
            {t("Delivery is not confirmed")}
          </Typography>
        </Grid>
        <Grid item md={12} className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setdeliveryerrorpopup(false);
            }}
          >
            {t("OK")}
          </RACButton>
        </Grid>
      </div>
    );
  };
  const Delivery_confirmed_ok = async () => {
    if (
      ["CI", "P"].includes(
        currentappointmentDetails?.appointmentInfo?.appointmentType
      )
    ) {
      history.push({
        pathname: `/agreement/info/delivery/${currentappointmentDetails?.customerInfo?.customerId}/${currentappointmentDetails?.agreement?.agreementId}`,
        search: `?apid=${currentappointmentDetails.appointmentInfo.appointmentId}`,
      });
    }
    setEnableDeliveryPopup(false);
    SetOpendeliveryconfirmpopup(false);
    setacimaEventDetails(false);
    setloader(true);
    await pageLoad(filterStateData?.date);
    setloader(false);
  };
  const deliveryDigitalSignCompletedFn = async () => {
    setdigitalSignEnable(false);
    setloader(true);
    if (agrDelStatus == "Cancelled") {
      const value = {
        agreementId: currentappointmentDetails?.agreement?.agreementId,
        isLoaner: "Y",
        loanerAction: {
          appointmentId: String(appiontmentId),
          storeNumber: window.sessionStorage.getItem("storeNumber"),
          actionName: "Reopen",
          coWorkerId: EmpolyeeId,
        },
      };
      const result = await Confirmdelivery(value);
    }
    let updatedeliverystatus: any = "";
    if (
      currentappointmentDetails &&
      currentappointmentDetails.isSwitchoutEnabled == "1"
    ) {
      updatedeliverystatus = {
        agreementId: currentappointmentDetails?.agreement?.agreementId,
        isSwitchOut: 1,
        switchInItem: Number(currentappointmentDetails.switchInItem),
        documentId: updateRecieptKey,
      };
    } else {
      updatedeliverystatus = {
        agreementId: currentappointmentDetails?.agreement?.agreementId,
        documentId: updateRecieptKey,
      };
    }
    const updatesign = {
      agreementId: currentappointmentDetails?.agreement?.agreementId,
      value: 2,
    };
    let updatestatusresponse: any = {
      updatedata: {},
    };

    let updatesignresponse: any = {
      signdata: {},
    };
    const payload: any = {
      storeNumber: currentappointmentDetails.storeNumber,
      appointmentId: currentappointmentDetails.appointmentInfo.appointmentId,
      actionName: "Complete",
      documentId: updateRecieptKey,
    };
    if (
      ["CI", "P", "S", "SCI", "SCO", "SD", "SP"].includes(
        currentappointmentDetails?.appointmentInfo?.appointmentType
      )
    ) {
      updatestatusresponse = await updateEventStatus(payload);
      const updatesign = {
        agreementId:
          currentappointmentDetails &&
          currentappointmentDetails?.agreement?.agreementId,
        value: 2,
      };
      Recieptsign(updatesign);
    } else {
      await Promise.all([
        Confirmdelivery(updatedeliverystatus),
        Recieptsign(updatesign),
      ]).then((resp) => {
        [updatestatusresponse, updatesignresponse] = resp;
      });
    }
    setloader(false);
    if (updatestatusresponse.status == 200) {
      if (currentappointmentDetails?.isSwitchoutEnabled == "1") {
        const payload: any = {
          storeException: [
            {
              identifierId: Number(
                currentappointmentDetails?.agreement?.agreementId
              ),
              identifierType: "AGREEMENT",
              storeNumber: window.sessionStorage.getItem("storeNumber"),
              exceptionTypeRefCode: "SWO",
              exceptionText: null,
            },
          ],
        };
        storeException(payload);
      }
      SetOpendeliveryconfirmpopup(true);
    } else {
      setdeliveryerrorpopup(true);
    }
  };
  const deliveryDigitalSignCanceledFn = () => {
    setdigitalSignEnable(false);
    setmanualSignatureEnabled(false);
  };
  const AcimadeliveryDigitalSignCompletedFn = async (type?: any) => {
    if (isManual && type == "Manual") {
      setmanualSignature(true);
      return;
    }
    const payLoad = {
      agreementId: "afjndl",
      isAcimaPo: "Y",
      acimaCreate: {
        actionName: "Complete",
        appointmentId: acimaEventValues.appointmentId,
        storeNumber: window.sessionStorage.getItem("storeNumber"),
      },
    };
    const resp = await Confirmdelivery(payLoad);
    console.log(`After the Confirmdelivery ==============>`, resp);
    const payLoadForm = {
      purchaseOrderNumber: String(acimaEventValues?.poNumber),
      poDetailReceivedId: acimaEventValues.itemInformation.map(
        (value: any, index: number) => {
          return value.poDetailReceivedId;
        }
      ),
      appointmentId: acimaEventValues.appointmentId,
    };
    const updateManage = await managePoAcimaFn(payLoadForm);
    console.log(`After the Confirmdelivery ==============>`, updateManage);
    if (resp?.status !== 200) {
      setacimaDeliveryDigitalsignEnbale(false);
      setdeliveryerrorpopup(true);
    }

    return true;
  };
  const acimaManualCompletFn = async () => {
    setloader(true);
    setisSignedByCustomer(false);
    const payLoad = {
      agreementId: "afjndl",
      isAcimaPo: "Y",
      acimaCreate: {
        actionName: "Complete",
        appointmentId: acimaEventValues.appointmentId,
        storeNumber: window.sessionStorage.getItem("storeNumber"),
      },
    };
    const resp = await Confirmdelivery(payLoad);
    setloader(false);
    const payLoadForm = {
      purchaseOrderNumber: String(acimaEventValues?.poNumber),
      poDetailReceivedId: acimaEventValues.itemInformation.map(
        (value: any, index: number) => {
          return value.poDetailReceivedId;
        }
      ),
      appointmentId: acimaEventValues.appointmentId,
    };
    const updateManage = await managePoAcimaFn(payLoadForm);
    if (resp?.status == 200) {
      SetOpendeliveryconfirmpopup(true);
      setacimaDeliveryDigitalsignEnbale(false);
    } else {
      setacimaDeliveryDigitalsignEnbale(false);
      setdeliveryerrorpopup(true);
    }
  };
  const AcimadeliveryDigitalSignCanceledFn = async () => {
    setacimaDeliveryDigitalsignEnbale(false);
  };
  const customerSignatureCompletedFn = async () => {
    if (isManualAgreementSigned) {
      await agreementsignedmethod();
    } else {
      setEnableDeliveryPopup(false);
      setcustomerSignEnabled(false);
    }
  };
  const customerSignatureCanceledFn = async () => {
    setEnableDeliveryPopup(false);
    setcustomerSignEnabled(false);
  };
  const documentTypeArrFn = () => {
    if (currentappointmentDetails.isSwitchoutEnabled == "1") {
      return ["SWA"];
    } else if (
      currentappointmentDetails?.agreement?.agreementTypeDesc ==
      "Rent to Rent - Loaner"
    ) {
      return ["LOAN"];
    }
    return [];
  };
  const customerSignUsignModuleFn = () => {
    if (currentappointmentDetails.isSwitchoutEnabled == "1") {
      return "switchOut";
    } else if (
      currentappointmentDetails?.agreement?.agreementTypeDesc ==
      "Rent to Rent - Loaner"
    ) {
      return "loaner";
    }
    return "rental";
  };
  const itemInformationbind = () => {
    return acimaEventValues?.itemInformation?.map((value: any, index: any) => {
      return (
        <tr key={index} style={{ width: "100%" }}>
          <td
            style={{
              padding: "10px 20px",
              fontSize: 14,
            }}
          >
            {value !== undefined &&
            value.poDetailReceivedId !== undefined &&
            value.poDetailReceivedId !== null &&
            value.poDetailReceivedId != ""
              ? value.poDetailReceivedId
              : "-"}
          </td>
          <td
            style={{
              padding: "0px 0px 0px 67px",
              fontSize: 14,
            }}
          >
            {value !== undefined && value.description !== undefined
              ? value.description
              : "-"}
          </td>
        </tr>
      );
    });
  };
  const CancelEvent = () => {
    return (
      <Grid>
        <div style={{ marginLeft: "10px" }}>
          <Typography>
            {t("Reason for cancelling the PO")}{" "}
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <textarea
            style={{ resize: "none", padding: "0px, 20px" }}
            rows={7}
            cols={60}
            onChange={(e) => {
              setcancelPOReason(e.target.value.trimStart());
            }}
          ></textarea>
        </div>
        <RACButton
          className={classes.mx1}
          style={{ marginLeft: "20rem", marginTop: "5px" }}
          onClick={() => setcancelEventPopup(false)}
          variant="outlined"
          color="secondary"
        >
          {t("Cancel")}
        </RACButton>
        <RACButton
          disabled={cancelPOReason ? false : true}
          className={classes.mx1}
          style={{ marginTop: "5px" }}
          variant="contained"
          color="primary"
          onClick={() => setcancelEventPopup(false)}
        >
          {t("Save")}
        </RACButton>
      </Grid>
    );
  };
  const acimaPoaddressFormatFnResFn = () => {
    const address =
      acimaEventValues.addressLine1 + "," + acimaEventValues?.state;
    return address;
  };
  const handleAddressClickPO = async () => {
    const addressFormatFnRes = await acimaPoaddressFormatFnResFn();
    const encodedAddress = encodeURIComponent(addressFormatFnRes);
    const googleMapsURL = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
    window.open(googleMapsURL, "_blank");
  };
  const acimaEventModal = () => {
    return (
      <>
        <Grid>
          <Grid container style={{ padding: "7px 20px" }}>
            <Grid item md={7} sm={7}>
              <Typography>{t("PO Number #")}</Typography>
              <Typography
                className={classes.customerRaclinkAcima}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  history.push({
                    pathname: `/acimapo/poreceive/details/${acimaEventValues?.poNumber}`,
                  });
                }}
              >
                {acimaEventValues?.poNumber}
              </Typography>
            </Grid>
            <Grid item md={5} sm={5}>
              <Typography>{t("Customer Name")}</Typography>
              <Typography
                className={classes.customerRaclinkAcima}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  history.push({
                    pathname: `/acimapo/poreceive/details/${acimaEventValues?.poNumber}`,
                  });
                }}
              >{`${acimaEventValues?.firstName} ${acimaEventValues?.lastName}`}</Typography>
            </Grid>
          </Grid>
          <Grid container style={{ padding: "7px 20px" }}>
            <Grid item md={7} sm={7}>
              <Typography>{t("Customer Address")}</Typography>
              <Typography
                className={classes.customerRaclinkAcima}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleAddressClickPO();
                }}
              >{`${
                (acimaEventValues?.addressLine1
                  ? acimaEventValues?.addressLine1 + ", "
                  : " ") +
                (acimaEventValues?.addressLine2
                  ? acimaEventValues?.addressLine2 + ", "
                  : " ") +
                (acimaEventValues?.city ? acimaEventValues?.city + ", " : "") +
                (acimaEventValues?.state
                  ? acimaEventValues?.state + " "
                  : " ") +
                (acimaEventValues?.zip ? acimaEventValues?.zip : "")
              }`}</Typography>
            </Grid>
            <Grid item md={5} sm={5}>
              <Typography>{t("Phone #")}</Typography>
              <Typography className={classes.customerRaclinkAcima}>
                {acimaEventValues?.phoneNumber
                  ? formatNum(acimaEventValues?.phoneNumber)
                  : "-"}
              </Typography>
            </Grid>
          </Grid>
          <Grid style={{ padding: "5px 18px 5px 18px" }}>
            <Card>
              <CardContent className={classes.racLightBlue}>
                <table>
                  <thead>
                    <th
                      style={{
                        width: "400px",
                        padding: "10px 20px",
                        fontFamily: "OpenSans-bold",
                        textAlign: "left",
                      }}
                    >
                      {t("Item")} #
                    </th>
                    <th
                      style={{
                        fontFamily: "OpenSans-bold",
                        textAlign: "left",
                        paddingLeft: "65px",
                      }}
                    >
                      {t("Description")}
                    </th>
                  </thead>
                  <tbody>{itemInformationbind()}</tbody>
                </table>
              </CardContent>
            </Card>
          </Grid>
          {acimaEventValues?.appointmentStatus !== "CMP" ? (
            <div>
              {acimaEventValues?.appointmentStatus == "CAN" ? null : (
                <Grid style={{ padding: "10px 20px" }}>
                  <Grid style={{ display: "inline-block" }}>
                    <RACToggle
                      checked={acimaManulaSign}
                      toggleColor="#0d6efd"
                      OnChange={() => {
                        setacimaManulaSign(!acimaManulaSign);
                        setisManaul(!isManual);
                      }}
                    />
                  </Grid>
                  <Typography style={{ display: "inline" }}>
                    {" "}
                    {t("Manual Signature")}
                  </Typography>
                </Grid>
              )}
              {acimaEventValues?.appointmentStatus == "CAN" ? (
                <Grid
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "10px",
                    marginLeft: "30px",
                    marginTop: "10px",
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{ alignSelf: "center", color: "black" }}
                  >
                    {t("Status")} :
                  </Typography>
                  <span
                    style={{
                      marginLeft: "10px",
                      marginTop: "2px",
                      color: "black",
                      border: "1px solid #58af52",
                      padding: "5px",
                      borderRadius: "5px",
                      fontWeight: "800",
                    }}
                  >
                    {t("Cancelled")}
                  </span>
                </Grid>
              ) : null}
              <Grid
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {acimaEventValues?.appointmentStatus == "CAN" ? (
                  <RACButton
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      setModals({ ...modals, reopenConfirmModal: true })
                    }
                    style={{ marginLeft: "40px" }}
                  >
                    {t("Reopen Event")}
                  </RACButton>
                ) : (
                  <RACButton
                    variant="outlined"
                    className={classes.unassignBtnClass}
                    onClick={() => acimaPocancelEvent("Cancel")}
                  >
                    {t("Cancel Event")}
                  </RACButton>
                )}
                {acimaEventValues?.appointmentStatus ==
                "CAN" ? null : UserStateContextRes?.includes("RPDACIMAPO") ? (
                  <RACButton
                    color="primary"
                    variant="contained"
                    className={classes.ms2}
                    onClick={() => {
                      history.push({
                        pathname: `/acimapo/poreceive/details/${acimaEventValues?.poNumber}`,
                      });
                    }}
                  >
                    {t("Reschedule")}
                  </RACButton>
                ) : null}
                {acimaEventValues?.appointmentStatus ==
                "CAN" ? null : !acimaManulaSign ? (
                  <RACButton
                    color="primary"
                    variant="contained"
                    className={classes.ms2}
                    onClick={() => {
                      AcimaDigitalSignClickFn();
                    }}
                    disabled={
                      acimaEventValues?.appointmentStatus == "CAN"
                        ? true
                        : false
                    }
                  >
                    {t("Sign and Confirm Delivery")}
                  </RACButton>
                ) : manualSignature ? (
                  <RACButton
                    color="primary"
                    variant="contained"
                    className={classes.ms2}
                    onClick={() => {
                      setisSignedByCustomer(true);
                    }}
                  >
                    {t("Confirm Delivery")}
                  </RACButton>
                ) : (
                  <RACButton
                    color="primary"
                    variant="contained"
                    className={classes.ms2}
                    onClick={() => {
                      setacimaDeliveryDigitalsignEnbale(true);
                      setisManaul(true);
                    }}
                    disabled={
                      acimaEventValues?.appointmentStatus == "CAN"
                        ? true
                        : false
                    }
                  >
                    {t("Re-print Delivery Receipt")}
                  </RACButton>
                )}
              </Grid>
            </div>
          ) : (
            <div>
              <Grid
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px",
                }}
              >
                <Typography variant="h5" style={{ alignSelf: "center" }}>
                  {t("Status")} :
                </Typography>
                <span
                  style={{
                    marginLeft: "10px",
                    color: "#58af52",
                    border: "1px solid #58af52",
                    padding: "5px",
                    borderRadius: "5px",
                    fontWeight: "800",
                  }}
                >
                  {t("Completed")}
                </span>
              </Grid>
            </div>
          )}

          <Grid style={{ padding: "25px 25px" }}>
            <span style={{ fontSize: "14px" }}>
              {t(
                "Note: Only individuals who are 18 years or older are eligilble to sign the delivery receipt"
              )}
              .
            </span>
          </Grid>
          <RACModalCard
            isOpen={cancelEventPopup}
            borderRadius="25px"
            maxWidth="sm"
            title={t("Reason for Cancelling PO")}
            onClose={() => setcancelEventPopup(false)}
            closeIcon={true}
            // eslint-disable-next-line react/no-children-prop
            children={CancelEvent()}
          />
        </Grid>
        <Grid
          item
          className={`${customerStyleClasses.floatLeft} ${customerStyleClasses.w100}`}
        >
          <Box className={customerStyleClasses.floatLeft}>
            <List
              className={`${classes.racpadTab} ${classes.py0}`}
              id="CustTab"
              role="tabList"
            >
              <ListItem
                className={
                  activetab.history
                    ? `${classes.navLinkActive} ${classes.navLinkItem}`
                    : `${classes.navLinkItem}`
                }
                id="Customerinfo-tab"
                data-testid="customerInfoTab"
                data-bs-toggle="tab"
                data-bs-target="#customerinfo"
                role="tab"
                aria-controls="Customerinfo-tab"
                aria-selected="true"
                onClick={() =>
                  setactivetab({ ...activetab, notes: false, history: true })
                }
              >
                {t("History")}
              </ListItem>
            </List>
          </Box>
        </Grid>
        <RACTable
          renderTableHead={renderAcimaAppointmentTableHistoryHeader}
          renderTableContent={renderAcimaAppointmentTableHistoryContent}
        />
      </>
    );
  };
  {
    /* Do you want to schedule popup*/
  }
  const isCustomerSignedPopup = () => {
    return (
      <Grid
        style={{ textAlign: "center", padding: "0rem 0rem 0rem 0.75rem" }}
        className={classes.p4}
      >
        <Typography
          className={classes.font24}
          variant="h6"
          style={{
            textAlign: "center",
            fontWeight: "normal",
            fontFamily: "OpenSans-semibold",
            color: "#393939",
            fontSize: "17px",
            maxWidth: "100%",
            alignContent: "center",
          }}
        >
          {t("Did the customer sign the delivery receipt?")}
        </Typography>
        <Grid style={{ textAlign: "center" }}>
          <RACButton
            color="primary"
            variant="outlined"
            size="small"
            className={
              classes.mt4 +
              " " +
              classes.p2 +
              " " +
              classes.mx2 +
              " " +
              classes.px4 +
              " " +
              classes.py2
            }
            onClick={() => {
              setisSignedByCustomer(false);
            }}
          >
            {t("No")}
          </RACButton>
          <RACButton
            variant="contained"
            color="primary"
            size="small"
            className={
              classes.mt4 +
              " " +
              classes.p2 +
              " " +
              classes.mx2 +
              " " +
              classes.px4 +
              " " +
              classes.py2
            }
            onClick={() => {
              acimaManualCompletFn();
            }}
          >
            {t("Yes")}
          </RACButton>
        </Grid>
      </Grid>
    );
  };

  
    const mandatoryPopupFn = () => {
    return (
      <Grid>

        <Grid item md={12} className={classes.textCenter}>
          {/* <Erroricon style={{ width: '30px', height: '30px', textAlign: 'center' }} /> */} 
          <Alert style={{ width: '50px', height: '50px' }}></Alert>  
          <Typography style={{ marginTop: '13px', fontSize: '19px' , fontFamily: 'OpenSans-bold'}}>{t("Alert")}</Typography>     
          <Typography style={{ marginTop: '18px', marginRight: '16px',marginLeft: '16px', fontSize: '17px' ,color: '#A0A0A0' }}>
            {t('Address and Income Proof has not been uploaded. Please upload documents to proceed further')}
          </Typography>
        </Grid>
        <Grid style={{ textAlign: 'center', marginTop: '23px' }}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setMandatoryPopup(false);
              history.push(`/customer/update/${currentappointmentDetails?.customerInfo?.customerId}/customer`)}}
            >
            {t('OK')}
          </RACButton>
        </Grid>
      </Grid >
    );
  };

  return (
    <>
      <Grid container style={{ width: "100%" }}>
        <Grid style={{ width: "97%", float: "left" }}></Grid>
        {upcomingDapParamKey == "1" &&
        (appointmentDetails.length > 0 ||
          appointmentDetailsForExpand.length > 0) ? (
          <Grid
            style={{
              width: "2%",
              float: "left",
              position: "relative",
              cursor: "pointer",
            }}
          >
            <Expandicon
              className={classes.RACexpandIconclose}
              style={{ top: "10px", cursor: "pointer" }}
              data-bs-toggle="modal"
              data-bs-target="#storeActionItem"
              onClick={() => setModals({ ...modals, expandIconClicked: true })}
              data-testid="expandSLClose"
            ></Expandicon>
          </Grid>
        ) : null}
      </Grid>
      <div className={classes.fixedheadertableonline}>
        {/* <CardContent className={classes.cardBody}> */}
        {loader ? (
          <Grid className={classes.masterLoader} style={{ zIndex: "9999" }}>
            <Grid className={classes.Loader}>
              <CircularProgress />
            </Grid>
          </Grid>
        ) : null}
        {digitalSignEnable ? (
          <DeliveryDigitalSign
            agreementId={String(
              currentappointmentDetails?.agreement?.agreementId
            )}
            deliveryDigitalSignCompletedFn={() => {
              deliveryDigitalSignCompletedFn();
            }}
            deliveryDigitalSignCanceledFn={() => {
              deliveryDigitalSignCanceledFn();
            }}
            enableDocumentsCheck = {enableDocumentsCheck}
            customerId={currentappointmentDetails?.customerInfo?.customerId}
            getCustomerVerificationDocuments={getCustomerVerificationDocuments}            
          />
        ) : null}
        {acimaDeliveryDigitalsignEnbale ? (
          <AcimaDeliveryDigitalSign
            deliveryDigitalSignCompletedFn={AcimadeliveryDigitalSignCompletedFn}
            deliveryDigitalSignCanceledFn={AcimadeliveryDigitalSignCanceledFn}
            customerDetails={{
              itemDetails: acimaEventValues.itemInformation,
              customerName:
                acimaEventValues?.firstName + " " + acimaEventValues?.lastName,
              addressLine1: acimaEventValues?.addressLine1,
              addressLine2: acimaEventValues?.addressLine2,
              city: acimaEventValues?.city,
              zip: acimaEventValues?.zip,
              phoneNumber: acimaEventValues?.phoneNumber,
              appointmentId: acimaEventValues?.appointmentId,
              date: acimaEventValues?.appiontmnetDate,
              time: acimaEventValues?.appiontmnetTime,
              emailId: acimaEventValues?.emailId,
              state: acimaEventValues?.state,
            }}
            isManual={isManual}
            openPop={SetOpendeliveryconfirmpopup}
            poNumber={acimaEventValues?.poNumber}
          />
        ) : null}
        {customerSignEnabled ? (
          <CustomerSignature
            customerSignUsingField="dashBoard"
            customerSignUsingModule={customerSignUsignModuleFn()}
            documentGenerateCompleted={true}
            identifier={Number(agreementValues?.agreementId)}
            customersArr={customersArray}
            manualSignOptions={maualSignReasonDrpdwnVal}
            documentTypeArr={documentTypeArrFn()}
            customerSignatureCompletedFn={() => customerSignatureCompletedFn()}
            customerSignatureCanceledFn={() => customerSignatureCanceledFn()}
          />
        ) : null}
        {openFieldVisitModal && (
          <FieldVisitModal
            customerId={currentappointmentDetails?.customerInfo?.customerId}
            onClose={setOpenFieldVisitModal}
            onSaveSuccess={handleFieldVisitSaveSuccess}
            onError={handleFieldVisitError}
            isFVSRetentionEnabled={isFVSRetentionEnabled}
          />
        )}
        <RACModalCard
          isOpen={CheckforSign}
          borderRadius="15px"
          maxWidth="xs"
          closeIcon={true}
          onClose={() => SetCheckforSign(false)}
          // eslint-disable-next-line react/no-children-prop
          children={SignCheckPopup()}
        />
        <RACModalCard
          isOpen={Opendeliveryconfirmpopup}
          onClose={() => {
            Delivery_confirmed_ok();
          }}
          maxWidth="xs"
          borderRadius="20px"
          closeIcon={false}
          // eslint-disable-next-line react/no-children-prop
          children={DeliveryConfirmPopupOpen()}
        />
        <RACModalCard
          isOpen={OpenSurveySaveSuccessPopup}
          onClose={() => {
            SurveySavedOk();
          }}
          maxWidth="xs"
          borderRadius="20px"
          closeIcon={true}
          // eslint-disable-next-line react/no-children-prop
          children={SurveySavedSuccess()}
        />
        {/* Error Message Popup */}
        <RACModalCard
          isOpen={errorMessagePopupOpen}
          closeIcon={false}
          maxWidth="xs"
          borderRadius="20px"
          // eslint-disable-next-line react/no-children-prop
          children={errorMessagePopup()}
        />
        <RACModalCard
          isOpen={surveyError}
          closeIcon={true}
          maxWidth="sm"
          borderRadius="20px"
          onClose={() => setSurveyError(false)}
          // eslint-disable-next-line react/no-children-prop
          children={SurveryErrorPopup()}
        />
        <RACModalCard
          isOpen={referralLinkError}
          closeIcon={true}
          maxWidth="sm"
          borderRadius="20px"
          onClose={() => setReferralLinkError(false)}
        >
          <Grid style={{ padding: "20px", textAlign: "center" }}>
            <Typography style={{ marginBottom: "20px", fontFamily: "OpenSans-semibold" }}>
              {referralLinkErrorMessage || t('An error occurred while sending the referral link.')}
            </Typography>
            <RACButton
              variant="contained"
              color="primary"
              onClick={() => setReferralLinkError(false)}
            >
              {t('OK')}
            </RACButton>
          </Grid>
        </RACModalCard>
        <RACModalCard
          isOpen={deliveryerrorpopup}
          closeIcon={true}
          maxWidth="sm"
          borderRadius="20px"
          onClose={() => setdeliveryerrorpopup(false)}
          // eslint-disable-next-line react/no-children-prop
          children={deliveryerrorconfirm()}
        />
        {/*  */}
        <RACModalCard
          isOpen={openCOprintpopup}
          onClose={() => setopenCOprintpopup(false)}
          maxWidth="xs"
          closeIcon={true}
          borderRadius="20px"
          title={t("Re-Print Delivery Receipt")}
          // eslint-disable-next-line react/no-children-prop
          children={Coprintpopupopen()}
        />
        <RACModalCard
          isOpen={modals.expandIconClicked}
          maxWidth="xl"
          borderRadius="20px"
          dialogOptionalProps={{
            open: modals.expandIconClicked,
            disableBackdropClick: false,
          }}
          onClose={() => setModals({ ...modals, expandIconClicked: false })}
          // eslint-disable-next-line react/no-children-prop
          children={expandHeaderForUpcomingEvents()}
          // onClose={() => closeClick()}
          closeIcon={false}
          title={t("Upcoming Events")}
          TitleClassName="title"
          className="title "
          key="modalKeycard"
          data-testid="titleCard"
        />
        <RACModalCard
          borderRadius="20px"
          isOpen={modals.apiErrorInfoMsg}
          maxWidth="xs"
          closeIcon={true}
          onClose={() => setModals({ ...modals, apiErrorInfoMsg: false })}
          // eslint-disable-next-line react/no-children-prop
          children={UpdateInfoMsgPopup()}
          title=""
        />
        <RACModalCard
          isOpen={modals.timeSlotExceedModal}
          onClose={() => setModals({ ...modals, timeSlotExceedModal: false })}
          maxWidth="md"
          closeIcon={true}
          borderRadius="20px"
          title={timeSlotExceedRecordsDetails.timeSlot}
          // eslint-disable-next-line react/no-children-prop
          children={TimeSlotExceedRecord()}
        />
        {/*Print switchout receipt popup starts here*/}
        <RACModalCard
          isOpen={printswitchoutpopup}
          closeIcon={true}
          maxWidth="xs"
          borderRadius="20px"
          onClose={() => setprintswitchoutpopup(false)}
          // eslint-disable-next-line react/no-children-prop
          children={switchoutpopup()}
        />
        {/* Re-Print Delivery Reciept */}
        <RACModalCard
          isOpen={Openprintpopup}
          onClose={() => SetOpenprintpopup(false)}
          maxWidth="xs"
          closeIcon={true}
          borderRadius="20px"
          title={
            currentappointmentDetails &&
            (currentappointmentDetails.appointmentInfo.appointmentType == "P" ||
              currentappointmentDetails.appointmentInfo.appointmentType ==
                "CI" ||
              currentappointmentDetails.appointmentInfo.appointmentType ==
                "SCI" ||
              currentappointmentDetails.appointmentInfo.appointmentType == "SP")
              ? `${
                  currentappointmentDetails &&
                  currentappointmentDetails?.appointmentInfo?.appointmentType.includes(
                    "SCI",
                    "CI"
                  )
                    ? t("Service Pickup Receipt")
                    : t("Pickup Receipt")
                }`
              : `${
                  currentappointmentDetails &&
                  currentappointmentDetails?.appointmentInfo?.appointmentType.includes(
                    "SCO",
                    "CO"
                  )
                    ? t("Service Delivery Receipt")
                    : t("Delivery Receipt")
                }`
          }
          // eslint-disable-next-line react/no-children-prop
          children={PrintPopupOpen()}
        />
        <RACModalCard
          isOpen={modals.cancelEventReaspnModal}
          onClose={() =>
            setModals({ ...modals, cancelEventReaspnModal: false })
          }
          maxWidth="xs"
          closeIcon={true}
          borderRadius="20px"
          title={t("Canceling the event")}
          // eslint-disable-next-line react/no-children-prop
          children={cancelEventReasonPopUp()}
        />
        <RACModalCard
          isOpen={isSignedByCustomer}
          closeIcon={false}
          maxWidth="xs"
          borderRadius={"10px"}
          onClose={() => {
            setisSignedByCustomer(false);
          }}
        >
          {isCustomerSignedPopup()}
        </RACModalCard>
        <RACModalCard
          isOpen={modals.reopenConfirmModal}
          maxWidth="xs"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => setModals({ ...modals, reopenConfirmModal: false })}
          // eslint-disable-next-line react/no-children-prop
          children={reopenPopup()}
        />
        <RACModalCard
          isOpen={modals.completeConfirmModal}
          maxWidth="xs"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => setModals({ ...modals, completeConfirmModal: false })}
          // eslint-disable-next-line react/no-children-prop
          children={completeAckPopup()}
        />

        <RACModalCard
          isOpen={enableDeliveryPopup}
          maxWidth="md"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => setEnableDeliveryPopup(false)}
          // eslint-disable-next-line react/no-children-prop
          // children={DeliveryPopup}
          title={t("Event Details")}
          TitleVariantClassName={classes.popUpFont}
        >
          {DeliveryPopup()}
        </RACModalCard>
        <RACModalCard
          isOpen={enableStorePickupPopup}
          maxWidth="md"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => setEnableStorePickupPopup(false)}
          // eslint-disable-next-line react/no-children-prop
          children={StorePickupEventPopup()}
          title={t("Store Pick-Up Details")}
          TitleVariantClassName={classes.popUpFont}
        />
        <RACModalCard
          isOpen={enableFieldVisitPopup}
          maxWidth="md"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => setEnableFieldVisitPopup(false)}
          // eslint-disable-next-line react/no-children-prop
          children={FieldVisitEventPopup()}
          title={t("Field Visit Details")}
          TitleVariantClassName={classes.popUpFont}
        />
        <RACModalCard
          isOpen={toShowCustomerSurveyForm}
          maxWidth="md"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => cancelSurvey()}
          title={t("Customer Survey")}
          TitleVariantClassName={classes.popUpFont}
        >
          {CustomerSurveyPopup()}
        </RACModalCard>

        <RACModalCard
          isOpen={toShowAddressSurveyForm}
          maxWidth="md"
          closeIcon={true}
          borderRadius="20px"
          onClose={() => cancelAddressSurvey()}
          // eslint-disable-next-line react/no-children-prop
          children={AddressVerificationSurveyPopup()}
          title={t("Address Verification Survey")}
          TitleVariantClassName={classes.popUpFont}
        />
        {/* <HandleDeliveryModalCard /> */}
        <HandleRePrintModalCard />
        <RACModalCard
          isOpen={modals.storeEventDetailModal}
          maxWidth="md"
          borderRadius="20px"
          title={t("Store Event Details")}
          closeIcon={true}
          onClose={() => setModals({ ...modals, storeEventDetailModal: false })}
          // eslint-disable-next-line react/no-children-prop
          children={StoreEventModal()}
        />
        <RACModalCard
          isOpen={acimaEventDetails}
          maxWidth="md"
          borderRadius="20px"
          title={t("Event Details")}
          closeIcon={true}
          onClose={() => setacimaEventDetails(false)}
          // eslint-disable-next-line react/no-children-prop
          children={acimaEventModal()}
        />
        <RACModalCard
          borderRadius="20px"
          isOpen={mandatoryPopup}
          maxWidth="xs"
          closeIcon={true}
          onClose={() => setMandatoryPopup(false)}
          // eslint-disable-next-line react/no-children-prop
          children={mandatoryPopupFn()}
        />
        {showSendReferralLinkPopup && (() => {
          console.log("Calender - Passing customerPromotionProfile to SendReferralLink:", customerPromotionProfile);
          return (
            <SendReferralLink
              customerId={currentappointmentDetails?.customerInfo?.customerId || ''}
              customerName={
                (currentappointmentDetails?.customerInfo?.firstName || '') +
                ' ' +
                (currentappointmentDetails?.customerInfo?.lastName || '')
              }
              customerFirstName={currentappointmentDetails?.customerInfo?.firstName || ''}
              customerLastName={currentappointmentDetails?.customerInfo?.lastName || ''}
              email={currentappointmentDetails?.customerInfo?.emailAddress || ''}
              phoneNumber={currentappointmentDetails?.customerInfo?.phoneNumber || ''}
              globalCustomerId={currentappointmentDetails?.customerInfo?.globalCustomerId || ''}
              state={currentappointmentDetails?.customerInfo?.address?.state || ''}
              customerPromotionProfile={customerPromotionProfile || []}
              sendReferralLinkCompletedFn={() => {
                setShowSendReferralLinkPopup(false);
              }}
              sendReferralLinkCancelledFn={() => {
                setShowSendReferralLinkPopup(false);
              }}
              onSuccess={() => {
                setReferralLinkSentSuccess(true);
              }}
              onError={(message: string) => {
                setReferralLinkErrorMessage(message);
                setReferralLinkError(true);
              }}
              setCustomerPromotionProfile={setCustomerPromotionProfile}
            />
          );
        })()}
        {/* <Grid className={classes.filterContainer}>
                    <Grid className={classes.leftContainer}>
                        <Grid className={classes.filterContainerItems}>
                            <RACDatePicker
                                classes={{ input: `${classes.p3} ${classes.ml24} ${classes.h65}` }}
                                label={""}
                                onChange={(val: any) => onChangeDate(val)}
                                value={filterStateData && filterStateData?.date ? filterStateData?.date : ''} />
                            <RACButton
                                type="button"
                                className={`${classes.ms2} ${classes.todayButton}`}
                                color="primary"
                                disabled={handleDisable()}
                                style={{ height: '30px', marginTop: '15px' }}
                                variant="contained"
                                onClick={() => {
                                    setFilterStateData({ ...filterStateData, date: moment().format('YYYY-MM-DD') });
                                    setIsStoreClosed(false)
                                    onChangeDate(moment().format('YYYY-MM-DD'))
                                }
                                }
                            >
                                Today
                            </RACButton>
                        </Grid>
                        {createEvent ? (
                            <Grid className={classes.filterContainerItems}>
                                <Typography style={{ textAlign: 'center', width: '200px', marginTop: '20px', height: '25px' }}>
                                    Type of Events
                                </Typography>
                                <RACSelect
                                    name="typeofEvent"
                                    classes={{ formControl: classes.p3 }}
                                    options={eventDD}
                                    onChange={(e: any) => handleEventDropdown(e)}
                                    defaultValue={
                                        eventType !== undefined &&
                                            eventType !== null &&
                                            eventType !== ''
                                            ? String(eventType)
                                            : 'ALL'
                                    }
                                />
                            </Grid>) : null}
                    </Grid>
                    <Grid className={classes.rightContainer}>
                        <Grid className={`${classes.inputGroup} ${classes.searchBar}`}>
                            <RACButton
                                className={`${classes.px0} ${classes.searchBarIcon}`}
                                onClick={() => {
                                    console.log('need to incfsdlude the filter');
                                }}
                            >
                                <SearchbarIcon></SearchbarIcon>
                            </RACButton>
                            <RACTextbox
                                value={documentName}
                                placeHolder="Search"
                                OnChange={(e) => {
                                    setDocumentName(e.target.value);
                                }}
                                className={`${classes.searchSpacing}`}
                                onKeyPress={handleKeypress}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid style={{ width: '30%', float: 'right', display: 'flex' }}>
                    <Grid
                        style={{
                            borderLeft: '3px solid #2E31BE',
                            backgroundColor: 'aliceblue',
                            width: '23%',
                            marginRight: '2%'
                        }}
                    >
                        <Typography style={{ color: '#2E31BE', marginLeft: '10px', paddingLeft: '10px' }}>
                            Upcoming
                        </Typography>
                    </Grid>
                    <Grid
                        style={{
                            borderLeft: '3px solid red',
                            backgroundColor: '#fcf2f2',
                            width: '23%',
                            marginRight: '2%'
                        }}
                    >
                        <Typography style={{ color: 'red', marginLeft: '10px', paddingLeft: '10px' }}>
                            Due
                        </Typography>
                    </Grid>
                    <Grid
                        style={{
                            borderLeft: '3px solid green',
                            backgroundColor: '#ebfdeb',
                            width: '23%',
                            marginRight: '2%'
                        }}
                    >
                        <Typography style={{ color: 'green', marginLeft: '10px', paddingLeft: '10px' }}>
                            Completed
                        </Typography>
                    </Grid>
                    <Grid
                        style={{
                            borderLeft: '3px solid #5a5a5a',
                            backgroundColor: '#f6f6f6',
                            width: '23%',
                            marginRight: '2%'
                        }}
                    >
                        <Typography style={{ color: '#5a5a5a', marginLeft: '10px', paddingLeft: '10px' }}>
                            Cancelled
                        </Typography>
                    </Grid>

                </Grid> */}
        {appointmentDetails &&
        appointmentDetails.length > 0 &&
        !isStoreClosed ? (
          // <Grid style={{width:"100%"}}>
          bindAppointmentDetails()
        ) : modals.initialLoad ? ( // </Grid>
          <div className={classes.Norecords}>
            <CircularProgress
              style={{ marginTop: "30px", marginBottom: "73px" }}
            />
          </div>
        ) : upcomingDapParamKey == "0" && !isStoreClosed ? (
          storeClosedGrid(
            t("We are currently working on this feature and will launch soon!")
          )
        ) : appointmentDetails.length == 0 && !isStoreClosed ? (
          storeClosedGrid(t("No Upcoming Events Found"))
        ) : null}
        {isStoreClosed ? storeClosedGrid(t("Store Closed")) : null}
        <ReprintReceiptCode data={memoizedPropData} />
      </div>
    </>
  );
}

export default Calender;
